//https://cdn.haworth.com/haworth-configurator/0.0.33/assets/w-cf/scripts/core.min.js
'use strict';
var egr,
  __extends =
    (this && this.__extends) ||
    (function () {
      var n = function (e, t) {
        return (n =
          Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array &&
            function (e, t) {
              e.__proto__ = t;
            }) ||
          function (e, t) {
            for (var i in t) t.hasOwnProperty(i) && (e[i] = t[i]);
          })(e, t);
      };
      return function (e, t) {
        function i() {
          this.constructor = e;
        }
        n(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((i.prototype = t.prototype), new i()));
      };
    })(),
  __awaiter =
    (this && this.__awaiter) ||
    function (e, s, a, l) {
      return new (a = a || Promise)(function (i, t) {
        function n(e) {
          try {
            o(l.next(e));
          } catch (e) {
            t(e);
          }
        }
        function r(e) {
          try {
            o(l.throw(e));
          } catch (e) {
            t(e);
          }
        }
        function o(e) {
          var t;
          e.done
            ? i(e.value)
            : ((t = e.value) instanceof a
                ? t
                : new a(function (e) {
                    e(t);
                  })
              ).then(n, r);
        }
        o((l = l.apply(e, s || [])).next());
      });
    },
  __generator =
    (this && this.__generator) ||
    function (i, n) {
      var r,
        o,
        s,
        a = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1];
          },
          trys: [],
          ops: [],
        },
        e = { next: t(0), throw: t(1), return: t(2) };
      return (
        'function' == typeof Symbol &&
          (e[Symbol.iterator] = function () {
            return this;
          }),
        e
      );
      function t(t) {
        return function (e) {
          return (function (t) {
            if (r) throw new TypeError('Generator is already executing.');
            for (; a; )
              try {
                if (
                  ((r = 1),
                  o &&
                    (s =
                      2 & t[0]
                        ? o.return
                        : t[0]
                        ? o.throw || ((s = o.return) && s.call(o), 0)
                        : o.next) &&
                    !(s = s.call(o, t[1])).done)
                )
                  return s;
                switch (((o = 0), s && (t = [2 & t[0], s.value]), t[0])) {
                  case 0:
                  case 1:
                    s = t;
                    break;
                  case 4:
                    return a.label++, { value: t[1], done: !1 };
                  case 5:
                    a.label++, (o = t[1]), (t = [0]);
                    continue;
                  case 7:
                    (t = a.ops.pop()), a.trys.pop();
                    continue;
                  default:
                    if (
                      !(s = 0 < (s = a.trys).length && s[s.length - 1]) &&
                      (6 === t[0] || 2 === t[0])
                    ) {
                      a = 0;
                      continue;
                    }
                    if (3 === t[0] && (!s || (t[1] > s[0] && t[1] < s[3]))) {
                      a.label = t[1];
                      break;
                    }
                    if (6 === t[0] && a.label < s[1]) {
                      (a.label = s[1]), (s = t);
                      break;
                    }
                    if (s && a.label < s[2]) {
                      (a.label = s[2]), a.ops.push(t);
                      break;
                    }
                    s[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                t = n.call(i, a);
              } catch (e) {
                (t = [6, e]), (o = 0);
              } finally {
                r = s = 0;
              }
            if (5 & t[0]) throw t[1];
            return { value: t[0] ? t[1] : void 0, done: !0 };
          })([t, e]);
        };
      }
    };
!(function (e) {
  var b;
  (function (w) {
    var e =
      (Object.defineProperty(C.prototype, 'appData', {
        get: function () {
          return this.mAppData;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (C.prototype.clear = function () {
        try {
          this.eventBeforeClear.trigger(),
            this.mApp.model.beginModification(),
            this.mApp.commands.clearHistory(),
            this.mApp.viewer.resetViews(),
            this.mApp.model.clear(),
            this.mAppData.clear();
          for (var e = 0, t = this.mApp.modules; e < t.length; e++) {
            var i = t[e];
            try {
              i.clearDocumentData();
            } catch (e) {
              b.utils.Log.error('failed to clear module ' + i.moduleId, e);
            }
          }
        } finally {
          this.mApp.model.endModification(), this.eventAfterClear.trigger();
        }
      }),
      (C.prototype.loadFromZip = function (e, t) {
        var i = this,
          n = new b.utils.Progress(null != t ? t.onProgress : null, !0);
        n.startSection(5);
        var r = {};
        return (
          Object.assign(r, t),
          (r.onProgress = function (e) {
            n.setProgress(e);
          }),
          w.io.ZipDocumentContainer.LoadContainer(e).then(function (e) {
            return n.startSection(95), i.loadFromContainer(e, r);
          })
        );
      }),
      (C.prototype.loadFromContainer = function (p, d) {
        return __awaiter(this, void 0, void 0, function () {
          var t, i, n, r, o, s, a, l, u, h, m, c;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == p) throw new Error(b.utils.ERR_INVALID_ARGUMENT);
                return (t = !0), [4, this.mLoadSaveLock.acquireLock()];
              case 1:
                (i = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 15, 16]),
                  this.eventBeforeLoad.trigger(),
                  this.mApp.model.beginModification(),
                  this.mApp.viewer.beginDisableRendering(),
                  (n = new b.utils.Progress(
                    null != d ? d.onProgress : null,
                    !0
                  )),
                  (r = function (e) {
                    n.setProgress(e);
                  }),
                  n.startSection(5),
                  [4, this.readDocumentFromContainer(p)]
                );
              case 3:
                return (
                  (o = e.sent()),
                  this.validateDocument(o),
                  (s = new b.utils.GroupedMap()).deserialize(o.appData),
                  null == d || null == d.onValidateDocument
                    ? [3, 5]
                    : [4, d.onValidateDocument(o.header, s)]
                );
              case 4:
                e.sent(), (e.label = 5);
              case 5:
                this.clear(),
                  (a = new f(p, o.model)),
                  (this.mAppData = s),
                  n.startSection(20),
                  (l = 0),
                  (u = this.mApp.modules),
                  (e.label = 6);
              case 6:
                if (!(l < u.length)) return [3, 11];
                (h = u[l]), (e.label = 7);
              case 7:
                return (
                  e.trys.push([7, 9, , 10]),
                  (m = null) != o.moduleData && (m = o.moduleData[h.moduleId]),
                  [4, h.loadDocumentData(a, m)]
                );
              case 8:
                return e.sent(), [3, 10];
              case 9:
                if ((c = e.sent()) instanceof w.io.AbortError) throw c;
                return (
                  b.utils.Log.error('failed to load module ' + h.moduleId, c),
                  [3, 10]
                );
              case 10:
                return l++, [3, 6];
              case 11:
                return (
                  this.mApp.viewer.deserialize(o.viewer),
                  n.startSection(30),
                  [
                    4,
                    this.mApp.model.geometries._readGeometriesFromContainer(
                      o.model.geometries,
                      p,
                      r
                    ),
                  ]
                );
              case 12:
                return (
                  e.sent(),
                  n.startSection(30),
                  [
                    4,
                    this.mApp.model.materials._readTexturesFromContainer(
                      o.model.textures,
                      p,
                      r
                    ),
                  ]
                );
              case 13:
                return (
                  e.sent(),
                  n.startSection(15),
                  this.mApp.model._deserialize(o.model, a),
                  [4, a.waitForPendingTasks()]
                );
              case 14:
                return (
                  e.sent(),
                  this.mApp.model.geometries.missingGeometries.forEach(
                    function (e) {
                      b.utils.Log.warn('Missing geometry: ' + e);
                    }
                  ),
                  this.mApp.model.materials.missingResourceTextures.forEach(
                    function (e) {
                      b.utils.Log.warn('Missing texture: ' + e);
                    }
                  ),
                  (t = !1),
                  [3, 16]
                );
              case 15:
                return (
                  t && this.clear(),
                  this.mApp.viewer.endDisableRendering(),
                  this.mApp.model.endModification(),
                  this.eventAfterLoad.trigger(t),
                  this.mApp.viewer.requestRenderFrame(),
                  i.unlock(),
                  [7]
                );
              case 16:
                return [2];
            }
          });
        });
      }),
      (C.prototype.saveToZip = function (e) {
        var t = new b.utils.Progress(null != e ? e.onProgress : null, !0);
        t.startSection(30);
        var i = {};
        Object.assign(i, e),
          (i.onProgress = function (e) {
            t.setProgress(e);
          });
        var n = w.io.ZipDocumentContainer.NewContainer();
        return (
          null != e &&
            null != e.compressionLevel &&
            (n.compressionLevel = e.compressionLevel),
          this.saveToContainer(n, i).then(function () {
            return t.startSection(70), n.generateZip(i.onProgress);
          })
        );
      }),
      (C.prototype.saveToContainer = function (y, A) {
        return __awaiter(this, void 0, void 0, function () {
          var t, i, n, r, o, s, a, l, u, h, m, c, p, d, f, g, v;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == y) throw new Error(b.utils.ERR_INVALID_ARGUMENT);
                return (t = !0), [4, this.mLoadSaveLock.acquireLock()];
              case 1:
                (i = e.sent()), (e.label = 2);
              case 2:
                if (
                  (e.trys.push([2, , 16, 17]),
                  this.eventBeforeSave.trigger(),
                  (n = {
                    embedGeometries: !1,
                    embedTextures: !1,
                    embedAppModuleResources: !0,
                  }),
                  null != A && Object.assign(n, A),
                  (r = 0),
                  n.embedGeometries && r++,
                  n.embedTextures && r++,
                  (s = 100 - (o = 30 * r)),
                  (a = function (e) {
                    l.setProgress(e);
                  }),
                  (l = new b.utils.Progress(n.onProgress, !0)).startSection(
                    0.1 * s
                  ),
                  (u = new P(y)),
                  ((h = {}).header = this.saveHeader()),
                  null != (m = this.mAppData.serialize()) && (h.appData = m),
                  l.startSection(0.4 * s),
                  !(0 < this.mApp.modules.length))
                )
                  return [3, 9];
                (h.moduleData = {}),
                  (c = this.mApp.modules.length),
                  (p = 0),
                  (e.label = 3);
              case 3:
                if (!(p < c)) return [3, 9];
                (d = this.mApp.modules[p]), (e.label = 4);
              case 4:
                return e.trys.push([4, 6, , 7]), [4, d.saveDocumentData(u, n)];
              case 5:
                return (
                  null != (f = e.sent()) && (h.moduleData[d.moduleId] = f),
                  [3, 7]
                );
              case 6:
                if ((g = e.sent()) instanceof w.io.AbortError) throw g;
                return (
                  b.utils.Log.error('failed to save module ' + d.moduleId, g),
                  [3, 7]
                );
              case 7:
                l.setProgress(((p + 1) / c) * 100), (e.label = 8);
              case 8:
                return ++p, [3, 3];
              case 9:
                return (
                  l.startSection(0.4 * s),
                  (h.viewer = this.mApp.viewer.serialize()),
                  (h.model = this.mApp.model._serialize(u)),
                  l.startSection(0.1 * s),
                  [4, u.waitForPendingTasks()]
                );
              case 10:
                return (
                  e.sent(),
                  (v = w.io.stringifyToJson(h)),
                  [4, y.addFile(v, C.DOCUMENT_FILE)]
                );
              case 11:
                return (
                  e.sent(),
                  n.embedGeometries
                    ? (l.startSection(o / r),
                      [
                        4,
                        this.mApp.model.geometries._addGeometriesToContainer(
                          u.geometryIds,
                          y,
                          a
                        ),
                      ])
                    : [3, 13]
                );
              case 12:
                e.sent(), (e.label = 13);
              case 13:
                return n.embedTextures
                  ? (l.startSection(o / r),
                    [
                      4,
                      this.mApp.model.materials._addTexturesToContainer(
                        u.textureIds,
                        y,
                        a
                      ),
                    ])
                  : [3, 15];
              case 14:
                e.sent(), (e.label = 15);
              case 15:
                return (t = !1), [3, 17];
              case 16:
                return this.eventAfterSave.trigger(t), i.unlock(), [7];
              case 17:
                return [2];
            }
          });
        });
      }),
      (C.prototype.saveHeader = function () {
        var e = {};
        return (
          (e.majorVer = w.io.DOCUMENT_MAJOR_VERSION),
          (e.minorVer = w.io.DOCUMENT_MINOR_VERSION),
          '' !== this.mApp.applicationName &&
            (e.appName = this.mApp.applicationName),
          '' !== this.mApp.applicationVersion &&
            (e.appVer = this.mApp.applicationVersion),
          e
        );
      }),
      (C.prototype.readDocumentFromContainer = function (e) {
        return null == e
          ? Promise.reject(new Error(b.utils.ERR_INVALID_ARGUMENT))
          : e
              .getFile(C.DOCUMENT_FILE, !1)
              .then(function (e) {
                return JSON.parse(e);
              })
              .catch(function (e) {
                return Promise.reject(
                  new Error('Failed to read ' + C.DOCUMENT_FILE + ': ' + e)
                );
              });
      }),
      (C.prototype.validateDocument = function (e) {
        if (
          null == e ||
          null == e.header ||
          null == e.model ||
          null == e.model.elements
        )
          throw new Error('invalid file');
        var t = e.header.majorVer;
        if (null == t) throw new Error('unknown file version');
        if (t > w.io.DOCUMENT_MAJOR_VERSION)
          throw new Error('unsupported file version: ' + t);
      }),
      (C.DOCUMENT_FILE = 'document.json'),
      C);
    function C(e) {
      (this.eventBeforeClear = new b.utils.ListenableEvent(this)),
        (this.eventAfterClear = new b.utils.ListenableEvent(this)),
        (this.eventBeforeLoad = new b.utils.ListenableEvent(this)),
        (this.eventAfterLoad = new b.utils.ListenableEvent(this)),
        (this.eventBeforeSave = new b.utils.ListenableEvent(this)),
        (this.eventAfterSave = new b.utils.ListenableEvent(this)),
        (this.mApp = e),
        (this.mAppData = new b.utils.GroupedMap()),
        (this.mLoadSaveLock = new b.utils.async.Lock());
    }
    w.AppDocument = e;
    var t =
      (Object.defineProperty(i.prototype, 'customState', {
        get: function () {
          return this.mCustomState;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.registerPendingTask = function (e) {
        null != e && this.mPendingTasks.push(e);
      }),
      (i.prototype.waitForPendingTasks = function () {
        return __awaiter(this, void 0, void 0, function () {
          var t, i, n, r;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                (t = 0), (i = this.mPendingTasks), (e.label = 1);
              case 1:
                if (!(t < i.length)) return [3, 6];
                (n = i[t]), (e.label = 2);
              case 2:
                return e.trys.push([2, 4, , 5]), [4, n()];
              case 3:
                return e.sent(), [3, 5];
              case 4:
                return (
                  (r = e.sent()), console.log('Pending task failed.', r), [3, 5]
                );
              case 5:
                return t++, [3, 1];
              case 6:
                return [2];
            }
          });
        });
      }),
      i);
    function i(e) {
      (this.mContainer = e),
        (this.mPendingTasks = new Array()),
        (this.mCustomState = new b.utils.GroupedMap());
    }
    var n,
      f =
        (__extends(r, (n = t)),
        (r.prototype.getGeometryIdByIndex = function (e) {
          return null != this.mIOModel ? this.mIOModel.geometries[e].id : null;
        }),
        (r.prototype.getMaterialIdByIndex = function (e) {
          return null != this.mIOModel ? this.mIOModel.materials[e].id : null;
        }),
        (r.prototype.getTextureIdByIndex = function (e) {
          return null != this.mIOModel ? this.mIOModel.textures[e].id : null;
        }),
        (r.prototype.getLayerNameByIndex = function (e) {
          return null != this.mIOModel ? this.mIOModel.layers[e].name : null;
        }),
        (r.prototype.getResource = function (e, t) {
          return this.mContainer.getFile('resources/' + e, t);
        }),
        (r.prototype.getFile = function (e, t) {
          return this.mContainer.getFile(e, t);
        }),
        (r.prototype.listFiles = function (e) {
          return this.mContainer.listFiles(e);
        }),
        r);
    function r(e, t) {
      var i = n.call(this, e) || this;
      return (i.mIOModel = t), i;
    }
    var o,
      P =
        (__extends(s, (o = t)),
        Object.defineProperty(s.prototype, 'geometryIds', {
          get: function () {
            return this.mGeometryIds;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(s.prototype, 'materialIds', {
          get: function () {
            return this.mMaterialIds;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(s.prototype, 'textureIds', {
          get: function () {
            return this.mTextureIds;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(s.prototype, 'layerNames', {
          get: function () {
            return this.mLayerNames;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (s.prototype.addGeometry = function (e) {
          return this.addGraphic(e, this.mGeometryIds, this.mGeometryIdsMap);
        }),
        (s.prototype.addMaterial = function (e) {
          return this.addGraphic(e, this.mMaterialIds, this.mMaterialIdsMap);
        }),
        (s.prototype.addTexture = function (e) {
          return this.addGraphic(e, this.mTextureIds, this.mTextureIdsMap);
        }),
        (s.prototype.addLayer = function (e) {
          return this.addGraphic(e, this.mLayerNames, this.mLayerNamesMap);
        }),
        (s.prototype.addResource = function (e, t, i) {
          return this.mContainer.addFile(e, 'resources/' + t, i);
        }),
        (s.prototype.addResourceFromUrl = function (e, t, i, n) {
          return this.mContainer.addFileFromUrl(e, 'resources/' + t, i, n);
        }),
        (s.prototype.addResourceFromCache = function (e, t) {
          return this.mContainer.addFileFromCache('resources/' + e, t);
        }),
        (s.prototype.addGraphic = function (e, t, i) {
          var n = i.get(e);
          return null != n || ((n = t.push(e) - 1), i.set(e, n)), n;
        }),
        s);
    function s(e) {
      var t = o.call(this, e) || this;
      return (
        (t.mGeometryIds = new Array()),
        (t.mGeometryIdsMap = new Map()),
        (t.mMaterialIds = new Array()),
        (t.mMaterialIdsMap = new Map()),
        (t.mTextureIds = new Array()),
        (t.mTextureIdsMap = new Map()),
        (t.mLayerNames = new Array()),
        (t.mLayerNamesMap = new Map()),
        t
      );
    }
  })((b = e.wcf || (e.wcf = {})).core || (b.core = {}));
})((egr = egr || {})),
  (function (e) {
    var t, i, n;
    function r() {}
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (r.prototype.clearDocumentData = function () {}),
      (r.prototype.loadDocumentData = function (e, t) {
        return Promise.resolve();
      }),
      (r.prototype.saveDocumentData = function (e, t) {
        return Promise.resolve(null);
      }),
      (n = r),
      (i.AppModule = n);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n;
    function r() {
      (this.eventSnappingChanged = new t.utils.ListenableEvent(this)),
        (this.mSnapping = {
          gridEnabled: !0,
          gridDynamic: !0,
          gridSize: new BABYLON.Vector3(0.1, 0.1, 0.1),
          boundingBoxEnabled: !0,
        });
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      Object.defineProperty(r.prototype, 'snapping', {
        get: function () {
          return this.mSnapping;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.setSnapping = function (e) {
        Object.assign(this.mSnapping, e), this.eventSnappingChanged.trigger();
      }),
      (n = r),
      (i.AppSettings = n);
  })((egr = egr || {})),
  (function (e) {
    var s;
    (function (i) {
      function e() {
        (this.hardwareAntialiasing = !1),
          (this.preserveDrawingBuffer = !1),
          (this.stencilBuffer = !1),
          (this.adaptToDeviceRatio = !0),
          (this.maximumDeviceRatio = 2),
          (this.autoResizeViewer = !0),
          (this.audioEngine = !1),
          (this.disableWebGL2Support = !0);
      }
      i.AppInitOptions = e;
      var t = function () {
        (this.mainColorBright = '#95C11F'),
          (this.mainColorDark = '#7da50b'),
          (this.fontFamily = "'Open Sans', Tahoma, 'Geneva', sans-serif");
      };
      i.AppTheme = t;
      var n = function () {
        (this.showPropertyEditor = null),
          (this.beginAsyncOperation = null),
          (this.endAsyncOperation = null);
      };
      i.AppCallbacks = n;
      var r =
        (Object.defineProperty(o.prototype, 'version', {
          get: function () {
            return '6.0.0';
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'buildInfo', {
          get: function () {
            return 'b26703d1 HEAD 2020-05-27';
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'engine', {
          get: function () {
            return this.mEngine;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'scene', {
          get: function () {
            return this.mScene;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'i18n', {
          get: function () {
            return this.mI18n;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'settings', {
          get: function () {
            return this.mSettings;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'document', {
          get: function () {
            return this.mDocument;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'viewer', {
          get: function () {
            return this.mViewer;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'model', {
          get: function () {
            return this.mModelManager;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'commands', {
          get: function () {
            return this.mCommandManager;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'tools', {
          get: function () {
            return this.mToolManager;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'rendering', {
          get: function () {
            return this.mRenderingManager;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'theme', {
          get: function () {
            return this.mTheme;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'appCallbacks', {
          get: function () {
            return this.mAppCallbacks;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'modules', {
          get: function () {
            return this.mModulesArray;
          },
          enumerable: !1,
          configurable: !0,
        }),
        Object.defineProperty(o.prototype, 'initOptions', {
          get: function () {
            return this.mInitOptions;
          },
          enumerable: !1,
          configurable: !0,
        }),
        (o.prototype.initialize = function (e, t) {
          return (
            null != e &&
            null != t &&
            ((this.mInitOptions = t),
            (this.mViewer = new i.view.Viewer(this, e)),
            (this.mEngine = new BABYLON.Engine(
              this.mViewer.canvas,
              t.hardwareAntialiasing,
              {
                antialias: t.hardwareAntialiasing,
                preserveDrawingBuffer: t.preserveDrawingBuffer,
                limitDeviceRatio: t.maximumDeviceRatio,
                stencil: t.stencilBuffer,
                audioEngine: t.audioEngine,
                autoEnableWebVR: !1,
                disableWebGL2Support: t.disableWebGL2Support,
              },
              t.adaptToDeviceRatio
            )),
            (this.mEngine.enableOfflineSupport = !1),
            null != this.mEngine.getCaps().parallelShaderCompile &&
              ((this.mEngine.getCaps().parallelShaderCompile = void 0),
              s.utils.Log.info('Disabled parallel shader compilation.')),
            (this.mScene = new BABYLON.Scene(this.mEngine)),
            (this.mModelManager = new i.mdl.ModelManager(this)),
            !!this.mViewer.initialize(t.autoResizeViewer) &&
              (this.mEngine.runRenderLoop(this.processMainLoop.bind(this)), !0))
          );
        }),
        (o.prototype.dispose = function () {
          null == this.mEngine ||
            this.mScene.isDisposed ||
            (this.mViewer.dispose(), this.mEngine.dispose());
        }),
        (o.prototype.registerModule = function (e) {
          null == e ||
            this.mModules.has(e.moduleId) ||
            (this.mModules.set(e.moduleId, e), this.mModulesArray.push(e));
        }),
        (o.prototype.getModule = function (e) {
          if (s.utils.string.isNullOrEmpty(e)) return null;
          var t = this.mModules.get(e);
          return void 0 !== t ? t : null;
        }),
        (o.prototype.processMainLoop = function () {
          this.mToolManager._updateActiveToolState(),
            this.eventAnimate.trigger(),
            this.mViewer._renderFrame(!1);
        }),
        o);
      function o() {
        (this.eventAnimate = new s.utils.ListenableEvent(this)),
          (this.mTheme = new t()),
          (this.mAppCallbacks = new n()),
          (this.mModules = new Map()),
          (this.mModulesArray = new Array()),
          (this.dataPath = '/data/'),
          (this.applicationName = ''),
          (this.applicationVersion = ''),
          (this.mI18n = new i.I18nManager()),
          (this.mSettings = new i.AppSettings()),
          (this.mToolManager = new i.tool.ToolManager()),
          (this.mCommandManager = new i.cmd.CommandManager()),
          (this.mDocument = new i.AppDocument(this)),
          (this.mRenderingManager = new i.rendering.RenderingManager(this));
      }
      i.Application = r;
    })((s = e.wcf || (e.wcf = {})).core || (s.core = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, i, n;
    function r() {
      (this.eventLocaleChanged = new t.utils.ListenableEvent(this)),
        (this.eventLanguageChanged = new t.utils.ListenableEvent(this)),
        (this.eventLengthUnitChanged = new t.utils.ListenableEvent(this)),
        (this.mLocale = 'en-US'),
        (this.mLanguage = 'en'),
        (this.mLengthUnit = 4);
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      Object.defineProperty(r.prototype, 'locale', {
        get: function () {
          return this.mLocale;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'language', {
        get: function () {
          return this.mLanguage;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'lengthUnit', {
        get: function () {
          return this.mLengthUnit;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.setLocale = function (e) {
        if (t.utils.string.isNullOrEmpty(e))
          throw new Error(t.utils.ERR_INVALID_ARGUMENT);
        (this.mLocale = e), this.eventLocaleChanged.trigger();
      }),
      (r.prototype.setLanguage = function (e) {
        if (t.utils.string.isNullOrEmpty(e))
          throw new Error(t.utils.ERR_INVALID_ARGUMENT);
        (this.mLanguage = e), this.eventLanguageChanged.trigger();
      }),
      (r.prototype.setLengthUnit = function (e) {
        null != e &&
          ((this.mLengthUnit = e), this.eventLengthUnitChanged.trigger());
      }),
      (n = r),
      (i.I18nManager = n);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    function o(e) {
      this.mApp = e;
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.cmd || (i.cmd = {})),
      (o.prototype.isAvailable = function () {
        return !0;
      }),
      (o.prototype.isUndoable = function () {
        return !1;
      }),
      (o.prototype.isSignificant = function () {
        return !1;
      }),
      (o.prototype.undo = function () {
        return Promise.reject(new Error(t.utils.ERR_NOT_IMPLEMENTED));
      }),
      (o.prototype.redo = function () {
        return Promise.reject(new Error(t.utils.ERR_NOT_IMPLEMENTED));
      }),
      (o.prototype.dispose = function () {}),
      (r = o),
      (n.AbstractCommand = r);
  })((egr = egr || {})),
  (function (e) {
    var o, t;
    (o = e.wcf || (e.wcf = {})),
      (function (e) {
        var t =
          (Object.defineProperty(i.prototype, 'canUndo', {
            get: function () {
              return 0 < this.mUndoSections.length;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(i.prototype, 'canRedo', {
            get: function () {
              return 0 < this.mRedoSections.length;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(i.prototype, 'recordingEnabled', {
            get: function () {
              return this.mRecordingEnabled;
            },
            set: function (e) {
              this.mRecordingEnabled = e;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(i.prototype, 'historySize', {
            get: function () {
              return this.mHistorySize;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (i.prototype.executeCommand = function (t, e) {
            var i = this;
            return (
              void 0 === e && (e = null),
              null == t
                ? Promise.reject(new Error(o.utils.ERR_INVALID_ARGUMENT))
                : t.isAvailable()
                ? t
                    .execute(e)
                    .then(function (e) {
                      return e && i.addCommandToHistory(t), e;
                    })
                    .catch(function (e) {
                      return (
                        o.utils.Log.error('Failed to execute command.', e), !1
                      );
                    })
                : Promise.reject(new Error(o.utils.ERR_NOT_AVAILABLE))
            );
          }),
          (i.prototype.beginUndoSection = function () {
            0 === this.mSectionDepth && (this.mCurrentSection = new n()),
              this.mSectionDepth++;
          }),
          (i.prototype.endUndoSection = function () {
            this.mSectionDepth--,
              this.mSectionDepth <= 0 &&
                (null == this.mCurrentSection ||
                  this.mCurrentSection.isEmpty ||
                  (this.mUndoSections.push(this.mCurrentSection),
                  this.internal_clearHistory(!1, !0, !1),
                  this.ensureHistorySize(),
                  this.eventHistoryChanged.trigger()),
                (this.mCurrentSection = null),
                (this.mSectionDepth = 0));
          }),
          (i.prototype.undo = function () {
            var e = this;
            if (!this.canUndo || null != this.mCurrentSection)
              return o.utils.rejectError(o.utils.ERR_INVALID_STATE);
            var t = this.mUndoSections.pop();
            return t.undo().then(function () {
              e.mRedoSections.push(t), e.eventHistoryChanged.trigger();
            });
          }),
          (i.prototype.redo = function () {
            var e = this;
            if (!this.canRedo || null != this.mCurrentSection)
              return o.utils.rejectError(o.utils.ERR_INVALID_STATE);
            var t = this.mRedoSections.pop();
            return t.redo().then(function () {
              e.mUndoSections.push(t), e.eventHistoryChanged.trigger();
            });
          }),
          (i.prototype.clearHistory = function () {
            this.internal_clearHistory(!0, !0, !0),
              this.eventHistoryChanged.trigger();
          }),
          (i.prototype.setHistorySize = function (e) {
            null == e ||
              e <= 0 ||
              e === this.mHistorySize ||
              ((this.mHistorySize = e),
              this.ensureHistorySize(),
              this.eventHistoryChanged.trigger());
          }),
          (i.prototype.addCommandToHistory = function (e) {
            this.mRecordingEnabled &&
              (e.isUndoable()
                ? null == this.mCurrentSection
                  ? (this.beginUndoSection(),
                    this.mCurrentSection.addCommand(e),
                    this.endUndoSection())
                  : this.mCurrentSection.addCommand(e)
                : e.isSignificant() && this.clearHistory());
          }),
          (i.prototype.internal_clearHistory = function (e, t, i) {
            if (e) {
              for (var n = 0, r = this.mUndoSections; n < r.length; n++)
                r[n].dispose();
              this.mUndoSections = new Array();
            }
            if (t) {
              for (var o = 0, s = this.mRedoSections; o < s.length; o++)
                s[o].dispose();
              this.mRedoSections = new Array();
            }
            i && null != this.mCurrentSection && this.mCurrentSection.clear();
          }),
          (i.prototype.ensureHistorySize = function () {
            if (!(this.mUndoSections.length <= this.mHistorySize)) {
              for (
                var e = this.mUndoSections.length - this.mHistorySize, t = 0;
                t < e;
                ++t
              )
                this.mUndoSections[t].dispose();
              this.mUndoSections.splice(0, e);
            }
          }),
          i);
        function i() {
          (this.eventHistoryChanged = new o.utils.ListenableEvent(this)),
            (this.mCurrentSection = null),
            (this.mSectionDepth = 0),
            (this.mUndoSections = new Array()),
            (this.mRedoSections = new Array()),
            (this.mRecordingEnabled = !1),
            (this.mHistorySize = 10);
        }
        e.CommandManager = t;
        var n =
          (Object.defineProperty(r.prototype, 'isEmpty', {
            get: function () {
              return 0 === this.mCommands.length;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (r.prototype.dispose = function () {
            this.disposeCommands(), (this.mCommands = void 0);
          }),
          (r.prototype.clear = function () {
            this.disposeCommands(), (this.mCommands = new Array());
          }),
          (r.prototype.addCommand = function (e) {
            this.mCommands.push(e);
          }),
          (r.prototype.undo = function () {
            return o.utils.async
              .forEach(this.mCommands, !0, function (e, t) {
                return t
                  .undo()
                  .then(function () {
                    return !0;
                  })
                  .catch(function (e) {
                    return o.utils.Log.error('Failed to undo command.', e), !0;
                  });
              })
              .then(function () {});
          }),
          (r.prototype.redo = function () {
            return o.utils.async
              .forEach(this.mCommands, !1, function (e, t) {
                return t
                  .redo()
                  .then(function () {
                    return !0;
                  })
                  .catch(function (e) {
                    return o.utils.Log.error('Failed to redo command.', e), !0;
                  });
              })
              .then(function () {});
          }),
          (r.prototype.disposeCommands = function () {
            for (var e = 0, t = this.mCommands; e < t.length; e++)
              t[e].dispose();
          }),
          r);
        function r() {
          this.mCommands = new Array();
        }
      })((t = o.core || (o.core = {})).cmd || (t.cmd = {}));
  })((egr = egr || {})),
  (function (e) {
    var h, t;
    (h = e.wcf || (e.wcf = {})),
      (function (e) {
        var s,
          t =
            ((s = e.AbstractCommand),
            __extends(i, s),
            (i.prototype.isAvailable = function () {
              return null != this.mElements;
            }),
            (i.prototype.isUndoable = function () {
              return !0;
            }),
            (i.prototype.dispose = function () {
              if (this.mElementsDeleted)
                for (var e = 0, t = this.mElements; e < t.length; e++)
                  t[e].dispose();
              this.mElements = void 0;
            }),
            (i.prototype.deleteElements = function () {
              var e = this.mApp.model;
              try {
                e.beginSelectionChange();
                for (var t = 0; t < this.mElements.length; ++t)
                  this.mElementUndoData[t] = this.mElements[t].saveUndoData(0);
                for (t = 0; t < this.mElementParents.length; ++t)
                  null != (i = this.mElementParents[t]) && i.beginChange();
                for (t = 0; t < this.mElements.length; ++t)
                  e.removeElement(this.mElements[t], !0, !1);
              } finally {
                for (var i, t = 0; t < this.mElementParents.length; ++t)
                  null != (i = this.mElementParents[t]) && i.endChange();
                e.endSelectionChange();
              }
              (this.mElementsDeleted = !0),
                this.mApp.viewer.requestRenderFrame();
            }),
            (i.prototype.insertElements = function (e) {
              var t = this.mApp.model;
              try {
                for (var i = 0; i < this.mElementParents.length; ++i)
                  null != (n = this.mElementParents[i]) && n.beginChange();
                for (i = 0; i < this.mElements.length; ++i)
                  t.addElement(this.mElements[i], this.mNodeParents[i], e);
                for (i = 0; i < this.mElements.length; ++i)
                  null != this.mElementUndoData[i] &&
                    this.mElements[i].loadUndoData(0, this.mElementUndoData[i]);
              } finally {
                for (var n, i = 0; i < this.mElementParents.length; ++i)
                  null != (n = this.mElementParents[i]) && n.endChange();
              }
              (this.mElementsDeleted = !1),
                this.mApp.viewer.requestRenderFrame();
            }),
            i);
        function i(e, t) {
          var i = s.call(this, e) || this;
          (i.mElements = h.utils.array.clone(t)),
            (i.mElementsDeleted = !1),
            (i.mElementParents = new Array()),
            (i.mElementUndoData = new Array()),
            (i.mNodeParents = new Array());
          for (var n = 0, r = i.mElements; n < r.length; n++) {
            var o = r[n];
            i.mElementParents.push(o.getParentElement()),
              i.mElementUndoData.push(null),
              i.mNodeParents.push(o.node.parent);
          }
          return i;
        }
        e.AbstractInsertDeleteElements = t;
        var n,
          r =
            (__extends(o, (n = t)),
            (o.prototype.execute = function (e) {
              return this.redo().then(function () {
                return !0;
              });
            }),
            (o.prototype.undo = function () {
              return this.insertElements(!0), Promise.resolve();
            }),
            (o.prototype.redo = function () {
              return this.deleteElements(), Promise.resolve();
            }),
            o);
        function o(e, t) {
          return n.call(this, e, t) || this;
        }
        e.DeleteElements = r;
        var a,
          l =
            (__extends(u, (a = t)),
            (u.prototype.execute = function (e) {
              return this.insertElements(!1), Promise.resolve(!0);
            }),
            (u.prototype.undo = function () {
              return this.deleteElements(), Promise.resolve();
            }),
            (u.prototype.redo = function () {
              return this.insertElements(!0), Promise.resolve();
            }),
            u);
        function u(e, t) {
          return a.call(this, e, t) || this;
        }
        e.InsertElements = l;
      })((t = h.core || (h.core = {})).cmd || (t.cmd = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r, o;
    function s(e, t, i) {
      var n = r.call(this, e) || this;
      return (
        (n.mProperty = t),
        (n.mRedoValue = i),
        (n.mUndoValue = null),
        (n.mLastResult = 0),
        n
      );
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.cmd || (i.cmd = {})),
      (r = n.AbstractCommand),
      __extends(s, r),
      Object.defineProperty(s.prototype, 'lastResult', {
        get: function () {
          return this.mLastResult;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (s.prototype.isAvailable = function () {
        return null != this.mProperty;
      }),
      (s.prototype.isUndoable = function () {
        return this.mProperty.undoable;
      }),
      (s.prototype.execute = function (e) {
        var t = this,
          i = this.mProperty.getValue();
        return (
          (this.mUndoValue = null == i ? null : i.value),
          this.setPropertyValue(this.mRedoValue).then(function (e) {
            return 0 !== (t.mLastResult = e);
          })
        );
      }),
      (s.prototype.undo = function () {
        return this.setPropertyValue(this.mUndoValue).then(function () {});
      }),
      (s.prototype.redo = function () {
        return this.setPropertyValue(this.mRedoValue).then(function () {});
      }),
      (s.prototype.setPropertyValue = function (e) {
        var t = this;
        return (
          this.mProperty.provider.beginPropertyChange(),
          this.mProperty
            .setValue(e)
            .then(function (e) {
              return (
                t.mProperty.provider.endPropertyChange(),
                0 !== e && t.mApp.viewer.requestRenderFrame(),
                e
              );
            })
            .catch(function (e) {
              return (
                t.mProperty.provider.endPropertyChange(), Promise.reject(e)
              );
            })
        );
      }),
      (o = s),
      (n.SetPropertyValue = o);
  })((egr = egr || {})),
  (function (e) {
    var h, t, i, m, n;
    function r(e, t) {
      var i = m.call(this, e) || this;
      (i.mElements = h.utils.array.clone(t)),
        (i.mRedoData = null),
        (i.mRedoTransforms = null),
        (i.mUndoTransforms = new Array()),
        (i.mUndoData = new Array()),
        (i.mInvWorldMatrix = new Array()),
        (i.mInvWorldRotation = new Array()),
        i.mApp.model.eventBeginTransformElements.trigger();
      for (var n = 0, r = i.mElements; n < r.length; n++) {
        var o,
          s,
          a,
          l,
          u = r[n];
        i.mUndoTransforms.push(u.transform.clone()),
          i.mUndoData.push(u.saveUndoData(1)),
          null != u.node.parent
            ? ((o = u.node.parent.getWorldMatrix().clone().invert()),
              i.mInvWorldMatrix.push(o),
              (s = BABYLON.Vector3.Zero()),
              (a = new BABYLON.Quaternion()),
              (l = new BABYLON.Vector3(1, 1, 1)),
              o.decompose(l, a, s),
              i.mInvWorldRotation.push(a))
            : (i.mInvWorldMatrix.push(null), i.mInvWorldRotation.push(null));
      }
      return i;
    }
    (h = e.wcf || (e.wcf = {})),
      (t = h.core || (h.core = {})),
      (i = t.cmd || (t.cmd = {})),
      (m = i.AbstractCommand),
      __extends(r, m),
      (r.prototype.isAvailable = function () {
        return null != this.mElements;
      }),
      (r.prototype.isUndoable = function () {
        return !0;
      }),
      (r.prototype.execute = function (e) {
        this.mApp.model.beginModification();
        for (var t = 0, i = this.mElements; t < i.length; t++)
          i[t].notifyChange(8);
        this.mApp.model.eventEndTransformElements.trigger(),
          this.mApp.model.endModification(),
          (this.mRedoTransforms = new Array(this.mElements.length)),
          (this.mRedoData = new Array());
        for (var n = 0; n < this.mElements.length; ++n)
          (this.mRedoTransforms[n] = this.mElements[n].transform.clone()),
            (this.mRedoData[n] = this.mElements[n].saveUndoData(1));
        return Promise.resolve(!0);
      }),
      (r.prototype.undo = function () {
        return (
          this.mApp.model.eventBeginTransformElements.trigger(),
          this.undoTransforms(),
          Promise.resolve()
        );
      }),
      (r.prototype.redo = function () {
        if (
          (this.mApp.model.beginModification(),
          this.mApp.model.eventBeginTransformElements.trigger(),
          null != this.mRedoData && null != this.mRedoTransforms)
        ) {
          for (var e = 0; e < this.mElements.length; ++e)
            this.mElements[e].setTransform(this.mRedoTransforms[e]);
          for (e = 0; e < this.mElements.length; ++e)
            null != this.mRedoData[e] &&
              this.mElements[e].loadUndoData(1, this.mRedoData[e]);
        }
        return (
          this.mApp.model.eventEndTransformElements.trigger(),
          this.mApp.model.endModification(),
          this.mApp.viewer.requestRenderFrame(),
          Promise.resolve()
        );
      }),
      (r.prototype.translate = function (e) {
        for (var t = 0; t < this.mElements.length; ++t) {
          var i = e;
          null != this.mInvWorldMatrix[t] &&
            (i = BABYLON.Vector3.TransformNormal(i, this.mInvWorldMatrix[t])),
            this.mElements[t].node.position.addInPlace(i),
            h.utils.mesh.updateFrozenWorldMatrix(this.mElements[t].node);
        }
        this.mApp.rendering.notifyModelInteraction(),
          this.mApp.viewer.requestRenderFrame();
      }),
      (r.prototype.rotate = function (e, t, i) {
        void 0 === i && (i = null);
        for (var n = 0; n < this.mElements.length; ++n) {
          var r,
            o,
            s = i,
            a = e;
          t ||
            null == this.mInvWorldMatrix[n] ||
            ((r = h.utils.math.quaternionToAxisAngle(e)),
            (o = new BABYLON.Vector3(r.x, r.y, r.z)),
            h.utils.math.rotateVector3ToRef(o, this.mInvWorldRotation[n], o),
            (a = BABYLON.Quaternion.RotationAxis(o, r.w)),
            null != s &&
              (s = BABYLON.Vector3.TransformCoordinates(
                s,
                this.mInvWorldMatrix[n]
              ))),
            h.utils.mesh.rotate(this.mElements[n].node, a, t, s),
            h.utils.mesh.updateFrozenWorldMatrix(this.mElements[n].node);
        }
        this.mApp.rendering.notifyModelInteraction(),
          this.mApp.viewer.requestRenderFrame();
      }),
      (r.prototype.undoTransforms = function () {
        this.mApp.model.beginModification();
        for (var e = 0; e < this.mElements.length; ++e)
          this.mElements[e].setTransform(this.mUndoTransforms[e]);
        for (e = 0; e < this.mElements.length; ++e)
          null != this.mUndoData[e] &&
            this.mElements[e].loadUndoData(1, this.mUndoData[e]);
        this.mApp.model.eventEndTransformElements.trigger(),
          this.mApp.model.endModification(),
          this.mApp.viewer.requestRenderFrame();
      }),
      (n = r),
      (i.TransformElements = n);
  })((egr = egr || {})),
  (function (e) {
    var i, t, n;
    (i = e.wcf || (e.wcf = {})),
      (t = i.core || (i.core = {})),
      ((n = t.io || (t.io = {})).stringifyToJson = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return JSON.stringify(e, function (e, t) {
          return i.utils.number.isNumber(t) ? i.utils.math.roundTo(t, 6) : t;
        });
      }),
      (n.serializeQuaternion = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return [e.x, e.y, e.z, e.w];
      }),
      (n.deserializeQuaternion = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return new BABYLON.Quaternion(e[0], e[1], e[2], e[3]);
      }),
      (n.serializeVector2 = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return [e.x, e.y];
      }),
      (n.deserializeVector2 = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return new BABYLON.Vector2(e[0], e[1]);
      }),
      (n.serializeVector3 = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return [e.x, e.y, e.z];
      }),
      (n.deserializeVector3 = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return new BABYLON.Vector3(e[0], e[1], e[2]);
      }),
      (n.serializeColor3 = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return [e.r, e.g, e.b];
      }),
      (n.deserializeColor3 = function (e) {
        if (null == e) throw new Error(i.utils.ERR_INVALID_ARGUMENT);
        return new BABYLON.Color3(e[0], e[1], e[2]);
      });
  })((egr = egr || {})),
  (function (e) {
    var a, t;
    (a = e.wcf || (e.wcf = {})),
      (function (e) {
        (e.DOCUMENT_MAJOR_VERSION = 2), (e.DOCUMENT_MINOR_VERSION = 0);
        var i,
          t = ((i = a.utils.CustomError), __extends(n, i), n);
        function n(e) {
          var t = i.call(this, e) || this;
          return Object.setPrototypeOf(t, n.prototype), t;
        }
        e.FileNotFoundError = t;
        var r,
          o = ((r = a.utils.CustomError), __extends(s, r), s);
        function s(e) {
          var t = r.call(this, e) || this;
          return Object.setPrototypeOf(t, s.prototype), t;
        }
        e.AbortError = o;
      })((t = a.core || (a.core = {})).io || (t.io = {}));
  })((egr = egr || {})),
  (function (e) {
    var s, t, n, i;
    function r(e, t) {
      void 0 === t && (t = 4), (this.mZip = e), (this.compressionLevel = t);
    }
    (s = e.wcf || (e.wcf = {})),
      (t = s.core || (s.core = {})),
      (n = t.io || (t.io = {})),
      (r.NewContainer = function () {
        return new r(new JSZip());
      }),
      (r.LoadContainer = function (e) {
        var t = new JSZip();
        return t
          .loadAsync(e)
          .then(function () {
            return new r(t);
          })
          .catch(function (e) {
            return Promise.reject(new Error('Failed to read zip: ' + e));
          });
      }),
      (r.prototype.addFile = function (e, t, i, n) {
        if (null == e || s.utils.string.isNullOrEmpty(t))
          return Promise.reject(new Error(s.utils.ERR_INVALID_ARGUMENT));
        var r = {};
        return (
          (r.binary = !s.utils.string.isString(e)),
          null != i && !1 === i && (r.compression = 'STORE'),
          this.mZip.file(t, e, r),
          Promise.resolve()
        );
      }),
      (r.prototype.addFileFromUrl = function (e, t, i, n, r) {
        var o = this;
        return s.utils.string.isNullOrEmpty(e) ||
          s.utils.string.isNullOrEmpty(t)
          ? Promise.reject(new Error(s.utils.ERR_INVALID_ARGUMENT))
          : s.utils.async
              .ajax('GET', e, null, {
                responseType: i ? 'arraybuffer' : 'text',
              })
              .then(function (e) {
                return o.addFile(e, t, n);
              });
      }),
      (r.prototype.addFileFromCache = function (e, t) {
        return Promise.resolve(!1);
      }),
      (r.prototype.getFile = function (e, t) {
        var i = this.mZip.file(e);
        return null == i
          ? Promise.reject(new n.FileNotFoundError(e))
          : i.async(t ? 'arraybuffer' : 'string');
      }),
      (r.prototype.listFiles = function (e) {
        var t = null != e ? this.mZip.folder(e) : this.mZip;
        if (null == t) return Promise.reject(new n.FileNotFoundError(e));
        var i = new Array();
        return (
          t.forEach(function (e, t) {
            t.dir || i.push(e);
          }),
          Promise.resolve(i)
        );
      }),
      (r.prototype.generateZip = function (t) {
        return this.mZip.generateAsync(
          {
            compression: 0 === this.compressionLevel ? 'STORE' : 'DEFLATE',
            compressionOptions: { level: this.compressionLevel },
            streamFiles: !0,
            type: 'arraybuffer',
          },
          function (e) {
            null != t && t(e.percent);
          }
        );
      }),
      (i = r),
      (n.ZipDocumentContainer = i);
  })((egr = egr || {})),
  (function (e) {
    var l, s;
    (l = e.wcf || (e.wcf = {})),
      (function (h) {
        var e, t, i;
        ((e = h.ElementChangedFlags || (h.ElementChangedFlags = {}))[
          (e.None = 0)
        ] = 'None'),
          (e[(e.Added = 1)] = 'Added'),
          (e[(e.Removed = 2)] = 'Removed'),
          (e[(e.BoundingBox = 4)] = 'BoundingBox'),
          (e[(e.Transformation = 8)] = 'Transformation'),
          (e[(e.Properties = 16)] = 'Properties'),
          (e[(e.PropertyValues = 32)] = 'PropertyValues'),
          ((t = h.ElementCategory || (h.ElementCategory = {}))[(t.None = 0)] =
            'None'),
          (t[(t.Interior = 1)] = 'Interior'),
          (t[(t.FloorPlan = 2)] = 'FloorPlan'),
          (t[(t.Wall = 3)] = 'Wall'),
          (t[(t.WallOpening = 4)] = 'WallOpening'),
          (t[(t.WallAddition = 5)] = 'WallAddition'),
          ((i = h.UndoOperation || (h.UndoOperation = {}))[(i.Delete = 0)] =
            'Delete'),
          (i[(i.Transform = 1)] = 'Transform');
        var n =
          (Object.defineProperty(m.prototype, 'node', {
            get: function () {
              return this.mNode;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'isSelected', {
            get: function () {
              return this.mIsSelected;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'isDisposed', {
            get: function () {
              return void 0 === this.mNode;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'transform', {
            get: function () {
              return this.updateCachedTransforms(), this.mTransform;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'transformInverted', {
            get: function () {
              return this.updateCachedTransforms(), this.mTransformInverted;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'worldTransform', {
            get: function () {
              return this.updateCachedTransforms(), this.mWorldTransform;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'worldTransformInverted', {
            get: function () {
              return (
                this.updateCachedTransforms(), this.mWorldTransformInverted
              );
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'boundingBox', {
            get: function () {
              return (
                null == this.mBoundingBox &&
                  (this.mBoundingBox =
                    null == this.mNode
                      ? new h.BoundingBox()
                      : h.BoundingBox.FromNode(this.mNode)),
                this.mBoundingBox
              );
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'boundingBoxVisible', {
            get: function () {
              return (
                null == this.mBoundingBoxVisible &&
                  (this.mBoundingBoxVisible =
                    null == this.mNode
                      ? new h.BoundingBox()
                      : h.BoundingBox.FromNode(this.mNode, !0)),
                this.mBoundingBoxVisible
              );
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(m.prototype, 'category', {
            get: function () {
              return 0;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (m.prototype.dispose = function () {
            null != this.mNode &&
              (this.mNode.dispose(),
              h.NodeUserData.SetData(
                this.mNode,
                m.NODEDATA_SCENEELEMENT,
                null
              )),
              (this.mNode = void 0),
              (this.mBoundingBox = null),
              (this.mBoundingBoxVisible = null),
              (this.mIsInScene = !1);
          }),
          (m.prototype.canSelect = function () {
            return null != this.mNode && this.isInScene();
          }),
          (m.prototype.canSelectSubElement = function () {
            return !1;
          }),
          (m.prototype.canTranslate = function () {
            return !0;
          }),
          (m.prototype.canRotate = function () {
            return !0;
          }),
          (m.prototype.canDelete = function () {
            return !0;
          }),
          (m.prototype.setTransform = function (e) {
            if (null == this.mNode) return !1;
            var t = l.utils.mesh.setLocalMatrix(this.mNode, e);
            return t && this.updateTransformation(), t;
          }),
          (m.prototype.updateTransformation = function (e) {
            void 0 === e && (e = !0),
              null != this.mNode &&
                (l.utils.mesh.updateFrozenWorldMatrix(this.mNode, e),
                this.notifyChange(8));
          }),
          (m.prototype.getMainElement = function () {
            return this;
          }),
          (m.prototype.getParentElement = function () {
            return null != this.mNode && null != this.mNode.parent
              ? m.FromNode(this.mNode.parent, !0)
              : null;
          }),
          (m.prototype.getTopLevelElement = function () {
            var e = this.getParentElement();
            return null != e ? e.getTopLevelElement() : this;
          }),
          (m.prototype.getSelectableElement = function () {
            return this.canSelect() ? this : this.getSelectableParentElement();
          }),
          (m.prototype.getSelectableParentElement = function () {
            var e = this.getParentElement();
            return null != e ? e.getSelectableElement() : this;
          }),
          (m.prototype.getSelectionHighlightBoundingBox = function () {
            return this.boundingBoxVisible;
          }),
          (m.prototype.isSelectionHighlightEnabled = function () {
            return !0;
          }),
          (m.prototype.notifyChange = function (e, t) {
            var i, n;
            void 0 === t && (t = !0),
              null != e &&
                0 !== e &&
                ((this.mChangedFlags |= e),
                (this.mChangeNotifyParent = this.mChangeNotifyParent || t),
                this.handleImmediateChanges(),
                0 === this.mChangeDepth &&
                  (this.handleDelayedChanges(),
                  this.wasFlagChanged(1) && this.eventAdded.trigger(),
                  (i = !1),
                  this.wasFlagChanged(2) &&
                    (this.eventRemoved.trigger(), (i = !0)),
                  this.wasFlagChanged(4) &&
                    this.eventBoundingBoxChanged.trigger(),
                  this.wasFlagChanged(8) &&
                    this.eventTransformationChanged.trigger(),
                  this.wasFlagChanged(48) &&
                    this.eventPropertiesChanged.trigger(
                      this.wasFlagChanged(16) ? 2 : 1
                    ),
                  t &&
                    this.wasFlagChanged(15) &&
                    null != (n = this.getParentElement()) &&
                    n.notifyChange(4),
                  0 !== this.mChangedFlags &&
                    (i || this.isInScene()) &&
                    this.mModel.notifyModification(),
                  (this.mChangedFlags = 0),
                  (this.mChangeNotifyParent = !1)));
          }),
          (m.prototype.beginChange = function () {
            this.mChangeDepth++;
          }),
          (m.prototype.endChange = function () {
            return (
              this.mChangeDepth--,
              this.mChangeDepth <= 0 &&
                ((this.mChangeDepth = 0),
                this.notifyChange(this.mChangedFlags, this.mChangeNotifyParent),
                !0)
            );
          }),
          (m.prototype.replaceNode = function (e, t, i, n) {
            var r, o, s, a;
            void 0 === n && (n = !0),
              null != e &&
                (null != (r = this.mNode)
                  ? ((o = 4),
                    (this.mNode = e),
                    i && (this.mNode.parent = r.parent),
                    null != (s = h.NodeUserData.FromNode(r, !1)) &&
                      (s.assignToNode(this.mNode),
                      s.setData(m.NODEDATA_SCENEELEMENT, this)),
                    t
                      ? ((a = l.utils.mesh.getLocalMatrix(r)),
                        l.utils.mesh.setLocalMatrix(this.mNode, a),
                        l.utils.mesh.updateFrozenWorldMatrix(this.mNode))
                      : (o |= 8),
                    r.dispose(),
                    this.notifyChange(o, n))
                  : this.setNode(e));
          }),
          (m.prototype.clone = function (e) {
            var t = new m(this.mModel, m.cloneNode(this.mNode, e));
            return t.copyDataFrom(this), t;
          }),
          (m.prototype.isInScene = function () {
            if (!this.mIsInScene) return !1;
            var e = this.getParentElement();
            return null == e || e.isInScene();
          }),
          (m.prototype.getNodes = function (e) {
            var t = new Array();
            return (
              null != this.mNode &&
                (t.push(this.mNode), this.collectNodes(this.mNode, t, e)),
              t
            );
          }),
          (m.prototype.serialize = function (e) {
            return null;
          }),
          (m.prototype.showInteractors = function (e) {}),
          (m.prototype.saveUndoData = function (e) {
            return null;
          }),
          (m.prototype.loadUndoData = function (e, t) {}),
          (m.prototype.getProperties = function () {
            return Promise.resolve(null);
          }),
          (m.prototype.getPropertyClasses = function () {
            return Promise.resolve(null);
          }),
          (m.prototype.beginPropertyChange = function () {
            this.beginChange();
          }),
          (m.prototype.endPropertyChange = function () {
            this.endChange();
          }),
          (m.FromNode = function (e, t) {
            if (null == e) return null;
            var i = h.NodeUserData.GetData(e, m.NODEDATA_SCENEELEMENT);
            return null == i
              ? t && null != e.parent
                ? m.FromNode(e.parent, t)
                : null
              : i;
          }),
          (m.prototype._setIsSelected = function (e) {
            this.mIsSelected = e;
          }),
          (m.prototype.setNode = function (e) {
            (this.mNode = e),
              null != this.mNode &&
                h.NodeUserData.SetData(
                  this.mNode,
                  m.NODEDATA_SCENEELEMENT,
                  this
                ),
              this.notifyChange(12);
          }),
          (m.prototype.copyDataFrom = function (e) {}),
          (m.prototype.handleImmediateChanges = function () {
            this.wasFlagChanged(4) &&
              ((this.mBoundingBox = null), (this.mBoundingBoxVisible = null)),
              this.wasFlagChanged(8) &&
                ((this.mTransform = null), (this.mWorldTransform = null)),
              this.wasFlagChanged(1) && (this.mIsInScene = !0),
              this.wasFlagChanged(2) && (this.mIsInScene = !1);
          }),
          (m.prototype.handleDelayedChanges = function () {}),
          (m.prototype.wasAllFlagsChanged = function (e) {
            return (this.mChangedFlags & e) === e;
          }),
          (m.prototype.wasFlagChanged = function (e) {
            return 0 != (this.mChangedFlags & e);
          }),
          (m.cloneNode = function (e, t, i) {
            if (null != i && i) {
              var n = m.FromNode(e, !1);
              if (null != n) {
                var r = n.clone(t);
                if (null != r) return r.node;
              }
            }
            var o = e.clone(e.name, t, !0);
            if (null == o) throw new Error('Failed to clone node');
            var s = h.NodeUserData.FromNode(e);
            null != s && s.clone().assignToNode(o),
              e.isWorldMatrixFrozen && o.freezeWorldMatrix();
            for (
              var a = 0, l = e.getChildTransformNodes(!0);
              a < l.length;
              a++
            ) {
              var u = l[a];
              this.cloneNode(u, o, !0);
            }
            return o;
          }),
          (m.prototype.updateCachedTransforms = function () {
            null == this.mTransform &&
              ((this.mTransform =
                null == this.mNode
                  ? BABYLON.Matrix.Identity()
                  : l.utils.mesh.getLocalMatrix(this.mNode)),
              this.mTransform.invertToRef(this.mTransformInverted)),
              null == this.mWorldTransform &&
                (null != this.mNode
                  ? (this.mNode.computeWorldMatrix(!0),
                    (this.mWorldTransform = this.mNode.getWorldMatrix()))
                  : (this.mWorldTransform = BABYLON.Matrix.Identity()),
                this.mWorldTransform.invertToRef(this.mWorldTransformInverted));
          }),
          (m.prototype.collectNodes = function (e, t, i) {
            if (null != e)
              for (
                var n = 0, r = e.getChildTransformNodes(!0);
                n < r.length;
                n++
              ) {
                var o = r[n];
                (null != s.mdl.SceneElement.FromNode(o, !1) && !i) ||
                  (t.push(o), this.collectNodes(o, t, i));
              }
          }),
          (m.NODEDATA_SCENEELEMENT = 'core:sceneElement'),
          m);
        function m(e, t) {
          (this.eventAdded = new l.utils.ListenableEvent(this)),
            (this.eventRemoved = new l.utils.ListenableEvent(this)),
            (this.eventBoundingBoxChanged = new l.utils.ListenableEvent(this)),
            (this.eventTransformationChanged = new l.utils.ListenableEvent(
              this
            )),
            (this.eventPropertiesChanged = new l.utils.ListenableEvent(this)),
            (this.mModel = e),
            (this.mBoundingBox = null),
            (this.mBoundingBoxVisible = null),
            (this.mTransform = null),
            (this.mTransformInverted = BABYLON.Matrix.Identity()),
            (this.mWorldTransform = null),
            (this.mWorldTransformInverted = BABYLON.Matrix.Identity()),
            (this.mIsSelected = !1),
            (this.mIsInScene = !0),
            (this.mChangedFlags = 0),
            (this.mChangeDepth = 0),
            (this.mChangeNotifyParent = !1),
            this.setNode(t);
        }
        h.SceneElement = n;
      })((s = l.core || (l.core = {})).mdl || (s.mdl = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, i, o, n, r;
    function s() {
      return (null !== n && n.apply(this, arguments)) || this;
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (o = i.mdl || (i.mdl = {})),
      (n = o.SceneElement),
      __extends(s, n),
      (s.prototype.clone = function (e) {
        return new s(this.mModel, o.SceneElement.cloneNode(this.mNode, e));
      }),
      (s.prototype.serialize = function (e) {
        if (null == this.mNode) return null;
        var t = {};
        return (
          (t.classId = o.io.BASIC_ELEMENT_CLASSID),
          (t.node = o.io.serializeNode(this.mModel, e, this.mNode)),
          t
        );
      }),
      (s._RegisterClass = function (e) {
        e.registerElementLoader(o.io.BASIC_ELEMENT_CLASSID, function (
          e,
          t,
          i,
          n
        ) {
          if (null == i) return null;
          var r = o.io.deserializeNode(
            e.model,
            t,
            i.node,
            null != n ? n.node : null
          );
          return null == r ? null : new s(e.model, r);
        });
      }),
      (r = s),
      (o.BasicElement = r);
  })((egr = egr || {})),
  (function (e) {
    var d, l;
    (d = e.wcf || (e.wcf = {})),
      (function (m) {
        var e =
          ((c.prototype.getCenter = function (e) {
            void 0 === e && (e = null);
            var t = BABYLON.Vector3.Center(this.min, this.max);
            return (
              null != e && BABYLON.Vector3.TransformCoordinatesToRef(t, e, t), t
            );
          }),
          (c.prototype.getSize = function () {
            return this.max.subtract(this.min);
          }),
          (c.prototype.getRadius = function () {
            return 0.5 * BABYLON.Vector3.Distance(this.min, this.max);
          }),
          (c.prototype.getPoints = function (e) {
            void 0 === e && (e = null);
            var t = new Array(8);
            if (
              ((t[0] = this.min.clone()),
              (t[1] = this.min.clone()),
              (t[1].y = this.max.y),
              (t[2] = this.max.clone()),
              (t[2].z = this.min.z),
              (t[3] = this.min.clone()),
              (t[3].x = this.max.x),
              (t[4] = this.max.clone()),
              (t[4].y = this.min.y),
              (t[5] = this.max.clone()),
              (t[6] = this.max.clone()),
              (t[6].x = this.min.x),
              (t[7] = this.min.clone()),
              (t[7].z = this.max.z),
              null != e)
            )
              for (var i = 0; i < t.length; ++i)
                BABYLON.Vector3.TransformCoordinatesToRef(t[i], e, t[i]);
            return t;
          }),
          (c.prototype.isValid = function () {
            return c.IsMinMaxValid(this.min, this.max);
          }),
          (c.prototype.reset = function () {
            (this.min = d.utils.math.VECTOR3_MAX.clone()),
              (this.max = d.utils.math.VECTOR3_MIN.clone());
          }),
          (c.prototype.clone = function () {
            return new c(this.min, this.max);
          }),
          (c.prototype.expand = function (e) {
            return this.clone().expandInPlace(e);
          }),
          (c.prototype.expandInPlace = function (e) {
            return (
              null != e &&
                e.isValid() &&
                (this.expandByPointInPlace(e.min),
                this.expandByPointInPlace(e.max)),
              this
            );
          }),
          (c.prototype.expandByPoint = function (e) {
            return this.clone().expandByPointInPlace(e);
          }),
          (c.prototype.expandByPointInPlace = function (e) {
            return (
              this.min.minimizeInPlace(e), this.max.maximizeInPlace(e), this
            );
          }),
          (c.prototype.transform = function (e) {
            return this.clone().transformInPlace(e);
          }),
          (c.prototype.transformInPlace = function (e) {
            if (null == e || !this.isValid()) return this;
            var t = this.getPoints();
            (this.min = d.utils.math.VECTOR3_MAX.clone()),
              (this.max = d.utils.math.VECTOR3_MIN.clone());
            for (var i = 0; i < t.length; ++i)
              this.expandByPointInPlace(
                BABYLON.Vector3.TransformCoordinates(t[i], e)
              );
            return this;
          }),
          (c.prototype.isInFrustum = function (e, t) {
            if (
              (void 0 === t && (t = null),
              !this.isValid() || !this.isBoundingSphereInFrustum(e, t))
            )
              return !1;
            var i = this.getPoints(t);
            return BABYLON.BoundingBox.IsInFrustum(i, e);
          }),
          (c.prototype.isCompletelyInFrustum = function (e, t) {
            if (
              (void 0 === t && (t = null),
              !this.isValid() || !this.isBoundingSphereInFrustum(e, t))
            )
              return !1;
            var i = this.getPoints(t);
            return BABYLON.BoundingBox.IsCompletelyInFrustum(i, e);
          }),
          (c.prototype.intersects = function (e, t, i) {
            return (
              void 0 === i && (i = d.utils.math.EPSILON),
              !(null == e || !e.isValid()) &&
                this.intersectsMinMax(e.min, e.max, t, i)
            );
          }),
          (c.prototype.intersectsPoint = function (e, t, i) {
            return (
              void 0 === i && (i = d.utils.math.EPSILON),
              null != e && this.intersectsMinMax(e, e, t, i)
            );
          }),
          (c.prototype.intersectsMinMax = function (e, t, i, n) {
            if (
              (void 0 === n && (n = d.utils.math.EPSILON),
              null == e || null == t || !this.isValid())
            )
              return !1;
            if (i) {
              if (e.x - this.max.x > n || this.min.x - t.x > n) return !1;
              if (e.y - this.max.y > n || this.min.y - t.y > n) return !1;
              if (e.z - this.max.z > n || this.min.z - t.z > n) return !1;
            } else {
              if (this.max.x - e.x <= n || t.x - this.min.x <= n) return !1;
              if (this.max.y - e.y <= n || t.y - this.min.y <= n) return !1;
              if (this.max.z - e.z <= n || t.z - this.min.z <= n) return !1;
            }
            return !0;
          }),
          (c.FromNode = function (e, t) {
            if ((void 0 === t && (t = !1), null == e))
              throw new Error(d.utils.ERR_INVALID_ARGUMENT);
            var i,
              n,
              r = null;
            e instanceof BABYLON.AbstractMesh &&
              (e.isVisible || !t) &&
              ((r = e.getBoundingInfo()),
              (n = e) instanceof BABYLON.InstancedMesh && (n = n.sourceMesh),
              (null == n ||
                (n instanceof BABYLON.Mesh && null == n.geometry)) &&
                (r = null)),
              (i =
                null == r || null == r.boundingBox
                  ? new c()
                  : new c(r.boundingBox.minimum, r.boundingBox.maximum));
            for (
              var o = 0, s = e.getChildTransformNodes(!0);
              o < s.length;
              o++
            ) {
              var a = s[o],
                l = null,
                u = null,
                h = m.SceneElement.FromNode(a, !1);
              null != h
                ? ((l = t
                    ? h.boundingBoxVisible.clone()
                    : h.boundingBox.clone()),
                  (u = h.transform))
                : ((l = c.FromNode(a, t)),
                  (u = p),
                  d.utils.mesh.getLocalMatrixToRef(a, u)),
                null != l && (l.transformInPlace(u), i.expandInPlace(l));
            }
            return i;
          }),
          (c.FromMesh = function (e, t) {
            return void 0 === t && (t = !1), c.FromNode(e, t);
          }),
          (c.FromElements = function (e, t, i) {
            void 0 === t && (t = !0), void 0 === i && (i = !1);
            for (
              var n = new l.mdl.BoundingBox(), r = 0, o = e;
              r < o.length;
              r++
            ) {
              var s = o[r],
                a = (a = i ? s.boundingBoxVisible : s.boundingBox).transform(
                  t ? s.worldTransform : s.transform
                );
              n.expandInPlace(a);
            }
            return n;
          }),
          (c.IsBoundingInfoValid = function (e) {
            return c.IsMinMaxValid(e.minimum, e.maximum);
          }),
          (c.IsMinMaxValid = function (e, t) {
            return !(
              e.equalsWithEpsilon(
                d.utils.math.VECTOR3_MIN,
                d.utils.math.EPSILON
              ) ||
              e.equalsWithEpsilon(
                d.utils.math.VECTOR3_MAX,
                d.utils.math.EPSILON
              ) ||
              t.equalsWithEpsilon(
                d.utils.math.VECTOR3_MIN,
                d.utils.math.EPSILON
              ) ||
              t.equalsWithEpsilon(
                d.utils.math.VECTOR3_MAX,
                d.utils.math.EPSILON
              )
            );
          }),
          (c.prototype.isBoundingSphereInFrustum = function (e, t) {
            void 0 === t && (t = null);
            var i,
              n = this.getCenter(),
              r = this.getRadius();
            null != t &&
              (BABYLON.Vector3.TransformCoordinatesToRef(n, t, n),
              (i = BABYLON.Vector3.Zero()),
              BABYLON.Vector3.TransformNormalFromFloatsToRef(1, 1, 1, t, i),
              (r = Math.max(Math.abs(i.x), Math.abs(i.y), Math.abs(i.z)) * r));
            for (var o = 0; o < e.length; o++)
              if (e[o].dotCoordinate(n) <= -r) return !1;
            return !0;
          }),
          (c.SIDE_MIN_X = [7, 6, 1, 0]),
          (c.SIDE_MAX_X = [3, 2, 5, 4]),
          (c.SIDE_MIN_Y = [7, 0, 3, 4]),
          (c.SIDE_MAX_Y = [1, 6, 5, 2]),
          (c.SIDE_MIN_Z = [0, 1, 2, 3]),
          (c.SIDE_MAX_Z = [4, 5, 6, 7]),
          (c.EDGES = [
            [3, 0],
            [0, 1],
            [1, 2],
            [4, 3],
            [3, 2],
            [2, 5],
            [7, 4],
            [4, 5],
            [5, 6],
            [0, 7],
            [7, 6],
            [6, 1],
          ]),
          c);
        function c(e, t) {
          (this.min = null != e ? e.clone() : d.utils.math.VECTOR3_MAX.clone()),
            (this.max =
              null != t ? t.clone() : d.utils.math.VECTOR3_MIN.clone());
        }
        m.BoundingBox = e;
        var p = BABYLON.Matrix.Identity();
      })((l = d.core || (d.core = {})).mdl || (l.mdl = {}));
  })((egr = egr || {})),
  (function (e) {
    var a, l, s, t;
    function r(e) {
      (this.onDisposeMesh = function (e, t) {
        null != e && e.dispose();
      }),
        (this.mScene = e.scene),
        (this.mMeshCache = new l.mdl.ResourceCache()),
        (this.mMeshCache.onDisposeResource = this.onDisposeMesh),
        (this.mLastCacheCleanUp = Date.now()),
        (this.missingGeometries = new Set());
    }
    (a = e.wcf || (e.wcf = {})),
      (l = a.core || (a.core = {})),
      (s = l.mdl || (l.mdl = {})),
      (r.prototype.clear = function () {
        (this.mLastCacheCleanUp = Date.now()),
          this.mMeshCache.clear(),
          this.missingGeometries.clear();
      }),
      (r.prototype.addGeometryMesh = function (e, t) {
        if (a.utils.string.isNullOrEmpty(e) || null == t || null == t.geometry)
          return !1;
        var i = this.getGeometry(e);
        return !(
          (null != i && !this.isFallbackGeometry(i)) ||
          (null != i && this.mMeshCache.remove(e, !0),
          this.mMeshCache.add(e, t),
          (t.id = e),
          (t.geometry.id = e),
          this.mScene.removeMesh(t),
          this.missingGeometries.delete(e),
          0)
        );
      }),
      (r.prototype.getGeometryMesh = function (e) {
        if (a.utils.string.isNullOrEmpty(e)) return null;
        var t = this.mMeshCache.get(e);
        return null == t || null == t.geometry ? null : t;
      }),
      (r.prototype.getGeometry = function (e) {
        var t = this.getGeometryMesh(e);
        return null != t ? t.geometry : null;
      }),
      (r.prototype.hasGeometry = function (e) {
        return !a.utils.string.isNullOrEmpty(e) && this.mMeshCache.has(e);
      }),
      (r.prototype.isFallbackGeometry = function (e) {
        return null != e && !0 === e[r.KEY_IS_FALLBACK];
      }),
      (r.prototype.getMeshGeometryId = function (e) {
        return e instanceof BABYLON.Mesh &&
          null != e.geometry &&
          this.hasGeometry(e.geometry.id)
          ? e.geometry.id
          : null;
      }),
      (r.prototype._cleanUpCache = function (e) {
        var t,
          i = Date.now();
        (e || i - this.mLastCacheCleanUp > r.CACHE_CLEANUP_INTERVAL) &&
          ((this.mLastCacheCleanUp = i),
          (t = e ? 0 : r.CACHE_CLEANUP_INTERVAL),
          this.cleanUpMeshCache(t));
      }),
      (r.prototype._serializeGeometries = function (e) {
        if (null == e || null == e.geometryIds)
          throw new Error(a.utils.ERR_INVALID_ARGUMENT);
        for (var t = new Array(), i = 0, n = e.geometryIds; i < n.length; i++) {
          var r,
            o = n[i],
            s = this.getGeometry(o);
          null != s
            ? (((r = {}).id = o),
              (r.boundMin = l.io.serializeVector3(s.extend.minimum)),
              (r.boundMax = l.io.serializeVector3(s.extend.maximum)),
              t.push(r))
            : (a.utils.Log.warn('Unknown geometry id: ' + o),
              t.push({ id: o, boundMin: [0, 0, 0], boundMax: [0, 0, 0] }));
        }
        return t;
      }),
      (r.prototype._addGeometriesToContainer = function (n, r, o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == n || null == r)
                  throw new Error(a.utils.ERR_INVALID_ARGUMENT);
                (t = n.length), (i = 0), (e.label = 1);
              case 1:
                return i < t
                  ? [4, this.addGeometryToContainer(n[i], r)]
                  : [3, 4];
              case 2:
                e.sent(), null != o && o((i / t) * 100), (e.label = 3);
              case 3:
                return ++i, [3, 1];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype._readGeometriesFromContainer = function (n, r, o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == n || null == n)
                  throw new Error(a.utils.ERR_INVALID_ARGUMENT);
                (t = n.length), (i = 0), (e.label = 1);
              case 1:
                return i < t
                  ? [4, this.readGeometryFromContainer(n[i], r)]
                  : [3, 4];
              case 2:
                e.sent(), null != o && o((i / t) * 100), (e.label = 3);
              case 3:
                return ++i, [3, 1];
              case 4:
                return [2];
            }
          });
        });
      }),
      (r.prototype.cleanUpMeshCache = function (e) {
        var n = new Set();
        this.mMeshCache.forEach(function (e, t) {
          var i;
          null != t && null != t.geometry
            ? null != (i = t.geometry)._meshes
              ? 1 < i._meshes.length && n.add(e)
              : a.utils.Log.error(
                  'Private member BABYLON.Geometry._meshes is undefined.'
                )
            : n.add(e);
        }),
          this.mMeshCache.removeUnused(n, r.CACHE_CLEANUP_INTERVAL);
      }),
      (r.prototype.addGeometryToContainer = function (i, n) {
        var r = this.getGeometryMesh(i);
        if (null == r)
          return (
            a.utils.Log.warn('Unknown geometry id: ' + i), Promise.resolve()
          );
        if (null == r.geometry)
          return (
            a.utils.Log.warn('Geometry mesh has no geometry: ' + i),
            Promise.resolve()
          );
        if (this.isFallbackGeometry(r.geometry)) return Promise.resolve();
        var o = 'geometries/' + i + s.io.GltfMesh.BINARY_GLTF_EXTENSION;
        return n
          .addFileFromCache(o, !0)
          .then(function (e) {
            if (e) return Promise.resolve();
            var t = s.io.GltfMesh.Export(r);
            return null == t
              ? (a.utils.Log.error('Failed to export geometry ' + i),
                Promise.resolve())
              : n.addFile(t, o, !0, !0);
          })
          .catch(function (e) {
            a.utils.Log.error('Failed to embed geometry ' + i, e);
          });
      }),
      (r.prototype.readGeometryFromContainer = function (i, e) {
        var n = this;
        return null == i || this.hasGeometry(i.id)
          ? Promise.resolve()
          : e
              .getFile(
                'geometries/' + i.id + s.io.GltfMesh.BINARY_GLTF_EXTENSION,
                !0
              )
              .then(function (e) {
                var t = s.io.GltfMesh.Import(e, n.mScene);
                null != t && 0 < t.length
                  ? n.addGeometryMesh(i.id, t[0])
                  : a.utils.Log.error('Failed to import geometry ' + i.id);
              })
              .catch(function (e) {
                n.createFallbackGeometry(i.id, i),
                  n.missingGeometries.add(i.id),
                  e instanceof l.io.FileNotFoundError ||
                    a.utils.Log.error(
                      'Failed to get embedded geometry ' + i.id,
                      e
                    );
              });
      }),
      (r.prototype.createFallbackGeometry = function (e, t) {
        var i, n;
        null == t ||
          this.hasGeometry(e) ||
          ((i = BABYLON.MeshBuilder.CreateBox(
            e,
            {
              width: t.boundMax[0] - t.boundMin[0],
              height: t.boundMax[1] - t.boundMin[1],
              depth: t.boundMax[2] - t.boundMin[2],
              updatable: !1,
            },
            this.mScene
          )),
          (n = BABYLON.Matrix.Translation(
            0.5 * (t.boundMin[0] + t.boundMax[0]),
            0.5 * (t.boundMin[1] + t.boundMax[1]),
            0.5 * (t.boundMin[2] + t.boundMax[2])
          )),
          i.bakeTransformIntoVertices(n),
          (i.geometry[r.KEY_IS_FALLBACK] = !0),
          this.addGeometryMesh(e, i));
      }),
      (r.CACHE_CLEANUP_INTERVAL = 12e4),
      (r.KEY_IS_FALLBACK = 'egr_wcf_isFallback'),
      (t = r),
      (s.GeometryManager = t);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r, o;
    function s(e) {
      var t = r.call(this, e, new BABYLON.TransformNode('', e.scene)) || this;
      return (t.mChildElements = new Array()), t;
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.mdl || (i.mdl = {})),
      (r = n.SceneElement),
      __extends(s, r),
      Object.defineProperty(s.prototype, 'childElements', {
        get: function () {
          return this.mChildElements;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o = s),
      (n.GroupElement = o);
  })((egr = egr || {})),
  (function (e) {
    var a, t, i, n;
    function r(e) {
      (this.mApp = e), (this.mLayers = new Map());
    }
    (a = e.wcf || (e.wcf = {})),
      (t = a.core || (a.core = {})),
      (i = t.mdl || (t.mdl = {})),
      (r.prototype.clear = function () {
        this.mLayers.clear();
      }),
      (r.prototype.isLayerVisible = function (e) {
        if (null == e) return !0;
        var t = this.mLayers.get(e);
        return void 0 === t || t;
      }),
      (r.prototype.setLayerVisible = function (e, t) {
        if (this.isLayerVisible(e) !== t) {
          this.mLayers.set(e, t);
          for (var i = 0, n = this.mApp.model.elements; i < n.length; i++) {
            var r = n[i];
            this.applyLayerVisibility(e, t, r.node);
          }
        }
      }),
      (r.prototype.getMeshLayer = function (e) {
        return i.NodeUserData.GetData(e, r.NODEDATA_LAYER);
      }),
      (r.prototype.setMeshLayer = function (e, t) {
        i.NodeUserData.SetData(e, r.NODEDATA_LAYER, t),
          a.utils.string.isNotNullOrEmpty(t) &&
            (this.mLayers.has(t) || this.mLayers.set(t, !0),
            (e.isVisible = this.isLayerVisible(t)));
      }),
      (r.prototype.getMeshesOnLayer = function (e, t) {
        var i = new Array();
        if (void 0 !== t) this.collectMeshesOnLayer(e, t, i);
        else
          for (var n = 0, r = this.mApp.model.elements; n < r.length; n++) {
            var o = r[n];
            this.collectMeshesOnLayer(e, o.node, i);
          }
        return i;
      }),
      (r.prototype._serializeLayers = function (e) {
        if (null == e || null == e.layerNames)
          throw new Error(a.utils.ERR_INVALID_ARGUMENT);
        for (var t = new Array(), i = 0, n = e.layerNames; i < n.length; i++) {
          var r = n[i],
            o = this.mLayers.get(r);
          null == o && ((o = !1), a.utils.Log.warn('Unknown layer name: ' + r));
          var s = {};
          (s.name = r), o || (s.visible = o), t.push(s);
        }
        return t;
      }),
      (r.prototype._deserializeLayers = function (e) {
        if (null != e)
          for (var t = 0, i = e; t < i.length; t++) {
            var n,
              r = i[t];
            null != r &&
              ((n = !0),
              null != r.visible && (n = r.visible),
              this.mLayers.set(r.name, n));
          }
      }),
      (r.prototype.applyLayerVisibility = function (e, t, i) {
        if (null != i) {
          var n;
          i instanceof BABYLON.AbstractMesh &&
            null != (n = this.getMeshLayer(i)) &&
            n === e &&
            (i.isVisible = t);
          for (var r = 0, o = i.getChildTransformNodes(!0); r < o.length; r++) {
            var s = o[r];
            this.applyLayerVisibility(e, t, s);
          }
        }
      }),
      (r.prototype.collectMeshesOnLayer = function (e, t, i) {
        if (null != t) {
          var n;
          t instanceof BABYLON.AbstractMesh &&
            null != (n = this.getMeshLayer(t)) &&
            n === e &&
            i.push(t);
          for (var r = 0, o = t.getChildTransformNodes(!0); r < o.length; r++) {
            var s = o[r];
            this.collectMeshesOnLayer(e, s, i);
          }
        }
      }),
      (r.NODEDATA_LAYER = 'core:layer'),
      (n = r),
      (i.LayerManager = n);
  })((egr = egr || {})),
  (function (e) {
    var l, o, u, t;
    function n(e) {
      var n = this;
      (this.onDisposeMaterial = function (e, t) {
        null != e && (t ? e.dispose(!1, !0) : e.dispose());
      }),
        (this.onDisposeTexture = function (e, t) {
          var i;
          null != e &&
            (!e.isResource ||
              (null != (i = n.mResourceTextures.get(e.id)) &&
                (null != i.blobUrl && URL.revokeObjectURL(i.blobUrl),
                n.mResourceTextures.delete(e.id))),
            e.dispose());
        }),
        (this.mApp = e),
        (this.mScene = e.scene),
        (this.defaultMaterial = new u.PbrMaterial('default_mat', this)),
        (this.defaultMaterial.metallic = 0),
        (this.defaultMaterial.roughness = 1),
        (this.defaultMaterial.albedoColor = BABYLON.Color3.White()),
        this.defaultMaterial.freeze(),
        (this.missingResourceTextures = new Set()),
        (this.pbrImageProcessing = new BABYLON.ImageProcessingConfiguration()),
        (this.pbrImageProcessing.toneMappingEnabled = !0),
        (this.pbrImageProcessing.colorCurvesEnabled = !0),
        (this.pbrImageProcessing.colorCurves = new BABYLON.ColorCurves()),
        (this.pbrImageProcessing.colorCurves.globalSaturation = 40),
        (this.pbrImageProcessing.colorCurves.highlightsExposure = 24),
        (this.pbrImageProcessing.colorCurves.midtonesExposure = 0),
        (this.pbrImageProcessing.colorCurves.shadowsExposure = -100),
        (this.mMaterials = new u.ResourceCache()),
        (this.mMaterials.onDisposeResource = this.onDisposeMaterial),
        (this.mTextures = new u.ResourceCache()),
        (this.mTextures.onDisposeResource = this.onDisposeTexture),
        (this.mResourceTextures = new Map()),
        (this.mDefaultReflectionTexture = null),
        (this.mLastCacheCleanUp = Date.now()),
        (this.mLoadTexturesCount = 0),
        (this.mLoadTexturesPromise = null),
        (this.mLoadTexturesPromiseResolve = null),
        (this.mMaxAnisotropy = this.mScene.getEngine().getCaps().maxAnisotropy);
    }
    (l = e.wcf || (e.wcf = {})),
      (o = l.core || (l.core = {})),
      (u = o.mdl || (o.mdl = {})),
      Object.defineProperty(n.prototype, 'scene', {
        get: function () {
          return this.mScene;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (n.prototype.addMaterial = function (e, t) {
        return (
          !l.utils.string.isNullOrEmpty(e) &&
          null != t &&
          !this.mMaterials.has(e) &&
          ((t.id = e), this.mMaterials.add(e, t), !0)
        );
      }),
      (n.prototype.getMaterial = function (e) {
        if (l.utils.string.isNullOrEmpty(e)) return null;
        var t = this.mMaterials.get(e);
        return void 0 !== t ? t : null;
      }),
      (n.prototype.hasMaterial = function (e) {
        return !l.utils.string.isNullOrEmpty(e) && this.mMaterials.has(e);
      }),
      (n.prototype.clear = function () {
        (this.mLastCacheCleanUp = Date.now()),
          this.mMaterials.clear(),
          this.mTextures.clear(),
          this.missingResourceTextures.clear(),
          this.mResourceTextures.clear();
      }),
      (n.prototype.getTexture = function (e) {
        if (l.utils.string.isNullOrEmpty(e)) return null;
        var t = this.mTextures.get(e);
        return void 0 !== t ? t : null;
      }),
      (n.prototype.hasTexture = function (e) {
        return !l.utils.string.isNullOrEmpty(e) && this.mTextures.has(e);
      }),
      (n.prototype.createResourceTexture = function (i, n, r, e) {
        var o = this;
        if (
          (void 0 === r && (r = !1),
          l.utils.string.isNullOrEmpty(i) || l.utils.string.isNullOrEmpty(n))
        )
          return Promise.reject(new Error(l.utils.ERR_INVALID_ARGUMENT));
        var s = this.getTexture(i);
        return null == s || s.isFallback
          ? this.isTextureSupported(n)
            ? (null != e
                ? e.getFile(n, !0)
                : l.utils.async.ajax('GET', n, null, {
                    responseType: 'arraybuffer',
                  })
              ).then(function (e) {
                var t = 'jpg';
                return (
                  '.png' === l.utils.string.getFileExtension(n).toLowerCase() &&
                    (t = 'png'),
                  o.internalCreateResourceTexture(i, n, t, e, r, s)
                );
              })
            : Promise.reject(
                new Error('Unsupported texture file extension: ' + n)
              )
          : Promise.resolve(s);
      }),
      (n.prototype.getResourceTextureData = function (e) {
        var t = this.mResourceTextures.get(e);
        return void 0 === t ? null : t;
      }),
      (n.prototype.createTexture = function (e, t, i) {
        if (
          (void 0 === i && (i = !1),
          l.utils.string.isNullOrEmpty(e) || l.utils.string.isNullOrEmpty(t))
        )
          throw new Error(l.utils.ERR_INVALID_ARGUMENT);
        var n = this.getTexture(e);
        if (null != n) return n;
        if (!this.isTextureSupported(t))
          throw new Error('Unsupported texture file extension: ' + t);
        return (
          ((n = this.internalCreateTexture(
            e,
            t,
            t,
            !1,
            i
              ? BABYLON.Engine.TEXTUREFORMAT_RGBA
              : BABYLON.Engine.TEXTUREFORMAT_RGB
          )).hasAlpha = i),
          n
        );
      }),
      (n.prototype.waitUntilTexturesLoaded = function () {
        return null == this.mLoadTexturesPromise
          ? Promise.resolve()
          : this.mLoadTexturesPromise;
      }),
      (n.prototype.getDefaultReflectionTexture = function () {
        var e = this;
        return (
          null == this.mDefaultReflectionTexture &&
            (this.startLoadTexture(),
            (this.mDefaultReflectionTexture = new BABYLON.CubeTexture(
              this._dataPath + 'core/textures/defaultHDR_512.env',
              this.mScene,
              null,
              !1,
              null,
              function () {
                e.mApp.viewer.requestRenderFrame(), e.finishLoadTexture();
              },
              function () {
                l.utils.Log.error('Failed to load default reflection texture.'),
                  e.finishLoadTexture();
              },
              void 0,
              !0,
              void 0,
              !0
            )),
            (this.mDefaultReflectionTexture.rotationY = -l.utils.math.PI_DIV2)),
          this.mDefaultReflectionTexture
        );
      }),
      Object.defineProperty(n.prototype, '_dataPath', {
        get: function () {
          return this.mApp.dataPath;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (n.prototype._cleanUpCache = function (e) {
        var t,
          i = Date.now();
        (e || i - this.mLastCacheCleanUp > n.CACHE_CLEANUP_INTERVAL) &&
          ((this.mLastCacheCleanUp = i),
          (t = e ? 0 : n.CACHE_CLEANUP_INTERVAL),
          this.cleanUpMaterialCache(t),
          this.cleanUpTextureCache(t));
      }),
      (n.prototype._serializeMaterials = function (e) {
        if (null == e || null == e.materialIds)
          throw new Error(l.utils.ERR_INVALID_ARGUMENT);
        for (var t = new Array(), i = 0, n = e.materialIds; i < n.length; i++) {
          var r,
            o = n[i],
            s = this.getMaterial(o);
          null != s
            ? ((r = u.PbrMaterial._Serialize(e, s)), t.push(r))
            : (l.utils.Log.warn('Unknown material id: ' + o),
              t.push({ id: o }));
        }
        return t;
      }),
      (n.prototype._deserializeMaterials = function (e, t) {
        if (null != e && null != t)
          for (var i = 0, n = e; i < n.length; i++) {
            var r = n[i],
              o = u.PbrMaterial._Deserialize(r, t, this);
            null != o && this.addMaterial(r.id, o);
          }
      }),
      (n.prototype._serializeTextures = function (e) {
        if (null == e || null == e.textureIds)
          throw new Error(l.utils.ERR_INVALID_ARGUMENT);
        for (var t = new Array(), i = 0, n = e.textureIds; i < n.length; i++) {
          var r,
            o,
            s = n[i],
            a = this.getTexture(s);
          null != a
            ? null != (r = this.mResourceTextures.get(s)) &&
              a.isResource &&
              (((o = {}).id = s),
              'jpg' !== r.type && (o.type = r.type),
              a.name != s &&
                l.utils.string.isNotNullOrEmpty(a.name) &&
                (o.name = a.name),
              a.hasAlpha && (o.transparent = !0),
              t.push(o))
            : (l.utils.Log.warn('Unknown texture id: ' + s), t.push({ id: s }));
        }
        return t;
      }),
      (n.prototype._addTexturesToContainer = function (n, r, o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == n || null == r)
                  throw new Error(l.utils.ERR_INVALID_ARGUMENT);
                (t = n.length), (i = 0), (e.label = 1);
              case 1:
                return i < t
                  ? [4, this.addTextureToContainer(n[i], r)]
                  : [3, 4];
              case 2:
                e.sent(), null != o && o((i / t) * 100), (e.label = 3);
              case 3:
                return ++i, [3, 1];
              case 4:
                return [2];
            }
          });
        });
      }),
      (n.prototype._readTexturesFromContainer = function (n, r, o) {
        return __awaiter(this, void 0, void 0, function () {
          var t, i;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == n || null == r)
                  throw new Error(l.utils.ERR_INVALID_ARGUMENT);
                (t = n.length), (i = 0), (e.label = 1);
              case 1:
                return i < t
                  ? [4, this.readTextureFromContainer(n[i], r)]
                  : [3, 4];
              case 2:
                e.sent(), null != o && o((i / t) * 100), (e.label = 3);
              case 3:
                return ++i, [3, 1];
              case 4:
                return [2];
            }
          });
        });
      }),
      (n.prototype.internalCreateResourceTexture = function (e, t, i, n, r, o) {
        void 0 === o && (o = null);
        var s = new Blob([n]),
          a = URL.createObjectURL(s),
          l = this.internalCreateTexture(
            e,
            t,
            a,
            !0,
            r
              ? BABYLON.Engine.TEXTUREFORMAT_RGBA
              : BABYLON.Engine.TEXTUREFORMAT_RGB
          );
        l.hasAlpha = 'png' === i && r;
        var u = { data: n, blobUrl: a, type: i };
        return (
          this.mResourceTextures.set(e, u),
          this.missingResourceTextures.delete(e),
          null != o &&
            (this.mMaterials.forEach(function (e, t) {
              t.replaceTexture(o, l);
            }),
            o.dispose()),
          l
        );
      }),
      (n.prototype.internalCreateTexture = function (e, t, i, n, r, o) {
        var s = this;
        void 0 === o && (o = BABYLON.Texture.TRILINEAR_SAMPLINGMODE),
          this.startLoadTexture();
        var a = new u.Texture(
          i,
          this.mScene,
          function () {
            s.mApp.viewer.requestRenderFrame(), s.finishLoadTexture();
          },
          function () {
            l.utils.Log.error('Failed to load texture: ' + i),
              s.finishLoadTexture();
          },
          o,
          r
        );
        return (
          (a.anisotropicFilteringLevel = this.mMaxAnisotropy),
          (a.id = e),
          l.utils.string.isNotNullOrEmpty(t) && (a.name = t),
          (a.isResource = n),
          this.mTextures.add(e, a),
          a
        );
      }),
      (n.prototype.createFallbackTexture = function (e, t, i, n) {
        var r = this.internalCreateTexture(
          e,
          t,
          this.mApp.dataPath + 'core/textures/fallback.png',
          !0,
          BABYLON.Engine.TEXTUREFORMAT_RGBA,
          BABYLON.Texture.NEAREST_SAMPLINGMODE
        );
        (r.isFallback = !0), (r.hasAlpha = n);
        var o = { data: null, blobUrl: null, type: i };
        return this.mResourceTextures.set(e, o), r;
      }),
      (n.prototype.isTextureSupported = function (e) {
        if (l.utils.string.isNullOrEmpty(e)) return !1;
        var t = l.utils.string.getFileExtension(e);
        return (
          !l.utils.string.isNullOrEmpty(t) &&
          ('.png' == (t = t.toLowerCase()) || '.jpg' == t)
        );
      }),
      (n.prototype.cleanUpMaterialCache = function (e) {
        for (
          var t = new Set(), i = 0, n = this.mApp.model.meshInstances;
          i < n.length;
          i++
        ) {
          var r,
            o = n[i];
          null != o.material &&
            o.material instanceof u.PbrMaterial &&
            ((r = o.material.id),
            l.utils.string.isNotNullOrEmpty(r) && t.add(r));
        }
        this.mMaterials.removeUnused(t, e);
      }),
      (n.prototype.cleanUpTextureCache = function (e) {
        for (
          var t = new Set(),
            i = function (e) {
              null != e &&
                e instanceof u.Texture &&
                l.utils.string.isNotNullOrEmpty(e.id) &&
                t.add(e.id);
            },
            n = 0,
            r = this.mScene.materials;
          n < r.length;
          n++
        ) {
          var o = r[n];
          o instanceof u.PbrMaterial && o.collectTextures(i);
        }
        this.mTextures.removeUnused(t, e);
      }),
      (n.prototype.startLoadTexture = function () {
        var t = this;
        this.mLoadTexturesCount++,
          null == this.mLoadTexturesPromise &&
            (this.mLoadTexturesPromise = new Promise(function (e) {
              t.mLoadTexturesPromiseResolve = e;
            }));
      }),
      (n.prototype.finishLoadTexture = function () {
        0 !== this.mLoadTexturesCount &&
          (this.mLoadTexturesCount--,
          0 === this.mLoadTexturesCount &&
            (this.mLoadTexturesPromiseResolve(),
            (this.mLoadTexturesPromise = null),
            (this.mLoadTexturesPromiseResolve = null)));
      }),
      (n.prototype.addTextureToContainer = function (t, i) {
        var n = this.mResourceTextures.get(t),
          e = this.getTexture(t);
        if (null == n || null == e)
          return (
            l.utils.Log.warn('Unknown texture id: ' + t), Promise.resolve()
          );
        if (null == n.data)
          return (
            l.utils.Log.warn('Missing texture data for id: ' + t),
            Promise.resolve()
          );
        if (e.isFallback) return Promise.resolve();
        var r = 'textures/' + t + '.' + n.type;
        return i
          .addFileFromCache(r, !1)
          .then(function (e) {
            return e ? Promise.resolve() : i.addFile(n.data, r, !1, !0);
          })
          .catch(function (e) {
            l.utils.Log.error('Failed to embed texture ' + t, e);
          });
      }),
      (n.prototype.readTextureFromContainer = function (t, e) {
        var i = this;
        if (null == t || this.hasTexture(t.id)) return Promise.resolve();
        var n = 'jpg';
        null != t.type && (n = t.type);
        var r = null != t.transparent && t.transparent;
        return e
          .getFile('textures/' + t.id + '.' + n, !0)
          .then(function (e) {
            null == i.internalCreateResourceTexture(t.id, t.name, n, e, r) &&
              l.utils.Log.error('Failed to load texture ' + t.id);
          })
          .catch(function (e) {
            i.createFallbackTexture(t.id, t.name, n, r),
              i.missingResourceTextures.add(t.id),
              e instanceof o.io.FileNotFoundError ||
                l.utils.Log.error('Failed to get embedded texture ' + t.id, e);
          });
      }),
      (n.CACHE_CLEANUP_INTERVAL = 12e4),
      (t = n),
      (u.MaterialManager = t);
  })((egr = egr || {})),
  (function (e) {
    var o, t, n, i;
    function r(e) {
      var i = this;
      (this.eventSelectionChanged = new o.utils.ListenableEvent(this)),
        (this.eventModified = new o.utils.ListenableEvent(this)),
        (this.eventBeginTransformElements = new o.utils.ListenableEvent(this)),
        (this.eventEndTransformElements = new o.utils.ListenableEvent(this)),
        (this.onMeshAddedToScene = function (e, t) {
          null != e &&
            1 != n.NodeUserData.GetData(e, r.NODEDATA_MESHADDED) &&
            (i.mMeshInstances.push(e),
            n.NodeUserData.SetData(e, r.NODEDATA_MESHADDED, !0),
            e.onDisposeObservable.add(i.onMeshDisposed));
        }),
        (this.onMeshDisposed = function (e, t) {
          null != e &&
            (n.NodeUserData.SetData(e, r.NODEDATA_MESHADDED, !1),
            o.utils.array.remove(i.mMeshInstances, e),
            i.mCleanUpCachesOnDispose &&
              (i.mGeometryManager._cleanUpCache(!1),
              i.mMaterialManager._cleanUpCache(!1)));
        }),
        (this.mApp = e),
        (this.mScene = e.scene),
        (this.mElements = new Array()),
        (this.mMeshInstances = new Array()),
        (this.mCleanUpCachesOnDispose = !0),
        (this.mSelection = new Array()),
        (this.mSubElementSelection = new Map()),
        (this.mSelectionProperties = new n.SelectionPropertyProvider(e)),
        (this.mSelectionChanged = !1),
        (this.mSelectionChangeDepth = 0),
        (this.mModified = !1),
        (this.mModificationDepth = 0),
        this.mScene.onNewMeshAddedObservable.add(this.onMeshAddedToScene),
        (this.mGeometryManager = new n.GeometryManager(this)),
        (this.mMaterialManager = new n.MaterialManager(e)),
        (this.mLayerManager = new n.LayerManager(e)),
        (this.mLoaders = new Map()),
        n.BasicElement._RegisterClass(this);
    }
    (o = e.wcf || (e.wcf = {})),
      (t = o.core || (o.core = {})),
      (n = t.mdl || (t.mdl = {})),
      Object.defineProperty(r.prototype, 'app', {
        get: function () {
          return this.mApp;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'scene', {
        get: function () {
          return this.mScene;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'geometries', {
        get: function () {
          return this.mGeometryManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'materials', {
        get: function () {
          return this.mMaterialManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'layers', {
        get: function () {
          return this.mLayerManager;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'elements', {
        get: function () {
          return this.mElements;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'selection', {
        get: function () {
          return this.mSelection;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'selectionProperties', {
        get: function () {
          return this.mSelectionProperties;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'meshInstances', {
        get: function () {
          return this.mMeshInstances;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.addElement = function (e, t, i) {
        var n;
        void 0 === t && (t = null),
          void 0 === i && (i = !1),
          null != e &&
            null != e.node &&
            ((n = e.node),
            null == t ? this.mElements.push(e) : (n.parent = t),
            i && o.utils.mesh.addToScene(n, this.mScene),
            e.notifyChange(1));
      }),
      (r.prototype.removeElement = function (e, t, i) {
        var n;
        void 0 === t && (t = !0),
          void 0 === i && (i = !0),
          null != e &&
            null != e.node &&
            ((n = e.node),
            null == e.getParentElement()
              ? o.utils.array.remove(this.mElements, e)
              : (n.parent = null),
            t && !i && o.utils.mesh.removeFromScene(e.node, this.mScene),
            e.isSelected && this.removeFromSelection(e),
            e.notifyChange(2),
            i && e.dispose());
      }),
      (r.prototype.clear = function () {
        try {
          this.mCleanUpCachesOnDispose = !1;
          for (var e = 0, t = this.mElements; e < t.length; e++) t[e].dispose();
          (this.mElements = new Array()),
            this.mGeometryManager.clear(),
            this.mMaterialManager.clear(),
            this.mLayerManager.clear(),
            this.setSelection(null),
            this.notifyModification();
        } finally {
          this.mCleanUpCachesOnDispose = !0;
        }
      }),
      (r.prototype.setSelection = function (e) {
        var t = !1;
        if (0 < this.mSelection.length) {
          for (var i = 0, n = this.mSelection; i < n.length; i++)
            (r = n[i])._setIsSelected(!1), this.mSubElementSelection.delete(r);
          (this.mSelection = new Array()), (t = !0);
        }
        if (null != e && 0 < e.length) {
          for (var r, o = 0, s = e; o < s.length; o++)
            (r = s[o]).canSelect() &&
              !r.isSelected &&
              (this.mSelection.push(r), r._setIsSelected(!0));
          t = !0;
        }
        return t && this.selectionChanged(), t;
      }),
      (r.prototype.addToSelection = function (e) {
        return !(
          null == e ||
          e.isSelected ||
          !e.canSelect() ||
          (this.mSelection.push(e),
          e._setIsSelected(!0),
          this.selectionChanged(),
          0)
        );
      }),
      (r.prototype.removeFromSelection = function (e) {
        return !(
          null == e ||
          !e.isSelected ||
          !o.utils.array.remove(this.mSelection, e) ||
          (e._setIsSelected(!1),
          this.mSubElementSelection.delete(e),
          this.selectionChanged(),
          0)
        );
      }),
      (r.prototype.setSubElementSelection = function (e, t) {
        if (null == e || !e.isSelected) return !1;
        var i = !0,
          n = t;
        return (
          (e.canSelectSubElement() && (null == t || t.canSelect())) ||
            ((i = !1), (n = null)),
          n != this.getSubElementSelection(e) &&
            (null == n
              ? this.mSubElementSelection.delete(e)
              : this.mSubElementSelection.set(e, n),
            this.selectionChanged()),
          i
        );
      }),
      (r.prototype.getSubElementSelection = function (e) {
        var t = this.mSubElementSelection.get(e);
        return null != t ? t : null;
      }),
      (r.prototype.selectParentSubElement = function (e) {
        var t = this.getSubElementSelection(e);
        if (null == t) return null;
        var i = t.getSelectableParentElement();
        return i === e
          ? (this.setSubElementSelection(e, null), null)
          : (this.setSubElementSelection(e, i), i);
      }),
      (r.prototype.clearSubElementSelection = function () {
        this.hasSubElementSelection() &&
          (this.mSubElementSelection.clear(), this.selectionChanged());
      }),
      (r.prototype.hasSubElementSelection = function () {
        return 0 < this.mSubElementSelection.size;
      }),
      (r.prototype.validateSelection = function () {
        if (0 !== this.mSelection.length) {
          this.beginSelectionChange();
          for (
            var e = new Array(), t = new Array(), i = 0, n = this.mSelection;
            i < n.length;
            i++
          ) {
            var r = n[i];
            r.canSelect() &&
              (e.push(r), t.push(this.getSubElementSelection(r)));
          }
          this.mSelection.length != e.length && this.setSelection(e);
          for (var o = 0; o < e.length; ++o)
            null != t[o] && this.setSubElementSelection(e[o], t[o]);
          this.endSelectionChange();
        }
      }),
      (r.prototype.beginSelectionChange = function () {
        this.mSelectionChangeDepth++;
      }),
      (r.prototype.endSelectionChange = function () {
        this.mSelectionChangeDepth--,
          this.mSelectionChangeDepth <= 0 &&
            ((this.mSelectionChangeDepth = 0),
            this.mSelectionChanged && this.selectionChanged());
      }),
      (r.prototype.notifyModification = function () {
        (this.mModified = !0),
          0 === this.mModificationDepth &&
            ((this.mModified = !1), this.eventModified.trigger());
      }),
      (r.prototype.beginModification = function () {
        this.mModificationDepth++;
      }),
      (r.prototype.endModification = function () {
        this.mModificationDepth--,
          this.mModificationDepth <= 0 &&
            ((this.mModificationDepth = 0),
            this.mModified && this.notifyModification());
      }),
      (r.prototype.registerElementLoader = function (e, t) {
        o.utils.string.isNullOrEmpty(e) || null == t || this.mLoaders.set(e, t);
      }),
      (r.prototype.getElementLoader = function (e) {
        var t = this.mLoaders.get(e);
        return null != t ? t : null;
      }),
      (r.prototype._serialize = function (e) {
        if (null == e) throw new Error(o.utils.ERR_INVALID_ARGUMENT);
        var t = {};
        t.elements = new Array();
        for (var i = 0, n = this.mElements; i < n.length; i++) {
          var r = n[i].serialize(e);
          null != r && t.elements.push(r);
        }
        return (
          (t.layers = this.mLayerManager._serializeLayers(e)),
          (t.geometries = this.mGeometryManager._serializeGeometries(e)),
          (t.materials = this.mMaterialManager._serializeMaterials(e)),
          (t.textures = this.mMaterialManager._serializeTextures(e)),
          t
        );
      }),
      (r.prototype._deserialize = function (e, t) {
        if (null == e || null == t) return !1;
        this.mLayerManager._deserializeLayers(e.layers),
          this.mMaterialManager._deserializeMaterials(e.materials, t);
        for (var i = 0, n = e.elements; i < n.length; i++) {
          var r,
            o = n[i],
            s = this.mLoaders.get(o.classId);
          null == s ||
            (null != (r = s(this.mApp, t, o, null)) && this.addElement(r));
        }
        return !0;
      }),
      (r.prototype.selectionChanged = function () {
        (this.mSelectionChanged = !0),
          0 === this.mSelectionChangeDepth &&
            ((this.mSelectionChanged = !1),
            this.mSelectionProperties.setProviders(this.getSelectedProviders()),
            this.eventSelectionChanged.trigger());
      }),
      (r.prototype.getSelectedProviders = function () {
        if (0 === this.mSubElementSelection.size) return this.mSelection;
        for (
          var e = new Array(), t = 0, i = this.mSelection;
          t < i.length;
          t++
        ) {
          var n = i[t],
            r = this.getSubElementSelection(n);
          e.push(null != r ? r : n);
        }
        return e;
      }),
      (r.NODEDATA_MESHADDED = 'core:meshAddedToModel'),
      (i = r),
      (n.ModelManager = i);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    function o(e) {
      void 0 === e && (e = null),
        (this.mData = null != e ? new Map(e.mData) : new Map());
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.mdl || (i.mdl = {})),
      (o.prototype.getData = function (e) {
        return this.mData.has(e) ? this.mData.get(e) : null;
      }),
      (o.prototype.setData = function (e, t) {
        this.mData.set(e, t);
      }),
      (o.prototype.assignToNode = function (e) {
        null != e && (e[o.USERDATA_PROPERTY] = this);
      }),
      (o.prototype.clone = function () {
        return new o(this);
      }),
      (o.FromNode = function (e, t) {
        if ((void 0 === t && (t = !1), null == e)) return null;
        var i = e[o.USERDATA_PROPERTY];
        return null != i || (t && (i = new o()).assignToNode(e)), i;
      }),
      (o.GetData = function (e, t) {
        var i = o.FromNode(e, !1);
        return null != i ? i.getData(t) : null;
      }),
      (o.SetData = function (e, t, i) {
        var n = o.FromNode(e, !0);
        null != n && n.setData(t, i);
      }),
      (o.USERDATA_PROPERTY = 'egr_wcf_nodeUserData'),
      (r = o),
      (n.NodeUserData = r);
  })((egr = egr || {})),
  (function (e) {
    var h, u, m, n, t;
    function c(e, t) {
      var i = n.call(this, e, t.scene) || this;
      return (
        (i.mMatManger = t),
        (i.useRoughnessFromMetallicTextureAlpha = !1),
        (i.useRoughnessFromMetallicTextureGreen = !1),
        (i.useLinearAlphaFresnel = !0),
        (i.metallic = 1),
        (i.roughness = 1),
        (i.invertNormalMapX = !0),
        (i.invertNormalMapY = !0),
        (i.disableLighting = !0),
        (i.imageProcessingConfiguration = t.pbrImageProcessing),
        (i.reflectionTexture = i.mMatManger.getDefaultReflectionTexture()),
        i
      );
    }
    (h = e.wcf || (e.wcf = {})),
      (u = h.core || (h.core = {})),
      (m = u.mdl || (u.mdl = {})),
      (n = BABYLON.PBRMaterial),
      __extends(c, n),
      (c.prototype.dispose = function (e, t) {
        this.reflectionTexture ==
          this.mMatManger.getDefaultReflectionTexture() &&
          (this.reflectionTexture = null),
          t ||
            (m.Texture._DisposeIfCloned(this.albedoTexture),
            m.Texture._DisposeIfCloned(this.ambientTexture),
            m.Texture._DisposeIfCloned(this.bumpTexture),
            m.Texture._DisposeIfCloned(this.cameraColorGradingTexture),
            m.Texture._DisposeIfCloned(this.emissiveTexture),
            m.Texture._DisposeIfCloned(this.environmentBRDFTexture),
            m.Texture._DisposeIfCloned(this.lightmapTexture),
            m.Texture._DisposeIfCloned(this.metallicTexture),
            m.Texture._DisposeIfCloned(this.microSurfaceTexture),
            m.Texture._DisposeIfCloned(this.opacityTexture),
            m.Texture._DisposeIfCloned(this.reflectionTexture),
            m.Texture._DisposeIfCloned(this.reflectivityTexture),
            m.Texture._DisposeIfCloned(this.refractionTexture)),
          n.prototype.dispose.call(this, e, t);
      }),
      (c.prototype.clone = function (e) {
        var t = this;
        return BABYLON.SerializationHelper.Clone(function () {
          return new c(e, t.mMatManger);
        }, this);
      }),
      (c.prototype.hasFallbackTextures = function () {
        return (
          (null != this.albedoTexture &&
            !0 === this.albedoTexture.isFallback) ||
          (null != this.bumpTexture && !0 === this.bumpTexture.isFallback) ||
          (null != this.metallicTexture &&
            !0 === this.metallicTexture.isFallback) ||
          (null != this.microSurfaceTexture &&
            !0 === this.microSurfaceTexture.isFallback)
        );
      }),
      (c.prototype.replaceTexture = function (e, t) {
        this.albedoTexture === e &&
          ((this.albedoTexture = t), this.markDirty()),
          this.bumpTexture === e && ((this.bumpTexture = t), this.markDirty()),
          this.metallicTexture === e &&
            ((this.metallicTexture = t), this.markDirty()),
          this.microSurfaceTexture === e &&
            ((this.microSurfaceTexture = t), this.markDirty());
      }),
      (c.prototype.collectTextures = function (e) {
        e(this.albedoTexture),
          e(this.ambientTexture),
          e(this.bumpTexture),
          e(this.cameraColorGradingTexture),
          e(this.emissiveTexture),
          e(this.environmentBRDFTexture),
          e(this.lightmapTexture),
          e(this.metallicTexture),
          e(this.microSurfaceTexture),
          e(this.opacityTexture),
          e(this.reflectionTexture),
          e(this.reflectivityTexture),
          e(this.refractionTexture);
      }),
      (c.ConvertToPbrParameters = function (e, t, i, n, r, o, s) {
        var a,
          l,
          u = {};
        return (
          (u.metallic = c.ConvertToMetallic(r, o, s)),
          (u.roughness = c.ConvertToRoughness(i, n, r)),
          (u.albedo = e.toLinearSpace()),
          h.utils.math.eq(u.metallic, 1) &&
            !t &&
            ((a = c.ComputeLuminance(u.albedo)),
            (l = c.ComputeChroma(u.albedo)),
            a < 0.75 &&
              l < 0.1 &&
              (u.albedo = c.AdoptLuminance(u.albedo, 0.75))),
          u
        );
      }),
      (c.ConvertLinearRoughness = function (e) {
        var t = e;
        1 < t && (t = 1);
        var i = 0.2 * Math.pow(t, 0.5) * (1 - t);
        return (t = Math.pow(t, 2) + i);
      }),
      (c._Serialize = function (e, t) {
        if (null == e) throw new Error(h.utils.ERR_INVALID_ARGUMENT);
        var i,
          n = {};
        return (
          (n.id = t.id),
          (n.type = 'pbr'),
          t.name != t.id &&
            h.utils.string.isNotNullOrEmpty(t.name) &&
            (n.name = t.name),
          t.albedoColor.equalsFloats(1, 1, 1) ||
            (n.albedo = u.io.serializeColor3(t.albedoColor)),
          t.emissiveColor.equalsFloats(0, 0, 0) ||
            (n.emissive = u.io.serializeColor3(t.emissiveColor)),
          null == t.metallic ||
            h.utils.math.eq(t.metallic, 1) ||
            (n.metallic = t.metallic),
          null == t.roughness ||
            h.utils.math.eq(t.roughness, 1) ||
            (n.roughness = t.roughness),
          h.utils.math.eq(t.alpha, 1) || (n.alpha = t.alpha),
          null != t.albedoTexture &&
            null != (i = m.Texture._Serialize(e, t.albedoTexture)) &&
            (n.albedoTexture = i),
          null != t.bumpTexture &&
            null != (i = m.Texture._Serialize(e, t.bumpTexture)) &&
            (n.bumpTexture = i),
          null != t.metallicTexture &&
            null != (i = m.Texture._Serialize(e, t.metallicTexture)) &&
            ((n.metallic = void 0), (n.metallicTexture = i)),
          null != t.microSurfaceTexture &&
            null != (i = m.Texture._Serialize(e, t.microSurfaceTexture)) &&
            ((n.roughness = void 0), (n.roughnessTexture = i)),
          n
        );
      }),
      (c._Deserialize = function (e, t, i) {
        if (null == e.type || 'std' === e.type)
          return c.DeserializeLegacyMaterial(e, t, i);
        if (null == t) throw new Error(h.utils.ERR_INVALID_ARGUMENT);
        var n = new c(e.id, i);
        return (
          null != e.name && (n.name = e.name),
          null != e.albedo &&
            (n.albedoColor = u.io.deserializeColor3(e.albedo)),
          null != e.emissive &&
            (n.emissiveColor = u.io.deserializeColor3(e.emissive)),
          null != e.metallic ? (n.metallic = e.metallic) : (n.metallic = 1),
          null != e.roughness ? (n.roughness = e.roughness) : (n.roughness = 1),
          null != e.alpha && (n.alpha = e.alpha),
          null != e.albedoTexture &&
            ((n.albedoTexture = m.Texture._Deserialize(e.albedoTexture, t, i)),
            null != n.albedoTexture &&
              n.albedoTexture.hasAlpha &&
              (n.useAlphaFromAlbedoTexture = !0)),
          null != e.bumpTexture &&
            ((n.bumpTexture = m.Texture._Deserialize(e.bumpTexture, t, i)),
            null != n.bumpTexture && (n.forceIrradianceInFragment = !0)),
          null != e.metallicTexture &&
            (n.metallicTexture = m.Texture._Deserialize(
              e.metallicTexture,
              t,
              i
            )),
          null != e.roughnessTexture &&
            (n.microSurfaceTexture = m.Texture._Deserialize(
              e.roughnessTexture,
              t,
              i
            )),
          n.freeze(),
          n
        );
      }),
      (c.DeserializeLegacyMaterial = function (e, t, i) {
        if (null == t) throw new Error(h.utils.ERR_INVALID_ARGUMENT);
        var n = new c(e.id, i);
        null != e.name && (n.name = e.name);
        var r = BABYLON.Color3.White();
        null != e.diffuse && (r = u.io.deserializeColor3(e.diffuse));
        var o = BABYLON.Color3.Black();
        null != e.specular && (o = u.io.deserializeColor3(e.specular)),
          null != e.emissive &&
            (n.emissiveColor = u.io.deserializeColor3(e.emissive));
        var s = 30;
        null != e.shininess && (s = e.shininess);
        var a = 0;
        null != e.reflectivity && (a = e.reflectivity),
          null != e.alpha && (n.alpha = e.alpha),
          null != e.diffuseTexture &&
            ((n.albedoTexture = m.Texture._Deserialize(e.diffuseTexture, t, i)),
            null != n.albedoTexture &&
              n.albedoTexture.hasAlpha &&
              (n.useAlphaFromAlbedoTexture = !0)),
          null != e.bumpTexture &&
            ((n.bumpTexture = m.Texture._Deserialize(e.bumpTexture, t, i)),
            null != n.bumpTexture && (n.forceIrradianceInFragment = !0));
        var l = c.ConvertToPbrParameters(
          r,
          null != n.albedoTexture,
          o,
          s,
          a,
          n.alpha
        );
        return (
          (n.albedoColor = l.albedo),
          (n.metallic = l.metallic),
          (n.roughness = l.roughness),
          n.freeze(),
          n
        );
      }),
      (c.ConvertToMetallic = function (e, t, i) {
        if (null != i && 'common' !== i) {
          if ('metal' === i || 'metal_polished' === i) return 1;
          if ('glass' === i || 'glass_translucent' === i || 'illuminant' === i)
            return 0;
        }
        return 0.3 <= e && h.utils.math.eq(t, 1) ? 1 : 0;
      }),
      (c.ConvertToRoughness = function (e, t, i) {
        if (h.utils.math.eq(t, 0)) return c.MAX_CONVERTED_ROUGHNESS;
        var n,
          r = 0,
          o = 0.25 + 0.75 * h.utils.math.clamp((t - 1) / 127, 0, 1);
        i <= 0.01 &&
          ((n = c.ComputeLuminance(e)),
          (o *= 1 - Math.pow(1 - n, 4)),
          (r = 0.15));
        var s = r + Math.pow(1 - o, 2) * (c.MAX_CONVERTED_ROUGHNESS - r);
        return c.ConvertLinearRoughness(s);
      }),
      (c.ComputeLuminance = function (e) {
        return 0.2126729 * e.r + 0.7151522 * e.g + 0.072175 * e.b;
      }),
      (c.ComputeChroma = function (e) {
        return Math.max(e.r, e.g, e.b) - Math.min(e.r, e.g, e.b);
      }),
      (c.AdoptLuminance = function (e, t) {
        var i = c.ComputeLuminance(e);
        if (t === i) return e;
        if (t < i) return e.scale(t / i);
        var n = (t - i) / (1 - i),
          r = e.scale(1 - n);
        return r.addToRef(new BABYLON.Color3(n, n, n), r), r;
      }),
      (c.MAX_CONVERTED_ROUGHNESS = 0.7),
      (t = c),
      (m.PbrMaterial = t);
  })((egr = egr || {})),
  (function (e) {
    var n, t, i, r;
    function o() {
      (this.mCache = new Map()), (this.onDisposeResource = null);
    }
    (n = e.wcf || (e.wcf = {})),
      (t = n.core || (n.core = {})),
      (i = t.mdl || (t.mdl = {})),
      (o.prototype.has = function (e) {
        return this.mCache.has(e);
      }),
      (o.prototype.add = function (e, t) {
        return (
          !n.utils.string.isNullOrEmpty(e) &&
          (this.mCache.set(e, { data: t, lastUsed: Date.now() }), !0)
        );
      }),
      (o.prototype.get = function (e) {
        if (n.utils.string.isNullOrEmpty(e)) return null;
        var t = this.mCache.get(e);
        return null != t ? ((t.lastUsed = Date.now()), t.data) : null;
      }),
      (o.prototype.remove = function (e, t) {
        return (
          void 0 === t && (t = !0),
          !n.utils.string.isNullOrEmpty(e) &&
            (!t ||
              null == this.onDisposeResource ||
              (null != (i = this.mCache.get(e)) &&
                this.onDisposeResource(i.data, !1)),
            this.mCache.delete(e))
        );
        var i;
      }),
      (o.prototype.forEach = function (n) {
        this.mCache.forEach(function (e, t, i) {
          n(t, e.data);
        });
      }),
      (o.prototype.clear = function (e) {
        var t = this;
        void 0 === e && (e = !0),
          e &&
            null != this.onDisposeResource &&
            this.mCache.forEach(function (e) {
              return t.onDisposeResource(e.data, !0);
            }),
          this.mCache.clear();
      }),
      (o.prototype.removeUnused = function (n, r, o) {
        var s,
          a = this;
        void 0 === o && (o = !0),
          null != n &&
            ((s = Date.now()),
            this.mCache.forEach(function (e, t, i) {
              n.has(t) || (s - e.lastUsed > r && a.remove(t, o));
            }));
      }),
      (r = o),
      (i.ResourceCache = r);
  })((egr = egr || {})),
  (function (e) {
    var P, g;
    (P = e.wcf || (e.wcf = {})),
      (function (e) {
        var t;
        ((t = e.PropertyMergeMode || (e.PropertyMergeMode = {}))[
          (t.Intersection = 0)
        ] = 'Intersection'),
          (t[(t.Union = 1)] = 'Union');
        var i =
          (Object.defineProperty(C.prototype, 'providers', {
            get: function () {
              return this.mProviders;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(C.prototype, 'mergeMode', {
            get: function () {
              return this.mMergeMode;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (C.prototype.setProviders = function (e) {
            this.deregisterProviderEvents(),
              (this.mProviders =
                null == e ? new Array() : P.utils.array.clone(e)),
              this.registerProviderEvents(),
              this.propertiesChanged(3);
          }),
          (C.prototype.setMergeMode = function (e) {
            this.mMergeMode !== e &&
              ((this.mMergeMode = e), this.propertiesChanged(2));
          }),
          (C.prototype.getProperties = function (e) {
            var t = this;
            return this.updatePropertyList(e).then(function () {
              return t.mProperties;
            });
          }),
          (C.prototype.getPropertyClasses = function (e) {
            var t = this;
            return this.updatePropertyList(e).then(function () {
              return t.mPropertyClasses;
            });
          }),
          (C.prototype.getPropertyChoices = function (e, t) {
            return this.internalGetPropertyChoices(this.getSubProperties(e), t);
          }),
          (C.prototype.beginPropertyChange = function () {
            this.mPropertyChangeDepth++;
          }),
          (C.prototype.endPropertyChange = function () {
            this.mPropertyChangeDepth--,
              this.mPropertyChangeDepth <= 0 &&
                (this.mPropertyChangeDepth = 0) !==
                  this.mPropertyChangedState &&
                this.propertiesChanged(this.mPropertyChangedState);
          }),
          (C.prototype.setPropertyValueUndoable = function (e, t, i) {
            return this.setPropertyValue(e, t, !0, i);
          }),
          (C.prototype.isPropertyValueUndetermined = function (e) {
            this.updatePropertyValues();
            var t = this.mPropertyValueMap.get(e.key);
            return null != t && t.undetermined;
          }),
          (C.prototype.beginSetPropertyValue = function () {
            null != this.mApp && this.mApp.commands.beginUndoSection(),
              this.beginPropertyChange();
          }),
          (C.prototype.endSetPropertyValue = function () {
            this.endPropertyChange(),
              null != this.mApp && this.mApp.commands.endUndoSection();
          }),
          (C.prototype.finalizeSetPropertyValue = function () {
            return Promise.resolve();
          }),
          (C.prototype.propertiesChanged = function (e) {
            0 !== e &&
              ((this.mPropertyValuesNeedUpdate = !0),
              1 < e && (this.mPropertyListNeedsUpdate = !0),
              e > this.mPropertyChangedState &&
                (this.mPropertyChangedState = e)),
              0 === this.mPropertyChangeDepth &&
                (this.eventPropertiesChanged.trigger(
                  this.mPropertyChangedState
                ),
                (this.mPropertyChangedState = 0));
          }),
          (C.prototype.registerProviderEvents = function () {
            for (var e = 0, t = this.mProviders; e < t.length; e++)
              t[e].eventPropertiesChanged.addListener(this.onPropertiesChanged);
          }),
          (C.prototype.deregisterProviderEvents = function () {
            for (var e = 0, t = this.mProviders; e < t.length; e++)
              t[e].eventPropertiesChanged.removeListener(
                this.onPropertiesChanged
              );
          }),
          (C.prototype.updatePropertyList = function (i) {
            var n = this;
            if (null != this.mPropertyListPromise)
              return this.mPropertyListPromise;
            if (!this.mPropertyListNeedsUpdate) return Promise.resolve();
            this.clearPropertyList();
            var r = {
              properties: new Array(),
              classes: new Array(),
              addedClasses: new Set(),
            };
            this.mPropertyListNeedsUpdate = !1;
            var o = this.mProviders.length,
              s = 0,
              a = !1,
              l = !1;
            return (
              null != i && 0 < o && (a = !i(s, o)),
              (this.mPropertyListPromise = P.utils.async
                .forEachParallel(
                  this.mProviders,
                  function (e, t) {
                    return __awaiter(n, void 0, void 0, function () {
                      return __generator(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return a || l
                              ? [2]
                              : [4, this.addProviderClasses(t, r)];
                          case 1:
                            return (
                              e.sent(), [4, this.addProviderProperties(t, r)]
                            );
                          case 2:
                            return (
                              e.sent(),
                              s++,
                              null != i && (a = a || !i(s, o)),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  C.MAX_CONCURRENT_TASKS
                )
                .then(function () {
                  return (
                    (n.mPropertyListPromise = null),
                    n.mPropertyListNeedsUpdate
                      ? n.updatePropertyList()
                      : (n.buildPropertyList(r), Promise.resolve())
                  );
                })
                .catch(function (e) {
                  return (
                    (l = !0),
                    (n.mPropertyListPromise = null),
                    n.clearPropertyList(),
                    Promise.reject(e)
                  );
                })),
              this.mPropertyListPromise
            );
          }),
          (C.prototype.updatePropertyValues = function () {
            if (this.mPropertyValuesNeedUpdate) {
              this.mPropertyValuesNeedUpdate = !1;
              for (var e = 0, t = this.mProperties; e < t.length; e++) {
                var i = t[e],
                  n = this.mPropertyMap.get(i.key);
                if (null != n) {
                  for (
                    var r = n[0].getValue(), o = !0, s = 1;
                    s < n.length;
                    ++s
                  )
                    if (!n[s].isValueEqual(r)) {
                      o = !1;
                      break;
                    }
                  o
                    ? this.mPropertyValueMap.set(i.key, {
                        value: r,
                        undetermined: !1,
                      })
                    : this.mPropertyValueMap.set(i.key, {
                        value: null,
                        undetermined: !0,
                      });
                }
              }
            }
          }),
          (C.prototype.clearPropertyList = function () {
            (this.mProperties = new Array()),
              (this.mPropertyClasses = new Array()),
              (this.mPropertyMap = new Map()),
              (this.mPropertyValueMap = new Map());
          }),
          (C.prototype.addProviderClasses = function (e, r) {
            return e.getPropertyClasses().then(function (e) {
              if (null != e)
                for (var t = 0, i = e; t < i.length; t++) {
                  var n = i[t];
                  r.addedClasses.has(n.key) ||
                    (r.addedClasses.add(n.key), r.classes.push(n));
                }
            });
          }),
          (C.prototype.addProviderProperties = function (e, o) {
            var s = this;
            return e.getProperties().then(function (e) {
              if (null != e)
                for (var t = 0, i = e; t < i.length; t++) {
                  var n = i[t],
                    r = s.mPropertyMap.get(n.key);
                  null == r &&
                    ((r = new Array()),
                    s.mPropertyMap.set(n.key, r),
                    o.properties.push(n.key)),
                    r.push(n);
                }
            });
          }),
          (C.prototype.buildPropertyList = function (e) {
            for (
              var t = new Set(),
                i = this.mProviders.length,
                n = 0,
                r = e.properties;
              n < r.length;
              n++
            ) {
              var o,
                s = r[n],
                a = this.mPropertyMap.get(s);
              null != a &&
                ((a.length !== i && 1 !== this.mMergeMode) ||
                  (null != (o = this.buildProperty(s, a)) &&
                    null != o.class &&
                    t.add(o.class)));
            }
            (this.mPropertyValuesNeedUpdate = !0), this.updatePropertyValues();
            for (var l = 0, u = e.classes; l < u.length; l++) {
              var h = u[l];
              t.has(h.key) && this.mPropertyClasses.push(h);
            }
          }),
          (C.prototype.buildProperty = function (e, t) {
            var i = this;
            if (null == t || 0 === t.length) return null;
            var n = t[0].clone();
            n._setProvider(this),
              (n[C.SUB_PROPERTIES] = t),
              (n.undoable = !1),
              (n.setValue = function (e) {
                return i.setPropertyValue(n, e, !1);
              }),
              (n.getValue = function () {
                return i.getPropertyValue(e);
              }),
              (n.getChoices = function () {
                return i.internalGetPropertyChoices(t);
              });
            for (var r = 0, o = t; r < o.length; r++) {
              var s = o[r];
              s.editable || (n.editable = !1),
                s.visible || (n.visible = !1),
                s.undoable || (n.undoable = !1);
            }
            return this.mProperties.push(n), n;
          }),
          (C.prototype.setPropertyValue = function (c, p, d, f) {
            return __awaiter(this, void 0, void 0, function () {
              var t,
                o,
                s,
                a,
                l,
                i,
                n,
                r,
                u,
                h,
                m = this;
              return __generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    if (null == c)
                      throw new Error(P.utils.ERR_INVALID_ARGUMENT);
                    (t = this.getSubProperties(c)), (e.label = 1);
                  case 1:
                    return (
                      e.trys.push([1, , 4, 5]),
                      this.beginSetPropertyValue(),
                      (o = t.length),
                      (s = 0),
                      (l = a = !1),
                      null != f && 0 < o && (a = !f(s, o)),
                      [
                        4,
                        P.utils.async.forEachParallel(
                          t,
                          function (e, r) {
                            return __awaiter(m, void 0, void 0, function () {
                              var t, i, n;
                              return __generator(this, function (e) {
                                switch (e.label) {
                                  case 0:
                                    if (((t = 0), a || l)) return [2, t];
                                    e.label = 1;
                                  case 1:
                                    return (
                                      e.trys.push([1, 6, , 7]),
                                      d && null != this.mApp
                                        ? ((i = new g.cmd.SetPropertyValue(
                                            this.mApp,
                                            r,
                                            p
                                          )),
                                          [
                                            4,
                                            this.mApp.commands.executeCommand(
                                              i
                                            ),
                                          ])
                                        : [3, 3]
                                    );
                                  case 2:
                                    return e.sent(), (t = i.lastResult), [3, 5];
                                  case 3:
                                    return [4, r.setValue(p)];
                                  case 4:
                                    (t = e.sent()), (e.label = 5);
                                  case 5:
                                    return [3, 7];
                                  case 6:
                                    throw ((n = e.sent()), (l = !0), n);
                                  case 7:
                                    return (
                                      s++,
                                      null != f && (a = a || !f(s, o)),
                                      [2, t]
                                    );
                                }
                              });
                            });
                          },
                          C.MAX_CONCURRENT_SET_PROPVALUE
                        ),
                      ]
                    );
                  case 2:
                    if (((i = e.sent()), (n = 0), null != i))
                      for (r = 0, u = i; r < u.length; r++)
                        (h = u[r]), n < h && (n = h);
                    return [4, this.finalizeSetPropertyValue()];
                  case 3:
                    return e.sent(), [2, n];
                  case 4:
                    return this.endSetPropertyValue(), [7];
                  case 5:
                    return [2];
                }
              });
            });
          }),
          (C.prototype.getPropertyValue = function (e) {
            if (null != this.mPropertyListPromise) return null;
            this.updatePropertyValues();
            var t = this.mPropertyValueMap.get(e);
            return null != t ? t.value : null;
          }),
          (C.prototype.internalGetPropertyChoices = function (A, w) {
            return __awaiter(this, void 0, void 0, function () {
              var r,
                o,
                s,
                a,
                t,
                i,
                n,
                l,
                u,
                h,
                m,
                c,
                p,
                d,
                f,
                g,
                v,
                y = this;
              return __generator(this, function (e) {
                switch (e.label) {
                  case 0:
                    return 0 === A.length
                      ? [2, null]
                      : ((r = A.length),
                        (o = 0),
                        (a = s = !1),
                        null != w && 0 < r && (s = !w(o, r)),
                        s || !A[0].choiceList
                          ? [2, null]
                          : 1 === A.length
                          ? [2, A[0].getChoices()]
                          : [
                              4,
                              P.utils.async.forEachParallel(
                                A,
                                function (e, n) {
                                  return __awaiter(
                                    y,
                                    void 0,
                                    void 0,
                                    function () {
                                      var t, i;
                                      return __generator(this, function (e) {
                                        switch (e.label) {
                                          case 0:
                                            if (((t = null), s || a))
                                              return [2, t];
                                            e.label = 1;
                                          case 1:
                                            return (
                                              e.trys.push([1, 3, , 4]),
                                              [4, n.getChoices()]
                                            );
                                          case 2:
                                            return (t = e.sent()), [3, 4];
                                          case 3:
                                            throw ((i = e.sent()), (a = !0), i);
                                          case 4:
                                            return (
                                              o++,
                                              null != w && (s = s || !w(o, r)),
                                              [2, t]
                                            );
                                        }
                                      });
                                    }
                                  );
                                },
                                C.MAX_CONCURRENT_TASKS
                              ),
                            ]);
                  case 1:
                    if (((t = e.sent()), s || null == t)) return [2, null];
                    for (
                      i = new Array(), n = new Map(), l = 0, u = t;
                      l < u.length;
                      l++
                    )
                      if (null != (h = u[l]))
                        for (m = 0, c = h; m < c.length; m++)
                          (g = c[m]),
                            null == (v = n.get(g.value))
                              ? (i.push(g), n.set(g.value, 1))
                              : n.set(g.value, v + 1);
                    for (p = new Array(), d = 0, f = i; d < f.length; d++)
                      (g = f[d]),
                        (v = n.get(g.value)) === A.length && p.push(g);
                    return [2, p];
                }
              });
            });
          }),
          (C.prototype.getSubProperties = function (e) {
            var t = e[C.SUB_PROPERTIES];
            return null == t && (t = [e]), t;
          }),
          (C.SUB_PROPERTIES = 'MultiPropertyProvider_subProperties'),
          (C.MAX_CONCURRENT_TASKS = 10),
          (C.MAX_CONCURRENT_SET_PROPVALUE = 5),
          C);
        function C(e) {
          var t = this;
          (this.eventPropertiesChanged = new P.utils.ListenableEvent(this)),
            (this.onPropertiesChanged = function (e) {
              null != e && t.propertiesChanged(e);
            }),
            (this.mApp = e),
            (this.mProviders = new Array()),
            (this.mMergeMode = 0),
            this.clearPropertyList(),
            (this.mPropertyListNeedsUpdate = !0),
            (this.mPropertyValuesNeedUpdate = !0),
            (this.mPropertyChangeDepth = 0),
            (this.mPropertyChangedState = 0),
            (this.mPropertyListPromise = null);
        }
        e.MultiPropertyProvider = i;
      })((g = P.core || (P.core = {})).prop || (g.prop = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r, o;
    function s() {
      return (null !== r && r.apply(this, arguments)) || this;
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.mdl || (i.mdl = {})),
      (r = i.prop.MultiPropertyProvider),
      __extends(s, r),
      (s.prototype.beginSetPropertyValue = function () {
        null != this.mApp && this.mApp.model.beginModification(),
          r.prototype.beginSetPropertyValue.call(this);
      }),
      (s.prototype.endSetPropertyValue = function () {
        r.prototype.endSetPropertyValue.call(this),
          null != this.mApp && this.mApp.model.endModification();
      }),
      (o = s),
      (n.SelectionPropertyProvider = o);
  })((egr = egr || {})),
  (function (e) {
    var o, t, i, a, n;
    function r(e, t, i, n, r, o) {
      void 0 === r && (r = BABYLON.Texture.TRILINEAR_SAMPLINGMODE),
        void 0 === o && (o = BABYLON.Engine.TEXTUREFORMAT_RGB);
      var s = a.call(this, e, t, !1, !0, r, i, n, null, !1, o) || this;
      return (
        (s.mTextureMatrix = null),
        (s.mIsClone = !1),
        (s.isResource = !1),
        (s.isFallback = !1),
        (s.id = ''),
        s
      );
    }
    (o = e.wcf || (e.wcf = {})),
      (t = o.core || (o.core = {})),
      (i = t.mdl || (t.mdl = {})),
      (a = BABYLON.Texture),
      __extends(r, a),
      Object.defineProperty(r.prototype, 'isClone', {
        get: function () {
          return this.mIsClone;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.notifyTextureMatrixChanged = function () {
        this.mTextureMatrix = null;
      }),
      (r.prototype.getTextureMatrix = function () {
        var e, t, i, n;
        return (
          null == this.mTextureMatrix &&
            ((e = BABYLON.Matrix.Scaling(this.uScale, this.vScale, 1)),
            (t = BABYLON.Matrix.RotationYawPitchRoll(
              this.vAng,
              this.uAng,
              this.wAng
            )),
            (i = BABYLON.Matrix.Identity()).setRowFromFloats(
              2,
              this.uOffset,
              this.vOffset,
              i.m[10],
              i.m[11]
            ),
            (n = e),
            t.multiplyToRef(n, n),
            i.multiplyToRef(n, n),
            (this.mTextureMatrix = n)),
          this.mTextureMatrix
        );
      }),
      (r.prototype.clone = function () {
        var e = this,
          t = BABYLON.SerializationHelper.Clone(function () {
            return new r(
              e.url,
              e.getScene(),
              void 0,
              void 0,
              e.samplingMode,
              null == e._format ? BABYLON.Engine.TEXTUREFORMAT_RGB : e._format
            );
          }, this);
        return (
          (t.mIsClone = !0),
          (t.isResource = this.isResource),
          (t.isFallback = this.isFallback),
          (t.id = this.id),
          t
        );
      }),
      (r._DisposeIfCloned = function (e) {
        null != e && e instanceof r && e.isClone && e.dispose();
      }),
      (r._Serialize = function (e, t) {
        if (null == e) throw new Error(o.utils.ERR_INVALID_ARGUMENT);
        if (!(t instanceof r && t.isResource)) return null;
        var i = {};
        return (
          (i.texture = e.addTexture(t.id)),
          (o.utils.math.eq(t.uOffset, 0) && o.utils.math.eq(t.vOffset, 0)) ||
            (i.offset = [t.uOffset, t.vOffset]),
          (o.utils.math.eq(t.uScale, 1) && o.utils.math.eq(t.vScale, 1)) ||
            (i.scale = [t.uScale, t.vScale]),
          (o.utils.math.eq(t.uAng, 0) &&
            o.utils.math.eq(t.vAng, 0) &&
            o.utils.math.eq(t.wAng, 0)) ||
            (i.rotation = [t.uAng, t.vAng, t.wAng]),
          i
        );
      }),
      (r._Deserialize = function (e, t, i) {
        if (null == t) throw new Error(o.utils.ERR_INVALID_ARGUMENT);
        var n = t.getTextureIdByIndex(e.texture);
        if (null == n) return null;
        var r = i.getTexture(n);
        return null == r
          ? null
          : ((null == e.offset && null == e.scale && null == e.rotation) ||
              ((r = r.clone()),
              null != e.offset &&
                ((r.uOffset = e.offset[0]), (r.vOffset = e.offset[1])),
              null != e.scale &&
                ((r.uScale = e.scale[0]), (r.vScale = e.scale[1])),
              null != e.rotation &&
                ((r.uAng = e.rotation[0]),
                (r.vAng = e.rotation[1]),
                (r.wAng = e.rotation[2])),
              r.notifyTextureMatrixChanged()),
            r);
      }),
      (n = r),
      (i.Texture = n);
  })((egr = egr || {})),
  (function (e) {
    var n, t, i, r, o, s, a;
    function l() {}
    (n = e.wcf || (e.wcf = {})),
      (t = n.core || (n.core = {})),
      (i = t.mdl || (t.mdl = {})),
      (r = i.io || (i.io = {})),
      (l.ImportFromUrl = function (t, i) {
        return n.utils.string.isNullOrEmpty(t)
          ? Promise.resolve(null)
          : n.utils.string.getFileExtension(t).toLowerCase() !==
            l.BINARY_GLTF_EXTENSION
          ? n.utils.async.ajax('GET', t).then(function (e) {
              return new r.GltfMeshImport(i).importGltf(JSON.parse(e), t);
            })
          : r.GltfMeshImport.LoadArrayBuffer(t).then(function (e) {
              return new r.GltfMeshImport(i).importBinaryGltf(e);
            });
      }),
      (l.Import = function (e, t) {
        return null == e ? null : new r.GltfMeshImport(t).importBinaryGltf(e);
      }),
      (l.Export = function (e) {
        return null == e || null == e.geometry
          ? null
          : new r.GltfMeshExport(e).exportMesh();
      }),
      (l.GLTF_MIME_TYPE = 'model/gltf+json'),
      (l.GLTF_EXTENSION = '.gltf'),
      (l.BINARY_GLTF_MIME_TYPE = 'model/gltf.binary'),
      (l.BINARY_GLTF_EXTENSION = '.glb'),
      (l._GLTF_HEADER_MAGIC = 1179937895),
      (a = l),
      (r.GltfMesh = a),
      (o = r.GltfTypes || (r.GltfTypes = {})),
      ((s = o.ComponentType || (o.ComponentType = {}))[(s.BYTE = 5120)] =
        'BYTE'),
      (s[(s.UNSIGNED_BYTE = 5121)] = 'UNSIGNED_BYTE'),
      (s[(s.SHORT = 5122)] = 'SHORT'),
      (s[(s.UNSIGNED_SHORT = 5123)] = 'UNSIGNED_SHORT'),
      (s[(s.UNSIGNED_INT = 5125)] = 'UNSIGNED_INT'),
      (s[(s.FLOAT = 5126)] = 'FLOAT');
  })((egr = egr || {})),
  (function (e) {
    var m, t, i, c, n;
    function r(e) {
      (this.mMesh = e),
        (this.mUse32BitIndices = !1),
        (this.mPositionsAcc = -1),
        (this.mNormalsAcc = -1),
        (this.mTexCoordsAcc = -1),
        (this.mIndicesAcc = -1),
        (this.mPositionsByteLength = 0),
        (this.mNormalsByteLength = 0),
        (this.mTexCoordsByteLength = 0),
        (this.mIndicesByteLength = 0),
        (this.mMeshByteLength = 0);
    }
    (m = e.wcf || (e.wcf = {})),
      (t = m.core || (m.core = {})),
      (i = t.mdl || (t.mdl = {})),
      (c = i.io || (i.io = {})),
      (r.prototype.exportMesh = function () {
        if (!this.prepareMeshData()) return null;
        (this.mGltf = {}),
          (this.mGltf.asset = {}),
          (this.mGltf.asset.version = '2.0'),
          (this.mGltf.asset.generator = 'W-CF'),
          this.createBuffersAndViews(),
          this.createAccessors(),
          this.createMeshes();
        var e = this.getGltfJson();
        return null == e ? null : this.writeBinaryGltf(e);
      }),
      (r.prototype.stringToUint8Array = function (e) {
        for (
          var t = e.length, i = new Uint8Array(new ArrayBuffer(t)), n = 0;
          n < t;
          n++
        )
          i[n] = e.charCodeAt(n);
        return i;
      }),
      (r.prototype.negateZComponent = function (e) {
        if (null == e) return null;
        for (var t = Float32Array.from(e), i = 0; i < t.length; i += 3)
          t[i + 2] = -t[i + 2];
        return t;
      }),
      (r.prototype.prepareMeshData = function () {
        return (
          (this.mPositions = this.negateZComponent(
            this.mMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind, !1)
          )),
          !(
            null == this.mPositions ||
            this.mPositions.length < 3 ||
            ((this.mPositionsByteLength = 4 * this.mPositions.length),
            (this.mUse32BitIndices = 65535 < this.mPositions.length / 3),
            (this.mNormals = this.negateZComponent(
              this.mMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind, !1)
            )),
            (this.mNormalsByteLength =
              null == this.mNormals ? 0 : 4 * this.mNormals.length),
            (this.mTexCoords = this.mMesh.getVerticesData(
              BABYLON.VertexBuffer.UVKind,
              !1
            )),
            (this.mTexCoordsByteLength =
              null == this.mTexCoords ? 0 : 4 * this.mTexCoords.length),
            (this.mIndices = this.mMesh.getIndices(!1)),
            (this.mIndicesByteLength =
              null == this.mIndices ? 0 : this.mIndices.length),
            this.mUse32BitIndices
              ? (this.mIndicesByteLength *= 4)
              : (this.mIndicesByteLength *= 2),
            (this.mMeshByteLength =
              this.mPositionsByteLength +
              this.mNormalsByteLength +
              this.mTexCoordsByteLength +
              this.mIndicesByteLength),
            0)
          )
        );
      }),
      (r.prototype.createBuffersAndViews = function () {
        var e = {};
        (e.byteLength = this.mMeshByteLength), (this.mGltf.buffers = [e]);
        var t = { buffer: 0, byteOffset: 0 };
        (t.byteLength = this.mMeshByteLength), (this.mGltf.bufferViews = [t]);
      }),
      (r.prototype.createAccessors = function () {
        var e,
          t,
          i = 0;
        (this.mGltf.accessors = new Array()),
          null != this.mPositions &&
            (((e = { bufferView: 0 }).byteOffset = i),
            (e.componentType = 5126),
            (e.type = 'VEC3'),
            (e.count = this.mPositions.length / 3),
            this.mGltf.accessors.push(e),
            (this.mPositionsAcc = this.mGltf.accessors.length - 1),
            (i += this.mPositionsByteLength)),
          null != this.mNormals &&
            (((t = { bufferView: 0 }).byteOffset = i),
            (t.componentType = 5126),
            (t.type = 'VEC3'),
            (t.count = this.mNormals.length / 3),
            this.mGltf.accessors.push(t),
            (this.mNormalsAcc = this.mGltf.accessors.length - 1),
            (i += this.mNormalsByteLength)),
          null != this.mTexCoords &&
            (((t = { bufferView: 0 }).byteOffset = i),
            (t.componentType = 5126),
            (t.type = 'VEC2'),
            (t.count = this.mTexCoords.length / 2),
            this.mGltf.accessors.push(t),
            (this.mTexCoordsAcc = this.mGltf.accessors.length - 1),
            (i += this.mTexCoordsByteLength)),
          null != this.mIndices &&
            (((t = { bufferView: 0 }).byteOffset = i),
            (t.componentType = this.mUse32BitIndices ? 5125 : 5123),
            (t.type = 'SCALAR'),
            (t.count = this.mIndices.length),
            this.mGltf.accessors.push(t),
            (this.mIndicesAcc = this.mGltf.accessors.length - 1),
            (i += this.mIndicesByteLength));
      }),
      (r.prototype.createMeshes = function () {
        var e = { attributes: {} };
        (e.attributes.POSITION = this.mPositionsAcc),
          null != this.mNormals && (e.attributes.NORMAL = this.mNormalsAcc),
          null != this.mTexCoords &&
            (e.attributes.TEXCOORD_0 = this.mTexCoordsAcc),
          null != this.mIndices && (e.indices = this.mIndicesAcc);
        var t = {};
        (t.primitives = [e]), (this.mGltf.meshes = [t]);
      }),
      (r.prototype.getGltfJson = function () {
        try {
          return t.io.stringifyToJson(this.mGltf);
        } catch (e) {
          m.utils.Log.error('Failed to create gltf json: ', e);
        }
        return null;
      }),
      (r.prototype.writeBinaryGltf = function (e) {
        try {
          var t = e,
            i = 4 - (t.length % 4);
          if (4 != i) for (var n = 0; n < i; ++n) t += ' ';
          var r = this.stringToUint8Array(t),
            o = r.byteLength,
            s = 12;
          (s += o + 8), (s += this.mMeshByteLength + 8);
          var a = new ArrayBuffer(s),
            l = new Uint32Array(a, 0, 5);
          (l[0] = c.GltfMesh._GLTF_HEADER_MAGIC), (l[1] = 2), (l[2] = s);
          var u = 12;
          (l[3] = o),
            (l[4] = 1313821514),
            (u += 8),
            new Uint8Array(a, u, r.length).set(r),
            (u += o);
          var h = new Uint32Array(a, u, 2);
          return (
            (h[0] = this.mMeshByteLength),
            (h[1] = 5130562),
            (u += 8),
            null != this.mPositions &&
              (new Float32Array(a, u, this.mPositions.length).set(
                this.mPositions
              ),
              (u += this.mPositionsByteLength)),
            null != this.mNormals &&
              (new Float32Array(a, u, this.mNormals.length).set(this.mNormals),
              (u += this.mNormalsByteLength)),
            null != this.mTexCoords &&
              (new Float32Array(a, u, this.mTexCoords.length).set(
                this.mTexCoords
              ),
              (u += this.mTexCoordsByteLength)),
            null != this.mIndices &&
              (new (this.mUse32BitIndices ? Uint32Array : Uint16Array)(
                a,
                u,
                this.mIndices.length
              ).set(this.mIndices),
              (u += this.mIndicesByteLength)),
            a
          );
        } catch (e) {
          m.utils.Log.error('Failed to write gltf arraybuffer: ', e);
        }
        return null;
      }),
      (n = r),
      (c.GltfMeshExport = n);
  })((egr = egr || {})),
  (function (e) {
    var s, t, i, a, n;
    function r(e) {
      var n = this;
      (this.onBufferLoaded = function (e, t) {
        var i;
        null != t && null != n.mArrayBuffers
          ? (null != (i = n.mGltf.buffers[e].byteLength) &&
              t.byteLength != i &&
              s.utils.Log.warn(
                'Buffer ' +
                  e +
                  ' has length ' +
                  t.byteLength +
                  '. Expected: ' +
                  i
              ),
            (n.mArrayBuffers[e] = t))
          : s.utils.Log.warn('Failed to load buffer ' + e);
      }),
        (this.mScene = e),
        (this.mConvertToLeftHanded = !0),
        (this.mIsVersion1 = !1),
        (this.mRootUrl = ''),
        (this.mArrayBuffers = null),
        (this.mBinaryGltfOffset = 0);
    }
    (s = e.wcf || (e.wcf = {})),
      (t = s.core || (s.core = {})),
      (i = t.mdl || (t.mdl = {})),
      (a = i.io || (i.io = {})),
      (r.prototype.importGltf = function (e, t) {
        var i = this;
        return null == e || null == t
          ? Promise.resolve(null)
          : ((this.mRootUrl = s.utils.string.getFilePath(t)),
            (this.mGltf = e),
            this.prepareLoading(),
            this.loadBuffers().then(function () {
              return i.importMeshes();
            }));
      }),
      (r.prototype.importBinaryGltf = function (e) {
        if (null == e) return null;
        var t = this.parseBinaryGltfHeader(e);
        if (null == t) throw new Error('Failed to load binary glTF');
        return (
          (this.mGltf = t.gltf),
          this.prepareLoading(),
          this.mIsVersion1
            ? (this.mArrayBuffers.KHR_binary_glTF = t.arrayBuffer)
            : this.mArrayBuffers.push(t.arrayBuffer),
          (this.mBinaryGltfOffset = t.binaryOffset),
          this.importMeshes()
        );
      }),
      (r.LoadArrayBuffer = function (e) {
        return s.utils.string.isNullOrEmpty(e)
          ? Promise.resolve(null)
          : s.utils.async.ajax('GET', e, null, { responseType: 'arraybuffer' });
      }),
      (r.prototype.prepareLoading = function () {
        (this.mIsVersion1 = !1),
          (null != this.mGltf.asset.version &&
            !this.mGltf.asset.version.startsWith('1')) ||
            (this.mIsVersion1 = !0),
          (this.mConvertToLeftHanded = !0),
          null != this.mGltf.asset.extras &&
            null != this.mGltf.asset.extras.EGR_leftHandedCS &&
            (this.mConvertToLeftHanded = !this.mGltf.asset.extras
              .EGR_leftHandedCS),
          this.mIsVersion1
            ? (this.mArrayBuffers = {})
            : (this.mArrayBuffers = new Array());
      }),
      (r.prototype.importMeshes = function () {
        var e = new Array();
        if (this.mIsVersion1)
          for (var t in this.mGltf.meshes)
            this.mGltf.meshes.hasOwnProperty(t) &&
              null != (r = this.importMesh(this.mGltf.meshes[t])) &&
              e.push(r);
        else
          for (var i = 0, n = this.mGltf.meshes; i < n.length; i++) {
            var r,
              o = n[i];
            null != (r = this.importMesh(o)) && e.push(r);
          }
        return e;
      }),
      (r.prototype.getStringFromTypedArray = function (e, t, i) {
        for (
          var n = null != t ? t : 0,
            r = null != i ? i : e.byteLength - n,
            r = Math.min(r, e.byteLength),
            o = e.subarray(n, n + r),
            s = '',
            a = 0;
          a < o.length;
          ++a
        )
          s += String.fromCharCode(o[a]);
        return s;
      }),
      (r.prototype.parseBinaryGltfHeader = function (e) {
        var t = new Uint32Array(e, 0, 5);
        if (t[0] !== a.GltfMesh._GLTF_HEADER_MAGIC)
          return s.utils.Log.error('Not a valid binary glTF file'), null;
        var i = t[1];
        if (1 !== i && 2 !== i)
          return s.utils.Log.error('Invalid binary glTF version: ' + i), null;
        var n = t[3],
          r = 20 + n;
        1 < i && (r += 8);
        var o = this.getStringFromTypedArray(new Uint8Array(e), 20, n);
        return r % 4 == 0
          ? { gltf: JSON.parse(o), arrayBuffer: e, binaryOffset: r }
          : { gltf: JSON.parse(o), arrayBuffer: e.slice(r), binaryOffset: 0 };
      }),
      (r.prototype.loadBuffers = function () {
        var t = this,
          i = new Array();
        if (this.mIsVersion1)
          for (var e in this.mGltf.buffers)
            !(function (e) {
              i.push(function () {
                return t.loadBuffer(e);
              });
            })(e);
        else
          for (var n = 0; n < this.mGltf.buffers.length; ++n)
            !(function (e) {
              i.push(function () {
                return t.loadBuffer(e);
              });
            })(n);
        return s.utils.async
          .forEachParallel(
            i,
            function (e, t) {
              return t();
            },
            5
          )
          .then(function () {});
      }),
      (r.prototype.loadBuffer = function (e) {
        var t = this.mGltf.buffers[e];
        if (null == t)
          return Promise.reject(new Error('Buffer ' + e + ' not found'));
        if (s.utils.string.isDataUri(t.uri)) {
          var i = s.utils.arraybuffer.fromDataUri(t.uri);
          return this.onBufferLoaded(e, i), Promise.resolve();
        }
        return this.loadBufferFromUrl(e, this.mRootUrl + t.uri);
      }),
      (r.prototype.loadBufferFromUrl = function (t, e) {
        var i = this;
        return s.utils.string.isNullOrEmpty(e)
          ? Promise.resolve()
          : r.LoadArrayBuffer(e).then(function (e) {
              i.onBufferLoaded(t, e);
            });
      }),
      (r.prototype.importMesh = function (e) {
        if (null == e) return null;
        for (
          var t = new BABYLON.VertexData(), i = 0;
          i < e.primitives.length;
          i++
        ) {
          var n = 0 === i ? t : new BABYLON.VertexData(),
            r = e.primitives[i];
          if (null == r.mode || 4 === r.mode) {
            var o = r.attributes,
              s = null,
              a = null;
            for (var l in o) {
              var u,
                h,
                s = this.mGltf.accessors[o[l]],
                a = this.getBufferFromAccessor(s);
              'NORMAL' === l
                ? (n.normals = this.bufferToFloat32Array(
                    a,
                    this.mConvertToLeftHanded
                  ))
                : 'POSITION' === l
                ? (n.positions = this.bufferToFloat32Array(
                    a,
                    this.mConvertToLeftHanded
                  ))
                : -1 !== l.indexOf('TEXCOORD_') &&
                  ((u = Number(l.split('_')[1])),
                  (h = BABYLON.VertexBuffer.UVKind + (0 === u ? '' : u + 1)),
                  n.set(this.bufferToFloat32Array(a, !1), h));
            }
            if (null != r.indices)
              (s = this.mGltf.accessors[r.indices]),
                (a = this.getBufferFromAccessor(s)) instanceof Uint16Array ||
                a instanceof Uint32Array
                  ? (n.indices = a)
                  : (n.indices = new Uint32Array(a));
            else if (null != n.positions) {
              var m = n.positions.length / 3;
              n.indices = new Uint32Array(m);
              for (var c = 0; c < m; ++c) n.indices[c] = c;
            }
            0 < i && t.merge(n);
          }
        }
        var p = new BABYLON.Mesh('', this.mScene);
        return (
          new BABYLON.Geometry(
            BABYLON.Geometry.RandomId(),
            this.mScene,
            t,
            !1,
            p
          ),
          p
        );
      }),
      (r.prototype.bufferToFloat32Array = function (e, t) {
        var i = e instanceof Float32Array ? e : new Float32Array(e);
        if (t) for (var n = 0; n < i.length; n += 3) i[n + 2] = -i[n + 2];
        return i;
      }),
      (r.prototype.getByteStrideFromType = function (e) {
        if (null != e.byteStride) return e.byteStride;
        switch (e.type) {
          case 'VEC2':
            return 2;
          case 'VEC3':
            return 3;
          default:
            return 1;
        }
      }),
      (r.prototype.getBufferFromAccessor = function (e) {
        if (null == this.mArrayBuffers)
          throw new Error('undefined mArrayBuffers');
        if (null == e.bufferView) throw new Error('undefined bufferView');
        var t = this.mGltf.bufferViews[e.bufferView],
          i = this.mArrayBuffers[t.buffer],
          n = null != e.byteOffset ? e.byteOffset : 0,
          r = null != t.byteOffset ? t.byteOffset : 0,
          o = this.mBinaryGltfOffset + n + r,
          s = e.count * this.getByteStrideFromType(e);
        switch (e.componentType) {
          case 5120:
            return new Int8Array(i, o, s);
          case 5121:
            return new Uint8Array(i, o, s);
          case 5122:
            return new Int16Array(i, o, s);
          case 5123:
            return new Uint16Array(i, o, s);
          case 5125:
            return new Uint32Array(i, o, s);
          default:
            return new Float32Array(i, o, s);
        }
      }),
      (n = r),
      (a.GltfMeshImport = n);
  })((egr = egr || {})),
  (function (e) {
    var f, g, t, i, d;
    (f = e.wcf || (e.wcf = {})),
      (g = f.core || (f.core = {})),
      (t = g.mdl || (g.mdl = {})),
      (i = t.io || (t.io = {})),
      (d = new BABYLON.Vector3(1, 1, 1)),
      (i.serializeNode = function e(t, i, n, r, o) {
        if ((void 0 === r && (r = !0), null == t || null == i))
          throw new Error(f.utils.ERR_INVALID_ARGUMENT);
        var s = {};
        n.position.equalsWithEpsilon(f.utils.math.VECTOR3_ZERO) ||
          (s.position = g.io.serializeVector3(n.position));
        var a,
          l,
          u = f.utils.mesh.getRotationQuaternion(n).clone();
        if (
          (u.normalize(),
          f.utils.math.eq(u.w, 1) || (s.rotation = g.io.serializeQuaternion(u)),
          n.scaling.equalsWithEpsilon(d) ||
            (s.scale = g.io.serializeVector3(n.scaling)),
          n instanceof BABYLON.AbstractMesh &&
            ((a = t.layers.getMeshLayer(n)),
            f.utils.string.isNotNullOrEmpty(a) && (s.layer = i.addLayer(a)),
            (l = t.geometries.getMeshGeometryId(n)),
            f.utils.string.isNotNullOrEmpty(l) &&
              ((s.geometry = i.addGeometry(l)),
              null != n.material &&
                t.materials.hasMaterial(n.material.id) &&
                (s.material = i.addMaterial(n.material.id)))),
          null != o && o(n, s),
          r)
        ) {
          var h = n.getChildTransformNodes(!0);
          if (0 < h.length) {
            s.nodes = new Array();
            for (var m = 0, c = h; m < c.length; m++) {
              var p = e(t, i, c[m], r, o);
              null != p && s.nodes.push(p);
            }
          }
        }
        return s;
      }),
      (i.deserializeNode = function e(t, i, n, r, o) {
        if (null == t || null == i)
          throw new Error(f.utils.ERR_INVALID_ARGUMENT);
        var s,
          a,
          l,
          u,
          h,
          m = null,
          c =
            null != n.geometry
              ? (m = new BABYLON.Mesh('', t.scene))
              : new BABYLON.TransformNode('', t.scene);
        if (
          (null != r && (c.parent = r),
          null != n.position &&
            (c.position = g.io.deserializeVector3(n.position)),
          null != n.rotation &&
            (c.rotationQuaternion = g.io.deserializeQuaternion(n.rotation)),
          null != n.scale && (c.scaling = g.io.deserializeVector3(n.scale)),
          null != m &&
            (null != n.geometry &&
              (null == (s = i.getGeometryIdByIndex(n.geometry)) ||
                (null != (a = t.geometries.getGeometry(s)) &&
                  a.applyToMesh(m))),
            null != n.material &&
              (null == (l = i.getMaterialIdByIndex(n.material)) ||
                (null != (u = t.materials.getMaterial(l)) && (m.material = u))),
            null == n.layer ||
              (null != (h = i.getLayerNameByIndex(n.layer)) &&
                t.layers.setMeshLayer(m, h))),
          null != o && o(n, c),
          null != n.nodes)
        )
          for (var p = 0, d = n.nodes; p < d.length; p++) e(t, i, d[p], c, o);
        return c.freezeWorldMatrix(), c;
      });
  })((egr = egr || {})),
  (function (e) {
    var t, i, n;
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (((n = i.mdl || (i.mdl = {})).io || (n.io = {})).BASIC_ELEMENT_CLASSID =
        'egr.wcf.core:BasicElement');
  })((egr = egr || {})),
  (function (e) {
    var b, t;
    (b = e.wcf || (e.wcf = {})),
      (function (e) {
        var t;
        ((t = e.PropertyType || (e.PropertyType = {}))[(t.String = 0)] =
          'String'),
          (t[(t.Bool = 1)] = 'Bool'),
          (t[(t.Number = 2)] = 'Number'),
          (t[(t.Length = 3)] = 'Length'),
          (t[(t.Color3 = 4)] = 'Color3');
        var i =
          ((n.prototype.clone = function () {
            var e = new n(this.value, this.text);
            return (
              (e.smallIcon = this.smallIcon), (e.largeIcon = this.largeIcon), e
            );
          }),
          n);
        function n(e, t) {
          void 0 === e && (e = null),
            void 0 === t && (t = null),
            (this.value = e),
            (this.text = t),
            (this.smallIcon = null),
            (this.largeIcon = null);
        }
        e.PropertyValue = i;
        var r =
          ((o.prototype.getName = function () {
            return b.utils.string.isNullOrEmpty(this.name)
              ? this.key
              : this.name;
          }),
          o);
        function o(e, t) {
          void 0 === e && (e = null),
            void 0 === t && (t = null),
            (this.key = null != e ? e : ''),
            (this.name = t);
        }
        e.PropertyClass = r;
        var s =
          (Object.defineProperty(a.prototype, 'provider', {
            get: function () {
              return this.mProvider;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (a.prototype.getName = function () {
            return b.utils.string.isNullOrEmpty(this.name)
              ? this.key
              : this.name;
          }),
          (a.prototype.getValueAsString = function (e) {
            var t = void 0 === e ? this.getValue() : e;
            return null == t || null == t.value ? null : t.value.toString();
          }),
          (a.prototype.isValueEqual = function (e) {
            var t = this.getValue();
            return (
              (null == t && null == e) ||
              (null != t && null != e && t.value === e.value)
            );
          }),
          (a.prototype._setProvider = function (e) {
            null != e && (this.mProvider = e);
          }),
          (a.prototype.copyFrom = function (e) {
            (e.class = this.class),
              (e.key = this.key),
              (e.name = this.name),
              (e.mProvider = this.provider),
              (e.editable = this.editable),
              (e.visible = this.visible),
              (e.undoable = this.undoable),
              (e.choiceList = this.choiceList),
              (e.allowCustomChoice = this.allowCustomChoice),
              (e.userData = this.userData),
              (e.getValue = this.getValue),
              (e.setValue = this.setValue),
              (e.getChoices = this.getChoices);
          }),
          a);
        function a(e, t, i) {
          void 0 === i && (i = null),
            (this.mProvider = e),
            (this.key = t),
            (this.name = i),
            (this.class = null),
            (this.editable = !0),
            (this.visible = !0),
            (this.undoable = !0),
            (this.choiceList = !1),
            (this.allowCustomChoice = !1),
            (this.userData = null),
            (this.getValue = function () {
              return null;
            }),
            (this.setValue = function (e) {
              return Promise.resolve(0);
            }),
            (this.getChoices = function () {
              return Promise.resolve(null);
            });
        }
        e.Property = s;
        var l,
          u =
            (__extends(h, (l = s)),
            (h.prototype.clone = function () {
              var e = new h(this.provider, this.key, this.name);
              return this.copyFrom(e), e;
            }),
            (h.ConvertValueToString = function (e) {
              return null == e ? null : e.toString();
            }),
            (h.prototype.copyFrom = function (e) {
              l.prototype.copyFrom.call(this, e),
                e instanceof h && (e.maxLength = this.maxLength);
            }),
            h);
        function h(e, t, i) {
          var n = l.call(this, e, t, i) || this;
          return (n.type = 0), (n.maxLength = null), n;
        }
        e.StringProperty = u;
        var m,
          c =
            (__extends(p, (m = s)),
            (p.prototype.clone = function () {
              var e = new p(this.provider, this.key, this.name);
              return this.copyFrom(e), e;
            }),
            (p.ConvertValueToBool = function (e) {
              return null == e
                ? null
                : b.utils.boolean.isBoolean(e)
                ? e
                : b.utils.string.isString(e)
                ? 'true' === e
                : !!b.utils.number.isNumber(e) && 0 != e;
            }),
            p);
        function p() {
          var e = (null !== m && m.apply(this, arguments)) || this;
          return (e.type = 1), e;
        }
        e.BoolProperty = c;
        var d,
          f =
            (__extends(g, (d = s)),
            (g.prototype.isValueEqual = function (e) {
              if (d.prototype.isValueEqual.call(this, e)) return !0;
              var t = this.getValue();
              return (
                null != t &&
                null != t.value &&
                null != e &&
                null != e.value &&
                b.utils.math.eq(t.value, g.ConvertValueToNumber(e.value))
              );
            }),
            (g.prototype.clone = function () {
              var e = new g(this.provider, this.key, this.name);
              return this.copyFrom(e), e;
            }),
            (g.ConvertValueToNumber = function (e) {
              return null == e
                ? null
                : b.utils.number.isNumber(e)
                ? e
                : b.utils.string.isString(e)
                ? parseFloat(e)
                : b.utils.boolean.isBoolean(e) && e
                ? 1
                : 0;
            }),
            (g.prototype.copyFrom = function (e) {
              d.prototype.copyFrom.call(this, e),
                e instanceof g &&
                  ((e.minValue = this.minValue),
                  (e.maxValue = this.maxValue),
                  (e.numDigits = this.numDigits),
                  (e.numDecDigits = this.numDecDigits));
            }),
            g);
        function g(e, t, i) {
          var n = d.call(this, e, t, i) || this;
          return (
            (n.type = 2),
            (n.minValue = null),
            (n.maxValue = null),
            (n.numDigits = null),
            (n.numDecDigits = 0),
            n
          );
        }
        e.NumberProperty = f;
        var v,
          y =
            (__extends(A, (v = f)),
            (A.prototype.clone = function () {
              var e = new A(this.provider, this.key, this.name);
              return this.copyFrom(e), e;
            }),
            A);
        function A(e, t, i) {
          var n = v.call(this, e, t, i) || this;
          return (n.type = 3), (n.numDecDigits = 3), n;
        }
        e.LengthProperty = y;
        var w,
          C =
            (__extends(P, (w = s)),
            (P.prototype.clone = function () {
              var e = new P(this.provider, this.key, this.name);
              return this.copyFrom(e), e;
            }),
            (P.ConvertValueToString = function (e) {
              return null == e
                ? null
                : b.utils.boolean.isBoolean(e)
                ? e
                  ? '#FFFFFF'
                  : '#000000'
                : b.utils.string.isString(e)
                ? e
                : b.utils.number.isNumber(e) && 0 !== e
                ? '#FFFFFF'
                : '#000000';
            }),
            (P.ConvertValueToColor3 = function (e) {
              var t = P.ConvertValueToString(e);
              return null == t ? null : BABYLON.Color3.FromHexString(t);
            }),
            P);
        function P() {
          var e = (null !== w && w.apply(this, arguments)) || this;
          return (e.type = 4), e;
        }
        e.Color3Property = C;
      })((t = b.core || (b.core = {})).prop || (t.prop = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.prop || (i.prop = {})),
      ((r = n.PropertyChangedResult || (n.PropertyChangedResult = {}))[
        (r.Nothing = 0)
      ] = 'Nothing'),
      (r[(r.Value = 1)] = 'Value'),
      (r[(r.Properties = 2)] = 'Properties'),
      (r[(r.Providers = 3)] = 'Providers');
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    function o(e) {
      (this.mApp = e), (this.mShadowGenerators = new Array());
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.rendering || (i.rendering = {})),
      Object.defineProperty(o.prototype, 'shadowGenerators', {
        get: function () {
          return this.mShadowGenerators;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o.prototype.addShadowGenerator = function (e) {
        null != e && this.mShadowGenerators.push(e);
      }),
      (o.prototype.removeShadowGenerator = function (e) {
        null != e && t.utils.array.remove(this.mShadowGenerators, e);
      }),
      (o.prototype.notifyModelInteraction = function () {
        for (
          var e = 0, t = this.mApp.rendering.shadowGenerators;
          e < t.length;
          e++
        )
          t[e].notifyModelInteraction();
      }),
      (r = o),
      (n.RenderingManager = r);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r, o;
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.rendering || (i.rendering = {})),
      (r = n.ShadowGenerator || (n.ShadowGenerator = {})),
      (o = 'core:disableShadow'),
      (r.disableMeshShadow = function (e, t) {
        void 0 === t && (t = !0), i.mdl.NodeUserData.SetData(e, o, t);
      }),
      (r.isMeshShadowDisabled = function (e) {
        return !0 === i.mdl.NodeUserData.GetData(e, o);
      });
  })((egr = egr || {})),
  (function (e) {
    var a, l, n, t;
    function s(e, t) {
      var i = this;
      void 0 === t && (t = 1024),
        (this.onModelModified = function () {
          i.mShadowsNeedUpdate = !0;
        }),
        (this.onViewerBeforeRender = function () {
          i.updateShadows();
        }),
        (this.mApp = e),
        (this.mScene = e.scene),
        (this.mShadowsNeedUpdate = !1),
        (this.mEnabled = !0),
        (this.mShadowUpdateTimeout = null);
      (this.mMinPlaneSize = (t / 4096) * 10),
        (this.mPlaneSize = this.mMinPlaneSize),
        (this.mPosY = 0),
        (this.mTransparency = 0.7),
        this.createCamera(0.25),
        this.createRenderTarget(t),
        this.createPlane(),
        this.mApp.model.eventModified.addListener(this.onModelModified),
        this.mApp.viewer.eventBeforeRender.addListener(
          this.onViewerBeforeRender
        );
    }
    (a = e.wcf || (e.wcf = {})),
      (l = a.core || (a.core = {})),
      (n = l.rendering || (l.rendering = {})),
      Object.defineProperty(s.prototype, 'planeYOffset', {
        get: function () {
          return this.mPlane.position.y - this.mPosY;
        },
        set: function (e) {
          (this.mPlane.position.y = this.mPosY + e),
            a.utils.mesh.updateFrozenWorldMatrix(this.mPlane);
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(s.prototype, 'planeYPosition', {
        get: function () {
          return this.mPosY;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(s.prototype, 'transparency', {
        get: function () {
          return this.mTransparency;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(s.prototype, 'enabled', {
        get: function () {
          return this.mEnabled;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (s.prototype.dispose = function () {
        this.mPlane.dispose(),
          this.mPlaneMaterial.dispose(),
          this.mCamera.dispose(),
          this.mRenderTarget.dispose(),
          this.mDepthMaterial.dispose(),
          this.mDummyMesh.dispose(),
          this.mApp.model.eventModified.removeListener(this.onModelModified),
          this.mApp.viewer.eventBeforeRender.removeListener(
            this.onViewerBeforeRender
          ),
          (this.mShadowsNeedUpdate = !1);
      }),
      (s.prototype.setEnabled = function (e) {
        this.mEnabled !== e &&
          ((this.mPlane.isVisible = e), this.mApp.viewer.requestRenderFrame());
      }),
      (s.prototype.setPlaneYPosition = function (e) {
        var t;
        this.mPosY !== e &&
          ((t = this.planeYOffset),
          (this.mPosY = e),
          (this.mCamera.position.y = this.mPosY + s.CAMERA_Y_OFFSET),
          (this.mPlane.position.y = this.mPosY + t),
          a.utils.mesh.updateFrozenWorldMatrix(this.mPlane),
          (this.mShadowsNeedUpdate = !0),
          this.mApp.viewer.requestRenderFrame());
      }),
      (s.prototype.setTransparency = function (e) {
        this.mTransparency !== e &&
          ((this.mTransparency = e),
          (this.mShadowsNeedUpdate = !0),
          this.mApp.viewer.requestRenderFrame());
      }),
      (s.prototype.notifyModelInteraction = function () {
        var e = this;
        this.mEnabled &&
          ((this.mPlane.isVisible = !1),
          this.clearUpdateTimeout(),
          (this.mShadowUpdateTimeout = setTimeout(function () {
            (e.mShadowUpdateTimeout = null),
              (e.mShadowsNeedUpdate = !0),
              e.mApp.viewer.requestRenderFrame();
          }, 250)));
      }),
      (s.prototype.clearUpdateTimeout = function () {
        null != this.mShadowUpdateTimeout &&
          (clearTimeout(this.mShadowUpdateTimeout),
          (this.mShadowUpdateTimeout = null));
      }),
      (s.prototype.addMeshToRenderList = function (e, t) {
        if (
          !(null == e || e instanceof BABYLON.LinesMesh) &&
          ((e instanceof BABYLON.Mesh && null != e.geometry) ||
            e instanceof BABYLON.InstancedMesh)
        ) {
          if (n.ShadowGenerator.isMeshShadowDisabled(e)) return;
          var i = e.getBoundingInfo();
          null == i ||
            (a.utils.math.eq(i.boundingBox.minimumWorld.y, this.mPosY) &&
              a.utils.math.eq(i.boundingBox.maximumWorld.y, this.mPosY)) ||
            t.push(e);
        }
      }),
      (s.prototype.updateShadows = function () {
        if (this.mEnabled && this.mShadowsNeedUpdate) {
          this.clearUpdateTimeout(),
            (this.mShadowsNeedUpdate = !1),
            (this.mPlane.isVisible = !0);
          var e = new Array();
          e.push(this.mDummyMesh);
          for (var t = 0, i = this.mApp.model.elements; t < i.length; t++) {
            var n = i[t];
            if (null != n.node) {
              this.addMeshToRenderList(n.node, e);
              for (
                var r = 0, o = n.node.getChildTransformNodes(!1);
                r < o.length;
                r++
              ) {
                var s = o[r];
                this.addMeshToRenderList(s, e);
              }
            }
          }
          (this.mRenderTarget.renderList = e), this.updatePlaneSize();
          var a = this.mScene.activeCamera;
          (this.mScene.activeCamera = this.mCamera),
            this.mScene.incrementRenderId(),
            this.mScene.resetCachedMaterial(),
            this.mScene.updateTransformMatrix(!0),
            this.mRenderTarget.render(!0),
            (this.mScene.activeCamera = a);
        }
      }),
      (s.prototype.createCamera = function (e) {
        (this.mCamera = new BABYLON.TargetCamera(
          'shadowPlaneCamera',
          new BABYLON.Vector3(0, this.mPosY + s.CAMERA_Y_OFFSET, 0),
          this.mScene
        )),
          (this.mCamera.rotation.x = -a.utils.math.PI_DIV2),
          (this.mCamera.upVector = new BABYLON.Vector3(0, 0, -1)),
          (this.mCamera.mode = BABYLON.Camera.ORTHOGRAPHIC_CAMERA),
          (this.mCamera.minZ = 0),
          (this.mCamera.maxZ = e);
      }),
      (s.prototype.createRenderTarget = function (n) {
        var r = this,
          o = 1 / n;
        (this.mRenderTarget = new BABYLON.RenderTargetTexture(
          'shadowPlane',
          n,
          this.mScene,
          !0,
          !0,
          BABYLON.Engine.TEXTURETYPE_UNSIGNED_INT,
          !1,
          BABYLON.Texture.TRILINEAR_SAMPLINGMODE,
          !1,
          !1
        )),
          (this.mRenderTarget.clearColor = new BABYLON.Color4(1, 1, 1, 1)),
          (this.mRenderTarget.anisotropicFilteringLevel = this.mApp.engine.getCaps().maxAnisotropy),
          (this.mRenderTarget.hasAlpha = !0);
        var e = new BABYLON.PostProcess(
          'shadowPlaneDof',
          'wcf.core.ShadowPlaneDof',
          ['dofAmount', 'transparency'],
          [],
          { width: n, height: n },
          this.mCamera
        );
        (e.onApply = function (e) {
          var t = r.mPlaneSize / n,
            i = (s.REFERENCE_RATIO / t) * 12;
          e.setFloat('dofAmount', i * o),
            e.setFloat('transparency', r.mTransparency);
        }),
          ((e = new BABYLON.PostProcess(
            'shadowPlaneBlur',
            'wcf.core.ShadowPlaneBlur',
            ['blurAmount'],
            [],
            { width: n, height: n },
            this.mCamera
          )).onApply = function (e) {
            e.setFloat('blurAmount', 0.75 * o);
          }),
          (this.mDummyMesh = new BABYLON.Mesh('shadowPlaneDummy', this.mScene)),
          this.mDummyMesh.freezeWorldMatrix(),
          (this.mDummyMesh.isPickable = !1),
          (this.mDummyMesh.isVisible = !1),
          this.mDummyMesh.setEnabled(!1),
          a.utils.mesh.removeFromScene(this.mDummyMesh, this.mScene),
          (this.mDepthMaterial = new BABYLON.ShaderMaterial(
            'shadowPlaneDepth',
            this.mScene,
            'wcf.core.ShadowPlaneDepth',
            {
              attributes: ['position', 'world0', 'world1', 'world2', 'world3'],
              uniforms: ['viewProjection', 'world'],
            }
          )),
          (this.mDepthMaterial.backFaceCulling = !1),
          this.mDepthMaterial.freeze(),
          (this.mRenderTarget.onBeforeRender = function () {
            for (var e = 0, t = r.mRenderTarget.renderList; e < t.length; e++) {
              var i = t[e];
              i instanceof BABYLON.InstancedMesh ||
                ((i._savedMaterial = i.material),
                (i.material = r.mDepthMaterial));
            }
          }),
          (this.mRenderTarget.onAfterRender = function () {
            for (var e = 0, t = r.mRenderTarget.renderList; e < t.length; e++) {
              var i = t[e];
              i instanceof BABYLON.InstancedMesh ||
                (i.material = i._savedMaterial);
            }
          });
      }),
      (s.prototype.createPlane = function () {
        (this.mPlaneMaterial = new BABYLON.StandardMaterial(
          'shadowPlane',
          this.mScene
        )),
          (this.mPlaneMaterial.diffuseColor = BABYLON.Color3.White()),
          (this.mPlaneMaterial.specularColor = BABYLON.Color3.Black()),
          (this.mPlaneMaterial.emissiveColor = BABYLON.Color3.Red()),
          (this.mPlaneMaterial.sideOrientation =
            BABYLON.Material.ClockWiseSideOrientation),
          (this.mPlaneMaterial.diffuseTexture = this.mRenderTarget),
          (this.mPlaneMaterial.useAlphaFromDiffuseTexture = !0),
          (this.mPlaneMaterial.disableLighting = !0),
          this.mPlaneMaterial.freeze(),
          (this.mPlane = BABYLON.MeshBuilder.CreateGround(
            'shadowPlane',
            { width: 1, height: 1 },
            this.mScene
          )),
          (this.mPlane.position.y = this.mPosY + 0.002),
          (this.mPlane.rotation.x = Math.PI),
          (this.mPlane.isPickable = !1),
          (this.mPlane.material = this.mPlaneMaterial),
          this.mPlane.freezeWorldMatrix(),
          l.view.CameraControl.SetMeshCameraModeMask(this.mPlane, 192);
      }),
      (s.prototype.updatePlaneSize = function () {
        for (
          var e,
            t,
            i = new l.mdl.BoundingBox(),
            n = 0,
            r = this.mRenderTarget.renderList;
          n < r.length;
          n++
        ) {
          var o,
            s = r[n];
          s !== this.mDummyMesh &&
            null != (o = s.getBoundingInfo()) &&
            (i.expandByPointInPlace(o.boundingBox.minimumWorld),
            i.expandByPointInPlace(o.boundingBox.maximumWorld));
        }
        i.isValid() &&
          ((e = i.getCenter()),
          (this.mPlaneSize = Math.max(i.max.x - i.min.x, i.max.z - i.min.z)),
          this.mPlaneSize < this.mMinPlaneSize &&
            (this.mPlaneSize = this.mMinPlaneSize),
          (this.mPlaneSize += 0.1),
          (this.mPlane.scaling.x = this.mPlaneSize),
          (this.mPlane.scaling.z = this.mPlaneSize),
          (this.mPlane.position.x = e.x),
          (this.mPlane.position.z = e.z),
          (t = 0.5 * this.mPlaneSize),
          (this.mCamera.orthoTop = t),
          (this.mCamera.orthoBottom = -t),
          (this.mCamera.orthoLeft = -t),
          (this.mCamera.orthoRight = t),
          (this.mCamera.position.x = e.x),
          (this.mCamera.position.z = e.z),
          a.utils.mesh.updateFrozenWorldMatrix(this.mPlane));
      }),
      (s.REFERENCE_RATIO = 10 / 1024),
      (s.CAMERA_Y_OFFSET = -5e-4),
      (t = s),
      (n.ShadowPlane = t);
  })((egr = egr || {})),
  (BABYLON.Effect.ShadersStore['wcf.core.ShadowPlaneDepthVertexShader'] =
    '\nprecision highp float;\n\n#include<instancesDeclaration>\nattribute vec3 position;\nuniform mat4 viewProjection;\n\nvoid main(void)\n{\n    #include<instancesVertex>\n    gl_Position = viewProjection * finalWorld * vec4(position, 1.0);\n}'),
  (BABYLON.Effect.ShadersStore['wcf.core.ShadowPlaneDepthFragmentShader'] =
    '\nprecision highp float;\n\nvoid main(void)\n{\n    float depth = gl_FragCoord.z;\n    gl_FragColor = vec4(depth, depth, depth, 1.0);\n}'),
  (BABYLON.Effect.ShadersStore['wcf.core.ShadowPlaneBlurFragmentShader'] =
    '\nprecision highp float;\n\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nuniform float blurAmount;\n\nvoid main(void)\n{\n    float alpha = 0.0;\n    alpha += texture2D(textureSampler, vUV + vec2(-1.0, -1.0) * blurAmount).a;\n    alpha += texture2D(textureSampler, vUV + vec2( 0.0, -1.0) * blurAmount).a;\n    alpha += texture2D(textureSampler, vUV + vec2( 1.0, -1.0) * blurAmount).a;\n\n    alpha += texture2D(textureSampler, vUV + vec2(-1.0,  0.0) * blurAmount).a;\n    alpha += texture2D(textureSampler, vUV + vec2( 0.0,  0.0) * blurAmount).a;\n    alpha += texture2D(textureSampler, vUV + vec2( 1.0,  0.0) * blurAmount).a;\n\n    alpha += texture2D(textureSampler, vUV + vec2(-1.0,  1.0) * blurAmount).a;\n    alpha += texture2D(textureSampler, vUV + vec2( 0.0,  1.0) * blurAmount).a;\n    alpha += texture2D(textureSampler, vUV + vec2( 1.0,  1.0) * blurAmount).a;\n\n    alpha = alpha / 9.0;\n    gl_FragColor = vec4(0.0, 0.0, 0.0, alpha);\n}'),
  (BABYLON.Effect.ShadersStore['wcf.core.ShadowPlaneDofFragmentShader'] =
    '\nprecision highp float;\n\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nuniform float dofAmount;\nuniform float transparency;\n\nvoid main(void)\n{\n    float depth = texture2D( textureSampler, vUV ).x;\n    float dofblur = clamp( depth * dofAmount, 0.0, 1.0 );\n\n    float dofblur9 = dofblur * 0.7; //0.9\n    float dofblur7 = dofblur * 0.5; //0.7\n    float dofblur4 = dofblur * 0.25; //0.4\n\n    float col = 0.0;\n\n    col += depth;\n    col += texture2D( textureSampler, vUV + vec2(  0.0,   0.4  ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.15,  0.37 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.29,  0.29 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.37,  0.15 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.40,  0.0  ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.37, -0.15 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.29, -0.29 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.15, -0.37 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.0,  -0.4  ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.15,  0.37 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.29,  0.29 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.37,  0.15 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.4,   0.0  ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.37, -0.15 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.29, -0.29 ) * dofblur ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.15, -0.37 ) * dofblur ).x;\n\n    col += texture2D( textureSampler, vUV + vec2(  0.15,  0.37 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.37,  0.15 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.37, -0.15 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.15, -0.37 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.15,  0.37 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.37,  0.15 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.37, -0.15 ) * dofblur9 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.15, -0.37 ) * dofblur9 ).x;\n\n    col += texture2D( textureSampler, vUV + vec2(  0.29,  0.29 ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.40,  0.0  ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.29, -0.29 ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.0,  -0.4  ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.29,  0.29 ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.4,   0.0  ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.29, -0.29 ) * dofblur7 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.0,   0.4  ) * dofblur7 ).x;\n\n    col += texture2D( textureSampler, vUV + vec2(  0.29,  0.29 ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.4,   0.0  ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.29, -0.29 ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.0,  -0.4  ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.29,  0.29 ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.4,   0.0  ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2( -0.29, -0.29 ) * dofblur4 ).x;\n    col += texture2D( textureSampler, vUV + vec2(  0.0,   0.4  ) * dofblur4 ).x;\n\n    col = col / 41.0;\n\n    float tra = col + (1.0 - col) * transparency;\n    gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0 - tra);\n}'),
  (function (e) {
    var t, i, n, r;
    function o(e) {
      (this.eventStarted = new t.utils.ListenableEvent(this)),
        (this.eventStopped = new t.utils.ListenableEvent(this)),
        (this.mApp = e),
        (this.mIsRunning = !1),
        (this.mInteractionMode = 0);
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.tool || (i.tool = {})),
      (o.prototype.isAvailable = function () {
        return !0;
      }),
      (o.prototype.isRunning = function () {
        return this.mIsRunning;
      }),
      (o.prototype.getInteractionMode = function () {
        return this.mInteractionMode;
      }),
      (o.prototype.start = function (e) {
        return (this.mIsRunning = !0), this.eventStarted.trigger(), !0;
      }),
      (o.prototype.stop = function () {
        (this.mIsRunning = !1),
          (this.mInteractionMode = 0),
          this.eventStopped.trigger();
      }),
      (o.prototype.handlePointerDown = function (e, t) {}),
      (o.prototype.handlePointerUp = function (e, t) {}),
      (o.prototype.handlePointerDblClick = function (e, t) {}),
      (o.prototype.handlePointerMove = function (e, t) {}),
      (o.prototype.handlePointerCancel = function (e, t) {
        this.handlePointerUp(e, t);
      }),
      (o.prototype.handleKeyUp = function (e, t) {}),
      (o.prototype.setInteractionMode = function (e) {
        this.mInteractionMode = e;
      }),
      (r = o),
      (n.AbstractTool = r);
  })((egr = egr || {})),
  (function (e) {
    var t, a;
    (t = e.wcf || (e.wcf = {})),
      (function (e) {
        var t;
        ((t = e.InteractorType || (e.InteractorType = {}))[(t.None = 0)] =
          'None'),
          (t[(t.Dragger = 1)] = 'Dragger'),
          (t[(t.Button = 2)] = 'Button');
        var i =
          (Object.defineProperty(n.prototype, 'element', {
            get: function () {
              return this.mElement;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(n.prototype, 'visible', {
            get: function () {
              return this.mVisible;
            },
            set: function (e) {
              this.mVisible !== e &&
                ((this.mVisible = e), this.updateVisibility());
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(n.prototype, 'type', {
            get: function () {
              return this.mType;
            },
            set: function (e) {
              this.mType !== e &&
                ((this.mType = e),
                (this.mElement.style.pointerEvents =
                  0 === this.mType ? 'none' : 'all'),
                this.updateViewPosition());
            },
            enumerable: !1,
            configurable: !0,
          }),
          (n.prototype.updateViewPosition = function () {
            if (null == this.mView || this.mDisableUpdate) return !1;
            if (
              (null != this.onBeforeUpdateViewPosition &&
                ((this.mDisableUpdate = !0),
                this.onBeforeUpdateViewPosition(this.mView),
                (this.mDisableUpdate = !1)),
              !this.mVisible)
            )
              return !1;
            var e,
              t,
              i,
              n = this.mView.projectPoint2(this.position, 3, this.worldMatrix);
            return null != n
              ? (null != this.posOffsetDirection &&
                  0 !== this.posOffset &&
                  ((e = this.position.add(this.posOffsetDirection.scale(0.1))),
                  null !=
                    (t = this.mView.projectPoint2(e, 3, this.worldMatrix)) &&
                    ((i = t.subtract(n)).normalize(),
                    i.scaleInPlace(this.posOffset),
                    n.addInPlace(i))),
                (this.mElement.style.transform = this.customCssTransform),
                this.transform3d &&
                  (this.mElement.style.transform +=
                    ' ' + this.getCssTranformMatrix()),
                (this.mElement.style.left = Math.round(n.x).toString() + 'px'),
                (this.mElement.style.top = Math.round(n.y).toString() + 'px'),
                (this.mElement.style.display = 'block'),
                !0)
              : !(this.mElement.style.display = 'none');
          }),
          (n.prototype._setManager = function (e) {
            this.mManager = e;
          }),
          (n.prototype._setView = function (e) {
            this.mView !== e &&
              (this.mViewer.app.tools._activeDraggerInteractor === this
                ? ((this.mPendingNewView = void 0 === e ? null : e),
                  null == e && (this.mElement.style.display = 'none'))
                : (null != this.mView &&
                    this.mView.overlayDiv.removeChild(this.mElement),
                  (this.mView = e),
                  null != this.mView &&
                    this.mView.overlayDiv.appendChild(this.mElement)));
          }),
          (n.prototype._finishDragging = function () {
            void 0 !== this.mPendingNewView &&
              (this._setView(this.mPendingNewView),
              this.mPendingNewView,
              this.updateVisibility());
          }),
          (n.prototype.updateVisibility = function () {
            null == this.mManager || this.mManager.enabled
              ? ((this.mElement.style.display = this.mVisible
                  ? 'block'
                  : 'none'),
                this.updateViewPosition())
              : (this.mElement.style.display = 'none');
          }),
          (n.prototype.getCssTranformMatrix = function () {
            var e = r;
            null != this.mView &&
              (null != this.transform3dRotation
                ? (this.transform3dRotation.toRotationMatrix(e),
                  e.multiplyToRef(this.mView.camera.getViewMatrix(), e))
                : e.copyFrom(this.mView.camera.getViewMatrix())),
              e.multiplyToRef(n.MIRROR_X_MATRIX, e),
              e.setRowFromFloats(0, -e.m[0], -e.m[1], -e.m[2], e.m[3]),
              e.setTranslationFromFloats(0, 0, 0);
            for (var t = 'matrix3d(', i = 0; i < 16; ++i)
              (t += e.m[i].toFixed(6)), 15 !== i && (t += ',');
            return (t += ')');
          }),
          (n.prototype.trigger = function (e) {
            null != this.onTriggerAction &&
              (this.mViewer._forwardEvent(e, !0),
              this.onTriggerAction(),
              this.mViewer.app.tools.eventInteractorTriggered.trigger(this));
          }),
          (n.MIRROR_X_MATRIX = BABYLON.Matrix.Scaling(-1, 1, 1)),
          n);
        function n(e, t) {
          var s = this;
          (this.onClick = function (e) {
            2 === s.mType && null != s.onTriggerAction
              ? s.trigger(e)
              : s.mViewer._forwardEvent(e, !1);
          }),
            (this.onPointerDown = function (e) {
              var t = !0,
                i = !1,
                n = s.mViewer.inputState,
                r =
                  !a.view.PointerInfo.IsMousePointer(e) &&
                  0 === n.pointers.size,
                o = a.view.PointerInfo.IsPrimaryMousePointer(e);
              null != s.onTriggerAction &&
                (r || o) &&
                (1 === s.mType ? (i = !0) : (t = !1)),
                i &&
                  (s.mViewer.app.tools._setActiveDraggerInteractor(
                    s,
                    e.pointerId
                  ),
                  s.trigger(e)),
                t && s.mViewer._forwardEvent(e, !1);
            }),
            (this.onMouseWheel = function (e) {
              s.mViewer._forwardEvent(e, !1);
            }),
            (this.onContextMenu = function (e) {
              e.preventDefault();
            }),
            (this.mElement = e),
            (this.mViewer = t),
            (this.mView = null),
            (this.mVisible = !0),
            (this.mType = 1),
            (this.mManager = null),
            (this.mDisableUpdate = !1),
            (this.mPendingNewView = void 0),
            (this.position = BABYLON.Vector3.Zero()),
            (this.posOffsetDirection = null),
            (this.posOffset = 0),
            (this.worldMatrix = null),
            (this.customCssTransform = ''),
            (this.transform3d = !1),
            (this.transform3dRotation = null),
            (this.onTriggerAction = null),
            (this.onBeforeUpdateViewPosition = null),
            (this.mElement.style.pointerEvents = 'all'),
            (this.mElement.style.display = 'block'),
            (this.mElement.style.position = 'absolute'),
            this.mElement.addEventListener('click', this.onClick, !1),
            this.mElement.addEventListener(
              'pointerdown',
              this.onPointerDown,
              !1
            ),
            this.mElement.addEventListener('wheel', this.onMouseWheel, !1),
            this.mElement.addEventListener(
              'contextmenu',
              this.onContextMenu,
              !1
            );
        }
        e.Interactor = i;
        var r = BABYLON.Matrix.Identity();
      })((a = t.core || (t.core = {})).tool || (a.tool = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    function o(e) {
      var i = this;
      (this.onHoverViewChanged = function () {
        null == i.mFixedView && i.setView(i.mViewer.hoverView);
      }),
        (this.onCameraChanged = function () {
          if (i.mEnabled)
            for (var e = 0, t = i.mInteractors; e < t.length; e++) {
              t[e].updateViewPosition();
            }
        }),
        (this.mInteractors = new Array()),
        (this.mViewer = e),
        (this.mView = null),
        (this.mFixedView = null),
        this.setEnabled(!0);
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.tool || (i.tool = {})),
      Object.defineProperty(o.prototype, 'enabled', {
        get: function () {
          return this.mEnabled;
        },
        set: function (e) {
          this.setEnabled(e);
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'interactors', {
        get: function () {
          return this.mInteractors;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'viewer', {
        get: function () {
          return this.mViewer;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'view', {
        get: function () {
          return this.mView;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'fixedView', {
        get: function () {
          return this.mFixedView;
        },
        set: function (e) {
          (this.mFixedView = e),
            this.mEnabled &&
              this.setView(
                null == this.mFixedView
                  ? this.mViewer.hoverView
                  : this.mFixedView
              );
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o.prototype.addInteractor = function (e) {
        null != e &&
          (this.mInteractors.push(e),
          e._setManager(this),
          e._setView(this.mView),
          this.mEnabled
            ? e.updateViewPosition()
            : (e.element.style.display = 'none'));
      }),
      (o.prototype.removeInteractor = function (e) {
        null != e &&
          (t.utils.array.remove(this.mInteractors, e),
          e._setManager(null),
          e._setView(null));
      }),
      (o.prototype.clear = function () {
        this.removeInteractorsFromView(), (this.mInteractors = new Array());
      }),
      (o.prototype.dispose = function () {
        this.removeInteractorsFromView(),
          (this.enabled = !1),
          (this.mInteractors = void 0);
      }),
      (o.prototype.setEnabled = function (e) {
        if (this.mEnabled !== e)
          if (((this.mEnabled = e), this.mEnabled)) {
            this.mViewer.eventHoverViewChanged.addListener(
              this.onHoverViewChanged
            );
            for (var t = 0, i = this.mInteractors; t < i.length; t++)
              (n = i[t]).visible && (n.element.style.display = 'block');
            this.setView(
              null == this.mFixedView ? this.mViewer.hoverView : this.mFixedView
            ) || this.onCameraChanged();
          } else {
            this.mViewer.eventHoverViewChanged.removeListener(
              this.onHoverViewChanged
            );
            for (var n, r = 0, o = this.mInteractors; r < o.length; r++)
              (n = o[r]).element.style.display = 'none';
          }
      }),
      (o.prototype.setView = function (e) {
        return (
          e !== this.mView &&
          (null != this.mView &&
            (this.mView.cameraControl.eventCameraChanged.removeListener(
              this.onCameraChanged
            ),
            this.removeInteractorsFromView()),
          (this.mView = e),
          null != this.mView &&
            (this.mView.cameraControl.eventCameraChanged.addListener(
              this.onCameraChanged
            ),
            this.addInteractorsToView()),
          !0)
        );
      }),
      (o.prototype.addInteractorsToView = function () {
        for (var e = 0, t = this.mInteractors; e < t.length; e++) {
          var i = t[e];
          i._setView(this.mView), i.updateViewPosition();
        }
      }),
      (o.prototype.removeInteractorsFromView = function () {
        if (null != this.mInteractors)
          for (var e = 0, t = this.mInteractors; e < t.length; e++)
            t[e]._setView(null);
      }),
      (r = o),
      (n.InteractorManager = r);
  })((egr = egr || {})),
  (function (e) {
    var d, t, i, f, n;
    function r(e, t, i, n, r, o, s, a, l) {
      (this.mAxis = i),
        (this.mView = s),
        (this.mScene = o),
        (this.mRefPoint = t),
        (this.mPosIndex = e),
        (this.mNormal = r),
        (this.mWorldMatrix = a),
        (this.mApp = this.mView.viewer.app),
        (this.showAbsoluteValues = !1),
        null != this.mWorldMatrix &&
          ((this.mRefPoint = BABYLON.Vector3.TransformCoordinates(
            this.mRefPoint,
            this.mWorldMatrix
          )),
          (this.mAxis = BABYLON.Vector3.TransformNormal(
            this.mAxis,
            this.mWorldMatrix
          )),
          this.mAxis.normalize(),
          (this.mNormal = BABYLON.Vector3.TransformNormal(
            this.mNormal,
            this.mWorldMatrix
          )),
          this.mNormal.normalize()),
        (this.mValueDiv = document.createElement('div')),
        (this.mValueDiv.className = 'wcf-core length-feedback'),
        (this.mValueDiv.style.borderColor = n),
        document.body.appendChild(this.mValueDiv),
        (this.mMaterial = new BABYLON.StandardMaterial('', this.mScene)),
        (this.mMaterial.diffuseColor = BABYLON.Color3.Black()),
        (this.mMaterial.emissiveColor = BABYLON.Color3.FromHexString(n)),
        (this.mMaterial.disableLighting = !0),
        (this.mMaterial.backFaceCulling = !1),
        this.mMaterial.freeze(),
        (this.mArrowHead = BABYLON.MeshBuilder.CreateDisc(
          '',
          { tessellation: 3, radius: 1 },
          this.mScene
        )),
        this.mArrowHead.bakeTransformIntoVertices(
          BABYLON.Matrix.Translation(-1, 0, 0)
        ),
        (this.mArrowHead.renderingGroupId = 2),
        (this.mArrowHead.rotationQuaternion = new BABYLON.Quaternion()),
        (this.mArrowHead.layerMask = 1),
        (this.mArrowHead.isPickable = !1),
        (this.mArrowHead.material = this.mMaterial),
        this.mArrowHead.setEnabled(!1),
        (this.mArrowHeadStart = null),
        l &&
          ((this.mArrowHeadStart = BABYLON.MeshBuilder.CreateDisc(
            '',
            { tessellation: 3, radius: 1 },
            this.mScene
          )),
          this.mArrowHeadStart.bakeTransformIntoVertices(
            BABYLON.Matrix.Translation(-1, 0, 0)
          ),
          this.mArrowHeadStart.bakeTransformIntoVertices(
            BABYLON.Matrix.RotationY(Math.PI)
          ),
          (this.mArrowHeadStart.renderingGroupId = 2),
          (this.mArrowHeadStart.rotationQuaternion = new BABYLON.Quaternion()),
          (this.mArrowHeadStart.layerMask = 1),
          (this.mArrowHeadStart.isPickable = !1),
          (this.mArrowHeadStart.material = this.mMaterial),
          (this.mArrowHeadStart.position = this.mRefPoint),
          this.mArrowHeadStart.setEnabled(!1));
      var u = BABYLON.Vector3.Zero();
      (this.mLine1 = BABYLON.MeshBuilder.CreateLines(
        '',
        { points: [u, u], updatable: !0, instance: null, useVertexAlpha: !1 },
        this.mScene
      )),
        (this.mLine1.color = BABYLON.Color3.FromHexString(n)),
        (this.mLine1.renderingGroupId = 2),
        (this.mLine1.layerMask = 1),
        (this.mLine1.isPickable = !1),
        this.mLine1.setEnabled(!1),
        (this.mLine1PosData = this.mLine1.getVerticesData(
          BABYLON.VertexBuffer.PositionKind,
          !1
        )),
        (this.mLine2 = BABYLON.MeshBuilder.CreateLines(
          '',
          { points: [u, u], updatable: !0, instance: null },
          this.mScene
        )),
        (this.mLine2.color = BABYLON.Color3.Black()),
        (this.mLine2.alpha = 0.25),
        (this.mLine2.renderingGroupId = 1),
        (this.mLine2.layerMask = 1),
        (this.mLine2.isPickable = !1),
        this.mLine2.setEnabled(!1),
        (this.mLine2PosData = this.mLine2.getVerticesData(
          BABYLON.VertexBuffer.PositionKind,
          !1
        ));
    }
    (d = e.wcf || (e.wcf = {})),
      (t = d.core || (d.core = {})),
      (i = t.tool || (t.tool = {})),
      (f = d.utils.math),
      (r.prototype.update = function (e, t) {
        if (null == e || null == t)
          return (
            d.utils.mesh.resizeInViewSpace(this.mView, this.mArrowHead, 1, 6),
            void (
              null != this.mArrowHeadStart &&
              d.utils.mesh.resizeInViewSpace(
                this.mView,
                this.mArrowHeadStart,
                1,
                6
              )
            )
          );
        var i = t;
        null != this.mWorldMatrix &&
          (i = BABYLON.Vector3.TransformCoordinates(i, this.mWorldMatrix));
        var n = i.subtract(this.mRefPoint);
        n.multiplyInPlace(this.mAxis);
        var r = n.x + n.y + n.z,
          o = 30;
        e.isMousePointer && (o = 10);
        var s = r;
        this.showAbsoluteValues && (s = Math.abs(s)),
          (this.mValueDiv.textContent = d.utils.number.toLocaleLengthString(
            s,
            this.mApp.i18n.locale,
            this.mApp.i18n.lengthUnit
          ));
        var a,
          l,
          u,
          h,
          m,
          c = e.position.x - this.mValueDiv.offsetWidth - o,
          p =
            e.position.y -
            this.mValueDiv.offsetHeight -
            o -
            this.mPosIndex * (this.mValueDiv.offsetHeight + 5);
        (this.mValueDiv.style.top = p.toString() + 'px'),
          (this.mValueDiv.style.left = c.toString() + 'px'),
          f.eq(r, 0)
            ? (this.mArrowHead.setEnabled(!1),
              null != this.mArrowHeadStart &&
                this.mArrowHeadStart.setEnabled(!1),
              this.mLine1.setEnabled(!1),
              this.mLine2.setEnabled(!1))
            : ((a = this.mRefPoint),
              (u = (l = this.mRefPoint.add(this.mAxis.scale(r)))
                .subtract(a)
                .normalize()),
              (h = this.mNormal),
              (m = BABYLON.Vector3.Cross(h, u)),
              (this.mArrowHead.position = l),
              f.quaternionFromAxesToRef(
                u,
                m,
                h,
                this.mArrowHead.rotationQuaternion
              ),
              this.mArrowHead.setEnabled(!0),
              d.utils.mesh.resizeInViewSpace(this.mView, this.mArrowHead, 1, 6),
              null != this.mArrowHeadStart &&
                ((this.mArrowHeadStart.rotationQuaternion = this.mArrowHead.rotationQuaternion),
                this.mArrowHeadStart.setEnabled(!0),
                d.utils.mesh.resizeInViewSpace(
                  this.mView,
                  this.mArrowHeadStart,
                  1,
                  6
                )),
              (this.mLine1PosData[0] = a.x),
              (this.mLine1PosData[1] = a.y),
              (this.mLine1PosData[2] = a.z),
              (this.mLine1PosData[3] = l.x),
              (this.mLine1PosData[4] = l.y),
              (this.mLine1PosData[5] = l.z),
              this.mLine1.updateVerticesData(
                BABYLON.VertexBuffer.PositionKind,
                this.mLine1PosData,
                !0,
                !1
              ),
              this.mLine1.setEnabled(!0),
              (l = (a = i).subtract(this.mAxis.scale(r))),
              (this.mLine2PosData[0] = a.x),
              (this.mLine2PosData[1] = a.y),
              (this.mLine2PosData[2] = a.z),
              (this.mLine2PosData[3] = l.x),
              (this.mLine2PosData[4] = l.y),
              (this.mLine2PosData[5] = l.z),
              this.mLine2.updateVerticesData(
                BABYLON.VertexBuffer.PositionKind,
                this.mLine2PosData,
                !0,
                !1
              ),
              this.mLine2.setEnabled(!0));
      }),
      (r.prototype.dispose = function () {
        document.body.removeChild(this.mValueDiv),
          null != this.mLine1 &&
            (this.mLine1.dispose(), (this.mLine1 = void 0)),
          null != this.mLine2 &&
            (this.mLine2.dispose(), (this.mLine2 = void 0)),
          this.mArrowHead.dispose(),
          null != this.mArrowHeadStart && this.mArrowHeadStart.dispose(),
          this.mMaterial.dispose();
      }),
      (n = r),
      (i.LengthFeedback = n);
  })((egr = egr || {})),
  (function (e) {
    var u, h, t, i, n;
    function r(e) {
      var t = i.call(this, e) || this;
      return (
        (t.multiSelectMode = !1),
        (t.mode = 'Complete'),
        (t.mPartialMode = !1),
        (t.mRectDiv = null),
        t
      );
    }
    (u = e.wcf || (e.wcf = {})),
      (h = u.core || (u.core = {})),
      (t = h.tool || (h.tool = {})),
      (i = t.AbstractTool),
      __extends(r, i),
      (r.prototype.start = function (e) {
        return i.prototype.start.call(this, e);
      }),
      (r.prototype.stop = function () {
        null != this.mRectDiv &&
          (this.mView.overlayDiv.removeChild(this.mRectDiv),
          (this.mRectDiv = null)),
          i.prototype.stop.call(this);
      }),
      (r.prototype.handlePointerDown = function (e, t) {
        t.isPrimaryPointer(e) && this.startSelection();
      }),
      (r.prototype.handlePointerMove = function (e, t) {
        var i, n, r, o, s, a, l, u;
        !t.isPrimaryPointer(e) ||
          null == this.mRectDiv ||
          (null != (i = t.pointers.get(e.pointerId)) &&
            ((n = i.initialPosition),
            (r = i.position),
            (o = Math.min(n.x, r.x)),
            (s = Math.min(n.y, r.y)),
            (a = Math.abs(n.x - r.x)),
            (l = Math.abs(n.y - r.y)),
            (u = new BABYLON.Vector2(o, s)),
            this.mView.convertCoordsToRef(u, 1, 3, u),
            (this.mRectDiv.style.left = u.x.toString() + 'px'),
            (this.mRectDiv.style.top = u.y.toString() + 'px'),
            (this.mRectDiv.style.width = a.toString() + 'px'),
            (this.mRectDiv.style.height = l.toString() + 'px'),
            'Both' === this.mode && this.setPartialMode(r.x < n.x, !1)));
      }),
      (r.prototype.handlePointerUp = function (e, t) {
        var i, n, r, o, s;
        t.isPrimaryPointer(e) &&
          (null != (i = t.pointers.get(e.pointerId)) &&
            null != this.mRectDiv &&
            ((n = BABYLON.Vector2.Center(i.initialPosition, i.position)),
            (r = Math.abs(i.initialPosition.x - i.position.x)),
            (o = Math.abs(i.initialPosition.y - i.position.y)),
            1 < r &&
              1 < o &&
              ((s = this.mView.createPickingFrustum(n, r, o, 1)),
              this.select(s, this.multiSelectMode || e.ctrlKey))),
          this.stop());
      }),
      (r.prototype.startSelection = function () {
        null != this.mApp.viewer.activeView &&
          ((this.mView = this.mApp.viewer.activeView),
          (this.mRectDiv = document.createElement('div')),
          (this.mRectDiv.style.position = 'absolute'),
          (this.mRectDiv.style.boxSizing = 'border-box'),
          this.mView.overlayDiv.appendChild(this.mRectDiv),
          this.setPartialMode('Partial' === this.mode, !0),
          this.setInteractionMode(1));
      }),
      (r.prototype.setPartialMode = function (e, t) {
        (e === this.mPartialMode && !t) ||
          ((this.mPartialMode = e), this.applyRectDivColor(this.mPartialMode));
      }),
      (r.prototype.applyRectDivColor = function (e) {
        var t, i, n, r;
        null != this.mRectDiv &&
          ((t = e ? 0.2 : 0.3),
          (i = e ? 'dashed' : 'solid'),
          (n = BABYLON.Color3.FromHexString(
            this.mApp.theme.mainColorBright
          ).scale(256)),
          (r =
            'rgba(' +
            Math.round(n.r) +
            ', ' +
            Math.round(n.g) +
            ', ' +
            Math.round(n.b) +
            ', ' +
            t +
            ')'),
          (this.mRectDiv.style.backgroundColor = r),
          (this.mRectDiv.style.border =
            '1px ' + i + ' ' + this.mApp.theme.mainColorBright));
      }),
      (r.prototype.select = function (e, t) {
        for (
          var i = new Array(), n = 0, r = this.mApp.model.elements;
          n < r.length;
          n++
        ) {
          var o = r[n];
          (this.maySelectElement(e, o) || (o.isSelected && t)) && i.push(o);
        }
        this.mApp.model.setSelection(i);
      }),
      (r.prototype.maySelectElement = function (e, t) {
        if (null == e || !t.canSelect) return !1;
        if (!t.boundingBoxVisible.isInFrustum(e, t.transform)) return !1;
        var i = t.getNodes(!0);
        if (null == i || 0 === i.length) return !1;
        if (this.mPartialMode) {
          for (var n = 0, r = i; n < r.length; n++) {
            var o = r[n];
            if (this.isNodePartiallyInFrustum(e, o)) return !0;
          }
          return !1;
        }
        for (var s = 0, a = i; s < a.length; s++)
          if (((o = a[s]), !this.isNodeCompletelyInFrustum(e, o))) return !1;
        return !0;
      }),
      (r.prototype.isNodeCompletelyInFrustum = function (e, t) {
        if (null == t || !t.isEnabled()) return !0;
        var i = BABYLON.Vector3.Zero();
        if (
          (t instanceof BABYLON.Mesh && null != t.geometry) ||
          t instanceof BABYLON.InstancedMesh
        ) {
          if (!t.isVisible) return !0;
          if (!t.isInFrustum(e)) return !1;
          var n = t.getVerticesData(BABYLON.VertexBuffer.PositionKind);
          if (null == n) return !1;
          for (
            var r = h.view.View._GetLocalFrustum(e, t), o = 0;
            o < n.length;
            o += 3
          )
            if (
              (i.set(n[o], n[o + 1], n[o + 2]),
              !u.utils.math.isPointInFrustum(i, r))
            )
              return !1;
        }
        return !0;
      }),
      (r.prototype.isNodePartiallyInFrustum = function (e, t) {
        if (null == t || !t.isEnabled()) return !1;
        if (
          (t instanceof BABYLON.Mesh && null != t.geometry) ||
          t instanceof BABYLON.InstancedMesh
        ) {
          if (!t.isVisible) return !1;
          if (!t.isInFrustum(e)) return !1;
          if (!t._generatePointsArray()) return !1;
          var i = t._positions;
          if (null == i) return !1;
          var n = t.getIndices();
          if (null == n) return !1;
          for (
            var r = h.view.View._GetLocalFrustum(e, t), o = 0;
            o < n.length;
            o += 3
          ) {
            var s = i[n[o]],
              a = i[n[o + 1]],
              l = i[n[o + 2]];
            if (u.utils.math.isTriangleInFrustum(s, a, l, r)) {
              if (u.utils.math.isSegmentInFrustum(s, a, r)) return !0;
              if (u.utils.math.isSegmentInFrustum(a, l, r)) return !0;
              if (u.utils.math.isSegmentInFrustum(l, s, r)) return !0;
            }
          }
        }
        return !1;
      }),
      (n = r),
      (t.RectangleSelect = n);
  })((egr = egr || {})),
  (function (e) {
    var m, r, t, n, o, i;
    function s() {
      (this.bounds = new r.mdl.BoundingBox()),
        (this.worldMatrix = BABYLON.Matrix.Identity()),
        (this.canRotate = !0),
        (this.canTranslate = !0),
        (this.canDelete = !0),
        this.update();
    }
    function c(e) {
      var i = o.call(this, e) || this;
      return (
        (i.eventRectangleSelectFinished = new m.utils.ListenableEvent(i)),
        (i.eventBackgroundClick = new m.utils.ListenableEvent(i)),
        (i.eventBackgroundClickImmediate = new m.utils.ListenableEvent(i)),
        (i.eventElementClick = new m.utils.ListenableEvent(i)),
        (i.eventMultiSelectModeChanged = new m.utils.ListenableEvent(i)),
        (i.onSelectionChanged = function (e) {
          (i.mSelectionChanged = !0),
            i.mMultiSelectMode &&
              i.multiSelectAutoStartEnabled &&
              0 === i.mApp.model.selection.length &&
              i.setMultiSelectMode(!1),
            i.mApp.viewer.requestRenderFrame();
        }),
        (i.onCameraChanged = function (e) {
          (i.mCameraChanged = !0), i.mApp.viewer.requestRenderFrame();
        }),
        (i.onCameraModeChanged = function (e) {
          (i.mCameraModeChanged = !0), i.mApp.viewer.requestRenderFrame();
        }),
        (i.onHoverViewChanged = function (e) {
          0 < i.mSelection.length
            ? ((i.mHoverViewChanged = !0), i.mApp.viewer.requestRenderFrame())
            : i.updateHoverView(i.mApp.viewer.hoverView);
        }),
        (i.onBeforeRender = function (e) {
          var t = !1;
          i.mHoverViewChanged &&
            ((t = !0),
            (i.mHoverViewChanged = !1),
            i.updateHoverView(i.mApp.viewer.hoverView)),
            i.mSelectionChanged &&
              ((t = !0), (i.mSelectionChanged = !1), i.updateSelection()),
            i.mCameraModeChanged && ((t = !0), (i.mCameraModeChanged = !1)),
            (t || i.mCameraChanged) &&
              (i.updateInteractors(!t), (i.mCameraChanged = !1));
        }),
        (i.onBeforeRenderCamera = function (e) {
          e instanceof r.view.Camera && i.updateSelectionBoxSides(e.view);
        }),
        (i.onTriggerBackgroundClick = function () {
          i.eventBackgroundClick.trigger(), (i.mBackgroundClickTimer = null);
        }),
        (i.onHandleLongTouch = function () {
          (i.mLongTouchTimer = null) != i.mPickedElement &&
            i.handleSelection(i.mPickedElement, !0) &&
            ((i.mPickedElement = null),
            (i.mHandleSelection = !1),
            (i.mHandleClick = !1));
        }),
        (i.multiSelectAutoStartEnabled = !1),
        (i.multiSelectDeselectAllEnabled = !0),
        (i.subElementSelectionEnabled = !0),
        (i.deselectionEnabled = !0),
        (i.showMainElementSelection = !0),
        (i.showSubElementSelection = !0),
        (i.leftMouseButtonRectangleSelectEnabled = !1),
        (i.rectangleSelectMode = 'Complete'),
        (i.mSelectionBoxSides = new Array()),
        (i.mSelectionBoxSideGeom = new Array()),
        (i.mPickedElement = null),
        (i.mSelection = new Array()),
        (i.mInteractorElements = new Array()),
        (i.mHoverView = null),
        (i.mHoverViewChanged = !1),
        (i.mPickedPos = BABYLON.Vector3.Zero()),
        (i.mSelectionInfo = new n()),
        (i.mRectSelectTool = null),
        (i.mSelectionChanged = !1),
        (i.mCameraChanged = !1),
        (i.mCameraModeChanged = !1),
        (i.mHandleSelection = !1),
        (i.mHandleClick = !1),
        (i.mLongTouchTimer = null),
        (i.mMultiSelectMode = !1),
        (i.mShowElementInteractors = !0),
        (i.mBackgroundClickTimer = null),
        i.prepareSelectionBoxSides(),
        i
      );
    }
    (m = e.wcf || (e.wcf = {})),
      (r = m.core || (m.core = {})),
      (t = r.tool || (r.tool = {})),
      (s.prototype.update = function () {
        var e = this.bounds.getSize();
        m.utils.math.eq(e.x, 0) &&
          ((this.bounds.min.x -= m.utils.math.EPSILON),
          (this.bounds.max.x += m.utils.math.EPSILON)),
          m.utils.math.eq(e.y, 0) &&
            ((this.bounds.min.y -= m.utils.math.EPSILON),
            (this.bounds.max.y += m.utils.math.EPSILON)),
          m.utils.math.eq(e.z, 0) &&
            ((this.bounds.min.z -= m.utils.math.EPSILON),
            (this.bounds.max.z += m.utils.math.EPSILON)),
          (this.worldBounds = this.bounds.transform(this.worldMatrix)),
          (this.worldPoints = this.bounds.getPoints(this.worldMatrix));
      }),
      (n = s),
      (o = t.AbstractTool),
      __extends(c, o),
      Object.defineProperty(c.prototype, 'multiSelectMode', {
        get: function () {
          return this.mMultiSelectMode;
        },
        set: function (e) {
          this.setMultiSelectMode(e);
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(c.prototype, 'showElementInteractors', {
        get: function () {
          return this.mShowElementInteractors;
        },
        set: function (e) {
          this.mShowElementInteractors !== e &&
            ((this.mShowElementInteractors = e),
            this.isRunning() &&
              (this.updateSelection(), this.mApp.viewer.requestRenderFrame()));
        },
        enumerable: !1,
        configurable: !0,
      }),
      (c.prototype.getInteractionMode = function () {
        return null != this.mRectSelectTool
          ? this.mRectSelectTool.getInteractionMode()
          : o.prototype.getInteractionMode.call(this);
      }),
      (c.prototype.start = function (e) {
        return (
          this.mApp.model.eventSelectionChanged.addListener(
            this.onSelectionChanged
          ),
          this.mApp.viewer.eventHoverViewChanged.addListener(
            this.onHoverViewChanged
          ),
          this.mApp.viewer.eventBeforeRender.addListener(this.onBeforeRender),
          this.mApp.model.scene.onBeforeCameraRenderObservable.add(
            this.onBeforeRenderCamera
          ),
          (this.mPickedElement = null),
          (this.mSelectionChanged = !0),
          (this.mHoverViewChanged = !0),
          (this.mCameraChanged = !1),
          (this.mCameraModeChanged = !1),
          (this.mHandleSelection = !1),
          (this.mHandleClick = !1),
          (this.mBackgroundClickTimer = null),
          (this.mLongTouchTimer = null),
          this.mApp.viewer.requestRenderFrame(),
          this.mMultiSelectMode &&
            this.multiSelectAutoStartEnabled &&
            0 === this.mApp.model.selection.length &&
            this.setMultiSelectMode(!1),
          o.prototype.start.call(this, e)
        );
      }),
      (c.prototype.stop = function () {
        null != this.mRectSelectTool && this.mRectSelectTool.stop(),
          this.mApp.model.eventSelectionChanged.removeListener(
            this.onSelectionChanged
          ),
          this.mApp.viewer.eventHoverViewChanged.removeListener(
            this.onHoverViewChanged
          ),
          this.mApp.viewer.eventBeforeRender.removeListener(
            this.onBeforeRender
          ),
          this.mApp.model.scene.onBeforeCameraRenderObservable.removeCallback(
            this.onBeforeRenderCamera
          ),
          this.updateHoverView(null),
          this.clearSelection(),
          this.resetBackgroundClickTimer(),
          this.mApp.viewer.requestRenderFrame(),
          o.prototype.stop.call(this);
      }),
      (c.prototype.handlePointerDown = function (e, t) {
        if (null == this.mRectSelectTool) {
          (this.mHandleClick = !0), (this.mHandleSelection = !1);
          var i = t.isPrimaryPointer(e),
            n = t.pointers.get(e.pointerId);
          if (null != n) {
            if (i) {
              if (n.pointerDownChangedHoverView) return;
              if (this.pickInteractors(n)) return;
              this.resetLongTouchTimer(),
                (this.mLongTouchTimer = setTimeout(
                  this.onHandleLongTouch,
                  c.LONG_TOUCH_TIMEOUT
                ));
            }
            null == this.mPickedElement &&
              (this.mPickedElement = this.getPickedElement(
                n.position,
                !n.isMousePointer,
                this.mPickedPos
              )),
              (null != this.mPickedElement || 0 < this.mSelection.length) &&
                (this.setInteractionMode(1), (this.mHandleSelection = !0));
          }
        } else this.mRectSelectTool.handlePointerDown(e, t);
      }),
      (c.prototype.handlePointerMove = function (e, t) {
        if (null == this.mRectSelectTool)
          if (t.isMouseHoverPointer(e))
            this.updateInteractorHover(
              new BABYLON.Vector2(e.clientX, e.clientY)
            );
          else {
            var i = t.getPointer(e.pointerId);
            if (this.pointerWasMoved(i)) {
              if (
                (this.resetLongTouchTimer(),
                this.leftMouseButtonRectangleSelectEnabled &&
                  (null == this.mPickedElement ||
                    !this.mPickedElement.getTopLevelElement().isSelected) &&
                  t.isPrimaryPointer(e) &&
                  r.view.PointerInfo.IsMousePointer(e))
              )
                return void this.startPointerDownRectangleSelect();
              this.mHandleClick &&
                (this.setInteractionMode(0), (this.mHandleClick = !1)),
                this.startPointerMoveTool(e, t);
            }
          }
        else this.mRectSelectTool.handlePointerMove(e, t);
      }),
      (c.prototype.handlePointerUp = function (e, t) {
        var i, n;
        null == this.mRectSelectTool
          ? ((i = this.mPickedElement),
            this.resetPickingStates(),
            null != (n = t.pointers.get(e.pointerId)) &&
              t.isPrimaryPointer(e) &&
              (n.pointerDownChangedHoverView ||
                (this.mHandleClick &&
                  (this.handleSelection(i, e.ctrlKey) ||
                    (this.eventBackgroundClickImmediate.trigger(),
                    null == this.mBackgroundClickTimer
                      ? (this.mBackgroundClickTimer = setTimeout(
                          this.onTriggerBackgroundClick,
                          1.2 * r.view.Viewer.MAX_DOUBLE_CLICK_DELAY
                        ))
                      : this.resetBackgroundClickTimer())))))
          : this.mRectSelectTool.handlePointerUp(e, t);
      }),
      (c.prototype.startRectangleSelect = function () {
        var e = this;
        (this.mRectSelectTool = new t.RectangleSelect(this.mApp)),
          (this.mRectSelectTool.multiSelectMode = this.mMultiSelectMode),
          (this.mRectSelectTool.mode = this.rectangleSelectMode),
          this.mRectSelectTool.eventStopped.addListener(function () {
            (e.mRectSelectTool = null),
              e.eventRectangleSelectFinished.trigger();
          });
      }),
      (c.prototype.updateInteractors = function (e) {}),
      (c.prototype.updateInteractorHover = function (e) {}),
      (c.prototype.pickInteractors = function (e) {
        return !1;
      }),
      (c.prototype.startPointerMoveTool = function (e, t) {}),
      (c.prototype.getDirectionToCamera = function (e, t) {
        var i;
        return (
          7 === t.cameraControl.cameraMode
            ? (i = t.cameraControl.position.subtract(e)).normalize()
            : (i = t.cameraControl.direction.negate()),
          i
        );
      }),
      (c.prototype.resetBackgroundClickTimer = function () {
        null != this.mBackgroundClickTimer &&
          (clearTimeout(this.mBackgroundClickTimer),
          (this.mBackgroundClickTimer = null));
      }),
      (c.prototype.resetLongTouchTimer = function () {
        null != this.mLongTouchTimer &&
          (clearTimeout(this.mLongTouchTimer), (this.mLongTouchTimer = null));
      }),
      (c.prototype.pointerWasMoved = function (e) {
        return (
          null != e &&
          (Math.abs(e.initialPosition.x - e.position.x) >
            r.view.Viewer.POINTER_MOVE_TOLERANCE ||
            Math.abs(e.initialPosition.y - e.position.y) >
              r.view.Viewer.POINTER_MOVE_TOLERANCE)
        );
      }),
      (c.prototype.setMultiSelectMode = function (e) {
        this.mMultiSelectMode !== e &&
          ((this.mMultiSelectMode = e),
          null != this.mRectSelectTool &&
            (this.mRectSelectTool.multiSelectMode = this.mMultiSelectMode),
          !this.mMultiSelectMode &&
            1 < this.mApp.model.selection.length &&
            this.mApp.model.setSelection(null),
          this.eventMultiSelectModeChanged.trigger());
      }),
      (c.prototype.handleSelection = function (e, t) {
        if (!this.mHandleSelection) return !1;
        var i,
          n,
          r,
          o,
          s = !1;
        return (
          this.mApp.model.beginSelectionChange(),
          null != e
            ? (this.eventElementClick.trigger(e),
              (i = e.getTopLevelElement()),
              (n = e.getMainElement()),
              (r = e.getSelectableElement()),
              (this.subElementSelectionEnabled && n === i && n !== r) ||
                (r = null),
              t || this.mMultiSelectMode
                ? ((o = !1),
                  this.multiSelectAutoStartEnabled &&
                    !this.mMultiSelectMode &&
                    (this.setMultiSelectMode(!0), (o = !0)),
                  i.isSelected
                    ? (this.deselectionEnabled ||
                        1 < this.mApp.model.selection.length) &&
                      (o || this.mApp.model.removeFromSelection(i), (s = !0))
                    : (this.mApp.model.addToSelection(i),
                      this.mApp.model.setSubElementSelection(n, r),
                      (s = !0)))
                : (i.isSelected || this.mApp.model.setSelection([i]),
                  this.mApp.model.setSubElementSelection(n, r),
                  (s = !0)))
            : t ||
              (this.mMultiSelectMode && !this.multiSelectDeselectAllEnabled) ||
              (this.deselectionEnabled
                ? (this.mApp.model.setSelection(null), (s = !0))
                : this.mApp.model.hasSubElementSelection() &&
                  (this.mApp.model.clearSubElementSelection(), (s = !0))),
          this.mApp.model.endSelectionChange(),
          s
        );
      }),
      (c.prototype.updateHoverView = function (e) {
        null != this.mHoverView &&
          (this.mHoverView.cameraControl.eventCameraChanged.removeListener(
            this.onCameraChanged
          ),
          this.mHoverView.cameraControl.eventCameraModeChanged.removeListener(
            this.onCameraModeChanged
          )),
          null != e &&
            (e.cameraControl.eventCameraChanged.addListener(
              this.onCameraChanged
            ),
            e.cameraControl.eventCameraModeChanged.addListener(
              this.onCameraModeChanged
            )),
          (this.mHoverView = e);
      }),
      (c.prototype.getPickedElement = function (e, t, i) {
        if (null != this.mHoverView) {
          var n = null;
          if (
            null !=
              (n = t
                ? this.mHoverView.pickSceneWithFrustum(
                    e,
                    c.PICK_FRUSTUM_SIZE,
                    c.PICK_FRUSTUM_SIZE,
                    1
                  )
                : this.mHoverView.pickScene(e, 1)) &&
            n.hit &&
            null != n.pickedMesh
          )
            return (
              null != i && null != n.pickedPoint && i.copyFrom(n.pickedPoint),
              r.mdl.SceneElement.FromNode(n.pickedMesh, !0)
            );
        }
        return null;
      }),
      (c.prototype.clearSelection = function () {
        for (var e = 0, t = this.mSelectionBoxSides; e < t.length; e++)
          t[e].dispose();
        this.mSelectionBoxSides = new Array();
        for (var i = 0, n = this.mSelection; i < n.length; i++)
          (r = n[i]).eventBoundingBoxChanged.removeListener(
            this.onSelectionChanged
          ),
            r.eventTransformationChanged.removeListener(
              this.onSelectionChanged
            );
        this.mSelection = new Array();
        for (var r, o = 0, s = this.mInteractorElements; o < s.length; o++)
          (r = s[o]).showInteractors(!1);
        this.mInteractorElements = new Array();
      }),
      (c.prototype.updateSelection = function () {
        this.clearSelection(),
          (this.mSelection = m.utils.array.clone(this.mApp.model.selection)),
          this.mSelectionInfo.bounds.reset(),
          BABYLON.Matrix.IdentityToRef(this.mSelectionInfo.worldMatrix),
          (this.mSelectionInfo.canDelete = !0),
          (this.mSelectionInfo.canRotate = !0),
          (this.mSelectionInfo.canTranslate = !0);
        for (var e = 0, t = this.mSelection; e < t.length; e++) {
          var i = t[e];
          i.eventBoundingBoxChanged.addListener(this.onSelectionChanged),
            i.eventTransformationChanged.addListener(this.onSelectionChanged);
          var n = i.getSelectionHighlightBoundingBox().clone(),
            r = i.worldTransform;
          this.showMainElementSelection &&
            i.isSelectionHighlightEnabled() &&
            this.createSelectionBox(n, r, !1),
            1 === this.mSelection.length
              ? ((this.mSelectionInfo.bounds = n),
                (this.mSelectionInfo.worldMatrix = r.clone()))
              : (n.transformInPlace(r),
                this.mSelectionInfo.bounds.expandInPlace(n)),
            (this.mSelectionInfo.canDelete =
              this.mSelectionInfo.canDelete && i.canDelete()),
            (this.mSelectionInfo.canRotate =
              this.mSelectionInfo.canRotate && i.canRotate()),
            (this.mSelectionInfo.canTranslate =
              this.mSelectionInfo.canTranslate && i.canTranslate());
          var o = this.mApp.model.getSubElementSelection(i);
          null != o
            ? (this.showSubElementSelection &&
                o.isSelectionHighlightEnabled() &&
                this.createSelectionBox(
                  o.boundingBoxVisible,
                  o.worldTransform,
                  !0
                ),
              this.mShowElementInteractors &&
                (o.showInteractors(!0), this.mInteractorElements.push(o)))
            : this.mShowElementInteractors &&
              (i.showInteractors(!0), this.mInteractorElements.push(i));
        }
        this.mSelectionInfo.update();
      }),
      (c.prototype.prepareSelectionBoxSides = function () {
        var e = new r.mdl.BoundingBox(
          new BABYLON.Vector3(-0.5, -0.5, -0.5),
          new BABYLON.Vector3(0.5, 0.5, 0.5)
        ).getPoints();
        (this.mSelectionBoxSideGeom = new Array()),
          this.prepareSelectionBoxSide(e, r.mdl.BoundingBox.SIDE_MIN_X),
          this.prepareSelectionBoxSide(e, r.mdl.BoundingBox.SIDE_MAX_X),
          this.prepareSelectionBoxSide(e, r.mdl.BoundingBox.SIDE_MIN_Y),
          this.prepareSelectionBoxSide(e, r.mdl.BoundingBox.SIDE_MAX_Y),
          this.prepareSelectionBoxSide(e, r.mdl.BoundingBox.SIDE_MIN_Z),
          this.prepareSelectionBoxSide(e, r.mdl.BoundingBox.SIDE_MAX_Z);
      }),
      (c.prototype.prepareSelectionBoxSide = function (e, t) {
        var i = new Array();
        i.push(e[t[0]]),
          i.push(e[t[1]]),
          i.push(e[t[1]]),
          i.push(e[t[2]]),
          i.push(e[t[2]]),
          i.push(e[t[3]]),
          i.push(e[t[3]]),
          i.push(e[t[0]]);
        var n = e[t[1]].subtract(e[t[0]]),
          r = e[t[2]].subtract(e[t[0]]),
          o = BABYLON.Vector3.Cross(n, r).normalize(),
          s = BABYLON.Vector3.Center(e[t[0]], e[t[2]]),
          a = m.utils.mesh.ThickLinesMesh.CreateThickLines(
            'selectionBoxSideGeom',
            this.mApp.model.scene,
            i
          );
        (a.isPickable = !1),
          (a.thickness = 2),
          (a.renderingGroupId = 1),
          (a.layerMask = -5),
          (a.boxSide_normal = o),
          (a.boxSide_center = s),
          m.utils.mesh.removeFromScene(a, this.mApp.model.scene),
          this.mSelectionBoxSideGeom.push(a);
      }),
      (c.prototype.createSelectionBox = function (e, t, i) {
        if (null != e && null != t) {
          var n = e.getCenter(),
            r = i
              ? BABYLON.Color4.FromHexString('#868686FF')
              : BABYLON.Color4.FromHexString(
                  this.mApp.theme.mainColorBright + 'FF'
                ),
            o = BABYLON.Matrix.Scaling(
              e.max.x - e.min.x + c.SELECTION_BOX_OFFSET,
              e.max.y - e.min.y + c.SELECTION_BOX_OFFSET,
              e.max.z - e.min.z + c.SELECTION_BOX_OFFSET
            );
          o.multiplyToRef(BABYLON.Matrix.Translation(n.x, n.y, n.z), o);
          for (
            var s = o.multiply(t), a = 0, l = this.mSelectionBoxSideGeom;
            a < l.length;
            a++
          ) {
            var u = l[a],
              h = u.clone('selectionBoxSide');
            (h.color = r),
              m.utils.mesh.setLocalMatrix(h, s),
              (h.boxSide_normal = BABYLON.Vector3.TransformNormal(
                u.boxSide_normal,
                s
              )),
              (h.boxSide_center = BABYLON.Vector3.TransformCoordinates(
                u.boxSide_center,
                s
              )),
              this.mSelectionBoxSides.push(h);
          }
        }
      }),
      (c.prototype.updateSelectionBoxSides = function (e) {
        for (var t = 0, i = this.mSelectionBoxSides; t < i.length; t++) {
          var n = i[t],
            r = n.boxSide_normal,
            o = n.boxSide_center,
            s = this.getDirectionToCamera(o, e),
            a = BABYLON.Vector3.Dot(r, s);
          n.isVisible = !(a < 0);
        }
      }),
      (c.prototype.startPointerDownRectangleSelect = function () {
        this.resetPickingStates(),
          this.startRectangleSelect(),
          null != this.mRectSelectTool && this.mRectSelectTool.startSelection();
      }),
      (c.prototype.resetPickingStates = function () {
        (this.mPickedElement = null),
          this.resetLongTouchTimer(),
          this.setInteractionMode(0);
      }),
      (c.PICK_FRUSTUM_SIZE = 30),
      (c.SELECTION_BOX_OFFSET = 0.025),
      (c.LONG_TOUCH_TIMEOUT = 750),
      (i = c),
      (t.SelectionDefault = i);
  })((egr = egr || {})),
  (function (e) {
    var r, c, o, t;
    function i(e, t, i) {
      var n = this;
      if (
        ((this.onElementClicked = function (e) {
          null != e &&
            e.getTopLevelElement().isSelected &&
            n.setActive(!n.active);
        }),
        (this.onToolStarted = function () {
          n.mApp.tools.activeTool === n.mApp.tools.defaultTool
            ? n.show()
            : n.deactivateOnToolStart
            ? n.setActive(!1)
            : n.hide();
        }),
        (this.onInteractorTriggered = function () {
          n.setActive(!1);
        }),
        (this.onSelectionChanged = function () {
          (n.mActive = !0), n.show();
        }),
        (this.onHoverViewChanged = function () {
          null != n.mView &&
            n.mView.cameraControl.eventCameraChanged.removeListener(
              n.onCameraChanged
            ),
            (n.mView = n.mApp.viewer.hoverView),
            null != n.mView &&
              n.mView.cameraControl.eventCameraChanged.addListener(
                n.onCameraChanged
              ),
            n.show();
        }),
        (this.onCameraChanged = function () {
          n.hide(),
            n.resetCameraTimeout(),
            (n.mCameraTimeout = setTimeout(function () {
              return n.show();
            }, 200));
        }),
        (this.mApp = e),
        (this.mView = null),
        (this.mVisible = !1),
        (this.mActive = !0),
        (this.deactivateOnToolStart = !0),
        (this.mShowCallback = t),
        (this.mHideCallback = i),
        this.mApp.model.eventSelectionChanged.addListener(
          this.onSelectionChanged
        ),
        this.mApp.viewer.eventHoverViewChanged.addListener(
          this.onHoverViewChanged
        ),
        this.mApp.tools.eventToolStarted.addListener(this.onToolStarted),
        this.mApp.tools.eventInteractorTriggered.addListener(
          this.onInteractorTriggered
        ),
        null == this.mApp.tools.defaultTool)
      )
        throw r.utils.newError(
          r.utils.ERR_INVALID_STATE,
          'no default tool defined'
        );
      if (!(this.mApp.tools.defaultTool instanceof o.SelectionDefault))
        throw r.utils.newError(
          r.utils.ERR_INVALID_STATE,
          'default tool not derived from SelectionDefault'
        );
      this.mApp.tools.defaultTool.eventElementClick.addListener(
        this.onElementClicked
      ),
        this.onHoverViewChanged();
    }
    (r = e.wcf || (e.wcf = {})),
      (c = r.core || (r.core = {})),
      (o = c.tool || (c.tool = {})),
      Object.defineProperty(i.prototype, 'active', {
        get: function () {
          return this.mActive;
        },
        set: function (e) {
          this.setActive(e);
        },
        enumerable: !1,
        configurable: !0,
      }),
      (i.prototype.dispose = function () {
        this.hide(),
          this.mApp.model.eventSelectionChanged.removeListener(
            this.onSelectionChanged
          ),
          this.mApp.viewer.eventHoverViewChanged.removeListener(
            this.onHoverViewChanged
          ),
          this.mApp.tools.eventToolStarted.removeListener(this.onToolStarted),
          this.mApp.tools.eventInteractorTriggered.removeListener(
            this.onInteractorTriggered
          ),
          this.mApp.tools.defaultTool instanceof o.SelectionDefault &&
            this.mApp.tools.defaultTool.eventElementClick.removeListener(
              this.onElementClicked
            ),
          null != this.mView &&
            (this.mView.cameraControl.eventCameraChanged.removeListener(
              this.onCameraChanged
            ),
            (this.mView = null));
      }),
      (i.prototype.setActive = function (e) {
        e !== this.mActive &&
          (this.mActive
            ? ((this.mActive = !1), this.hide())
            : ((this.mActive = !0), this.show()));
      }),
      (i.prototype.hide = function () {
        this.mVisible && ((this.mVisible = !1), this.mHideCallback());
      }),
      (i.prototype.resetCameraTimeout = function () {
        null != this.mCameraTimeout &&
          (clearTimeout(this.mCameraTimeout), (this.mCameraTimeout = void 0));
      }),
      (i.prototype.show = function () {
        if ((this.resetCameraTimeout(), this.mActive))
          if (
            null != this.mView &&
            this.mApp.tools.isDefaultToolRunning() &&
            0 !== this.mApp.model.selection.length
          ) {
            var e, t;
            if (1 < this.mApp.model.selection.length) {
              t = new c.mdl.BoundingBox();
              for (
                var i = 0, n = this.mApp.model.selection;
                i < n.length;
                i++
              ) {
                var r = n[i],
                  o = (o = r.getSelectionHighlightBoundingBox()).transform(
                    r.worldTransform
                  );
                t.expandInPlace(o);
              }
              e = null;
            } else
              (t = this.mApp.model.selection[0].getSelectionHighlightBoundingBox()),
                (e = this.mApp.model.selection[0].worldTransform);
            if (t.isValid()) {
              for (
                var s = t.getPoints(),
                  a = new c.mdl.BoundingBox(),
                  l = 0,
                  u = s;
                l < u.length;
                l++
              ) {
                var h = u[l],
                  m = this.mView.projectPoint3(h, 2, e, !1);
                null != m && a.expandByPointInPlace(m);
              }
              a.isValid()
                ? ((this.mVisible = !0),
                  this.mShowCallback(
                    new BABYLON.Vector2(a.min.x, a.min.y),
                    new BABYLON.Vector2(a.max.x, a.max.y),
                    this.mView
                  ))
                : this.hide();
            } else this.hide();
          } else this.hide();
      }),
      (t = i),
      (o.SelectionMenu = t);
  })((egr = egr || {})),
  (function (e) {
    var n, t, i, r;
    function o() {
      (this.offset = BABYLON.Vector3.Zero()),
        (this.size = new BABYLON.Vector3(0.1, 0.1, 0.1)),
        (this.snapXAxis = !0),
        (this.snapYAxis = !0),
        (this.snapZAxis = !0);
    }
    (n = e.wcf || (e.wcf = {})),
      (t = n.core || (n.core = {})),
      (i = t.tool || (t.tool = {})),
      (o.prototype.updateSize = function (e, t) {
        if (null != t && null != e) {
          var i = 0.1,
            n = t.projectPoint2(e, 2, null, !0),
            r = t.projectPoint2(
              e.add(t.cameraControl.right.scale(0.001)),
              2,
              null,
              !0
            );
          if (null != n && null != r)
            for (
              var o = BABYLON.Vector2.Distance(n, r), i = 0.001, s = !1;
              o < 5;

            ) {
              var a = s ? 2 : 5;
              if (((o *= a), (s = !s), 0.1 < (i *= a))) {
                i = 0.1;
                break;
              }
            }
          this.size.copyFromFloats(i, i, i);
        }
      }),
      (o.prototype.snap = function (e, t) {
        if (null == e || null == t)
          throw new Error(n.utils.ERR_INVALID_ARGUMENT);
        var i = e.subtract(this.offset);
        return (
          this.snapXAxis && (i.x = this.size.x * Math.round(i.x / this.size.x)),
          this.snapYAxis && (i.y = this.size.y * Math.round(i.y / this.size.y)),
          this.snapZAxis && (i.z = this.size.z * Math.round(i.z / this.size.z)),
          i.addInPlace(this.offset),
          i
        );
      }),
      (r = o),
      (i.SnapGrid = r);
  })((egr = egr || {})),
  (function (e) {
    var d, t, i, n;
    function r(e, t, i) {
      void 0 === i && (i = !1),
        (this.mPoint1 = e),
        (this.mPoint2 = t),
        (this.locked = !1),
        (this.isSegment = i),
        this.updateDirection();
    }
    (d = e.wcf || (e.wcf = {})),
      (t = d.core || (d.core = {})),
      (i = t.tool || (t.tool = {})),
      Object.defineProperty(r.prototype, 'point1', {
        get: function () {
          return this.mPoint1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'point2', {
        get: function () {
          return this.mPoint2;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(r.prototype, 'direction', {
        get: function () {
          return this.mDirection;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (r.prototype.setPoint1 = function (e) {
        (this.mPoint1 = e), this.updateDirection();
      }),
      (r.prototype.setPoint2 = function (e) {
        (this.mPoint2 = e), this.updateDirection();
      }),
      (r.FromAxis = function (e, t) {
        return new r(e, e.add(t));
      }),
      (r.Snap = function (e, t, i, n) {
        if ((void 0 === n && (n = 15), null == e || null == t)) return null;
        for (var r = null, o = 0, s = null, a = 0, l = t; a < l.length; a++) {
          var u = l[a],
            h = d.utils.math.projectPointOnLine3(
              e,
              u.mPoint1,
              u.mPoint2,
              u.isSegment
            );
          if (null != h) {
            if (u.locked) return ((c = {}).pos = h), (c.line = u), c;
            var m = Math.abs(BABYLON.Vector3.DistanceSquared(e, h));
            (null == r || m < o) && ((s = h), (r = u), (o = m));
          }
        }
        if (null == r || null == s) return null;
        var c,
          p = null;
        return null !=
          (p = null != i ? i.projectedDistance(e, s) : Math.sqrt(o)) && p < n
          ? (((c = {}).pos = s), (c.line = r), c)
          : null;
      }),
      (r.prototype.updateDirection = function () {
        (this.mDirection = this.mPoint2.subtract(this.mPoint1)),
          this.mDirection.normalize();
      }),
      (n = r),
      (i.SnapLine = n);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    function o() {}
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.tool || (i.tool = {})),
      (o.Snap = function (e, t, i, n) {
        if ((void 0 === n && (n = 15), null == e || null == t)) return null;
        for (var r = 0, o = null, s = 0, a = t; s < a.length; s++) {
          var l = a[s],
            u = Math.abs(BABYLON.Vector3.DistanceSquared(e, l));
          (null == o || u < r) && ((o = l), (r = u));
        }
        if (null == o) return null;
        var h = null;
        return null !=
          (h = null != i ? i.projectedDistance(e, o) : Math.sqrt(r)) && h < n
          ? o
          : null;
      }),
      (r = o),
      (n.SnapPoint = r);
  })((egr = egr || {})),
  (function (e) {
    var t, i, n, r;
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.tool || (i.tool = {})),
      ((r = n.InteractionMode || (n.InteractionMode = {}))[(r.None = 0)] =
        'None'),
      (r[(r.Primary = 1)] = 'Primary'),
      (r[(r.All = 2)] = 'All');
  })((egr = egr || {})),
  (function (e) {
    var n, t, i, r;
    function o() {
      (this.eventToolStarted = new n.utils.ListenableEvent(this)),
        (this.eventToolStopped = new n.utils.ListenableEvent(this)),
        (this.eventInteractorTriggered = new n.utils.ListenableEvent(this)),
        (this.mDefaultTool = null),
        (this.mActiveTool = null),
        (this.mActiveDraggerInteractor = null),
        (this.mActiveDraggerPointerId = null);
    }
    (n = e.wcf || (e.wcf = {})),
      (t = n.core || (n.core = {})),
      (i = t.tool || (t.tool = {})),
      Object.defineProperty(o.prototype, 'activeTool', {
        get: function () {
          return this.mActiveTool;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(o.prototype, 'defaultTool', {
        get: function () {
          return this.mDefaultTool;
        },
        set: function (e) {
          this.mDefaultTool = e;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o.prototype.startTool = function (e, t) {
        if ((void 0 === t && (t = null), null == e))
          throw new Error(n.utils.ERR_INVALID_ARGUMENT);
        if (!e.isAvailable()) throw new Error(n.utils.ERR_NOT_AVAILABLE);
        try {
          var i = e.start(t);
          return (
            i &&
              (this.stopTool(this.mActiveTool),
              (this.mActiveTool = e),
              this.eventToolStarted.trigger(e)),
            i
          );
        } catch (e) {
          return n.utils.Log.error('Failed to start tool.', e), !1;
        }
      }),
      (o.prototype.stopActiveTool = function () {
        this.stopTool(this.mActiveTool), this.startDefaultTool();
      }),
      (o.prototype.startDefaultTool = function () {
        return (
          null != this.mDefaultTool &&
          (!!this.isDefaultToolRunning() ||
            this.startTool(this.mDefaultTool, null))
        );
      }),
      (o.prototype.isDefaultToolRunning = function () {
        return (
          null != this.mActiveTool && this.mActiveTool === this.mDefaultTool
        );
      }),
      Object.defineProperty(o.prototype, '_activeDraggerInteractor', {
        get: function () {
          return this.mActiveDraggerInteractor;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (o.prototype._updateActiveToolState = function () {
        null == this.mActiveTool ||
          this.mActiveTool.isRunning() ||
          ((this.mActiveTool = null), this.startDefaultTool());
      }),
      (o.prototype._handlePointerDown = function (e, t) {
        var i = this.getActiveRunningTool();
        null != i && i.handlePointerDown(e, t);
      }),
      (o.prototype._handlePointerUp = function (e, t) {
        this.finishInteractorDragging(e);
        var i = this.getActiveRunningTool();
        null != i && i.handlePointerUp(e, t);
      }),
      (o.prototype._handlePointerDblClick = function (e, t) {
        var i = this.getActiveRunningTool();
        null != i && i.handlePointerDblClick(e, t);
      }),
      (o.prototype._handlePointerMove = function (e, t) {
        var i = this.getActiveRunningTool();
        null != i && i.handlePointerMove(e, t);
      }),
      (o.prototype._handlePointerCancel = function (e, t) {
        this.finishInteractorDragging(e);
        var i = this.getActiveRunningTool();
        null != i && i.handlePointerCancel(e, t);
      }),
      (o.prototype._handleKeyUp = function (e, t) {
        var i = this.getActiveRunningTool();
        null != i && i.handleKeyUp(e, t),
          27 === e.which && this.startDefaultTool();
      }),
      (o.prototype._setActiveDraggerInteractor = function (e, t) {
        (this.mActiveDraggerInteractor = e), (this.mActiveDraggerPointerId = t);
      }),
      (o.prototype.stopTool = function (e) {
        if (null != e)
          try {
            e.isRunning() && (e.stop(), this.eventToolStopped.trigger(e));
          } catch (e) {
            n.utils.Log.error('Failed to stop tool.', e);
          }
      }),
      (o.prototype.getActiveRunningTool = function () {
        return null != this.mActiveTool && this.mActiveTool.isRunning()
          ? this.mActiveTool
          : null;
      }),
      (o.prototype.finishInteractorDragging = function (e) {
        var t;
        this.mActiveDraggerPointerId === e.pointerId &&
          null != this.mActiveDraggerInteractor &&
          ((t = this.mActiveDraggerInteractor),
          (this.mActiveDraggerInteractor = null),
          (this.mActiveDraggerPointerId = null),
          t._finishDragging());
      }),
      (r = o),
      (i.ToolManager = r);
  })((egr = egr || {})),
  (function (e) {
    var t, y;
    (t = e.wcf || (e.wcf = {})),
      (function (c) {
        var e;
        function r(e, t, i, n) {
          BABYLON.Matrix.FromXYZAxesToRef(e, t, i, v),
            BABYLON.Quaternion.FromRotationMatrixToRef(v, n);
        }
        function n(e, t, i) {
          var n = Math.sin(t),
            r = Math.cos(t);
          (i.x = e.x * r - e.y * n), (i.y = e.y * r + e.x * n);
        }
        function o(e, t, i) {
          var n = 2 * (t.y * e.z - t.z * e.y),
            r = 2 * (t.z * e.x - t.x * e.z),
            o = 2 * (t.x * e.y - t.y * e.x);
          (i.x = e.x + t.w * n + (t.y * o - t.z * r)),
            (i.y = e.y + t.w * r + (t.z * n - t.x * o)),
            (i.z = e.z + t.w * o + (t.x * r - t.y * n));
        }
        function s(e, t, i, n, r) {
          var o = p,
            s = d;
          i.subtractToRef(t, o), e.subtractToRef(t, s);
          var a,
            l,
            u = o.x * s.x + o.y * s.y;
          n && (u < 0 || c.eq(u, 0))
            ? r.copyFrom(t)
            : ((a = o.x * o.x + o.y * o.y),
              !((n && (a < u || c.eq(a, u))) || 0 == a)
                ? ((l = u / a), (r.x = t.x + l * o.x), (r.y = t.y + l * o.y))
                : r.copyFrom(i));
        }
        function a(e, t, i, n, r) {
          var o = f,
            s = g;
          i.subtractToRef(t, o), e.subtractToRef(t, s);
          var a,
            l,
            u = o.x * s.x + o.y * s.y + o.z * s.z;
          n && (u < 0 || c.eq(u, 0))
            ? r.copyFrom(t)
            : ((a = o.x * o.x + o.y * o.y + o.z * o.z),
              !((n && (a < u || c.eq(a, u))) || 0 == a)
                ? ((l = u / a),
                  (r.x = t.x + l * o.x),
                  (r.y = t.y + l * o.y),
                  (r.z = t.z + l * o.z))
                : r.copyFrom(i));
        }
        function l(e, t, i) {
          var n = (i.y - t.y) * (e.x - i.x) - (i.x - t.x) * (e.y - i.y);
          return c.eq(n, 0) ? 0 : 0 < n ? 2 : 1;
        }
        function u(e, t, i, n) {
          t.subtractToRef(e, f),
            i.subtractToRef(e, g),
            BABYLON.Vector3.CrossToRef(f, g, n),
            n.normalize();
        }
        function h(e, t, i) {
          return (
            c.geq(e.x, Math.min(t.x, i.x)) &&
            c.leq(e.x, Math.max(t.x, i.x)) &&
            c.geq(e.y, Math.min(t.y, i.y)) &&
            c.leq(e.y, Math.max(t.y, i.y))
          );
        }
        function m(e, t, i) {
          return c.eq((t.x - e.x) * (i.y - e.y), (i.x - e.x) * (t.y - e.y));
        }
        (c.VECTOR2_X = new BABYLON.Vector2(1, 0)),
          (c.VECTOR2_Y = new BABYLON.Vector2(0, 1)),
          (c.VECTOR3_ZERO = new BABYLON.Vector3(0, 0, 0)),
          (c.VECTOR3_MIN = new BABYLON.Vector3(
            -Number.MAX_VALUE,
            -Number.MAX_VALUE,
            -Number.MAX_VALUE
          )),
          (c.VECTOR3_MAX = new BABYLON.Vector3(
            Number.MAX_VALUE,
            Number.MAX_VALUE,
            Number.MAX_VALUE
          )),
          (c.VECTOR3_X = new BABYLON.Vector3(1, 0, 0)),
          (c.VECTOR3_Y = new BABYLON.Vector3(0, 1, 0)),
          (c.VECTOR3_Z = new BABYLON.Vector3(0, 0, 1)),
          ((e = c.Orientation || (c.Orientation = {}))[(e.Collinear = 0)] =
            'Collinear'),
          (e[(e.Clockwise = 1)] = 'Clockwise'),
          (e[(e.CounterClockwise = 2)] = 'CounterClockwise'),
          (c.intersectRayPlane = function (e, t) {
            var i,
              n,
              r = null,
              o = BABYLON.Vector3.Dot(e.direction, t.normal);
            return (
              0 === o ||
                (0 <= (i = -t.signedDistanceTo(e.origin) / o) &&
                  ((n = f),
                  e.direction.scaleToRef(i, n),
                  (r = e.origin.add(n)))),
              r
            );
          }),
          (c.intersectLineLine2 = function (e, t, i, n) {
            var r = null,
              o = t.x - e.x,
              s = n.x - i.x,
              a = e.x - i.x,
              l = t.y - e.y,
              u = e.y - i.y,
              h = n.y - i.y,
              m = o * h - l * s;
            return (
              c.eq(m, 0) ||
                ((m = (u * s - a * h) / m),
                (r = new BABYLON.Vector2(e.x + m * o, e.y + m * l))),
              r
            );
          }),
          (c.angleBetweenVectors2 = function (e, t) {
            var i = BABYLON.Vector2.Dot(e, t) / (e.length() * t.length());
            return 1 <= i ? 0 : i <= -1 ? Math.PI : Math.acos(i);
          }),
          (c.angleBetweenVectors3 = function (e, t) {
            var i = BABYLON.Vector3.Dot(e, t) / (e.length() * t.length());
            return 1 <= i ? 0 : i <= -1 ? Math.PI : Math.acos(i);
          }),
          (c.signedAngleBetweenVectors2 = function (e, t) {
            var i = BABYLON.Vector2.Dot(e, t),
              n = e.x * t.y - e.y * t.x;
            return Math.atan2(n, i);
          }),
          (c.signedAngleBetweenVectors3 = function (e, t, i) {
            var n = BABYLON.Vector3.Dot(e, t),
              r = BABYLON.Vector3.Dot(i, BABYLON.Vector3.Cross(t, e));
            return Math.atan2(r, n);
          }),
          (c.normalizeAngle = function (e, t) {
            var i = e % c.PI_MUL2;
            return !t && i < 0 && (i = c.PI_MUL2 + i), i;
          }),
          (c.angleDistance = function (e, t) {
            var i = (e - t) % y.math.PI_MUL2;
            return (
              i > Math.PI
                ? (i = y.math.PI_MUL2 - i)
                : i < -Math.PI && (i = -y.math.PI_MUL2 - i),
              i
            );
          }),
          (c.quaternionToAxisAngle = function (e) {
            var t = e.clone().normalize(),
              i = (i = Math.sqrt(1 - t.w * t.w)) < c.EPSILON ? 1 : 1 / i,
              n = new BABYLON.Vector3(t.x * i, t.y * i, t.z * i);
            return c.eq(n.length(), 0)
              ? new BABYLON.Vector4(0, 0, 0, 0)
              : new BABYLON.Vector4(n.x, n.y, n.z, 2 * Math.acos(t.w));
          }),
          (c.quaternionFromAxes = function (e, t, i) {
            var n = new BABYLON.Quaternion();
            return r(e, t, i, n), n;
          }),
          (c.quaternionFromAxesToRef = r),
          (c.rotateVector2 = function (e, t) {
            var i = BABYLON.Vector2.Zero();
            return n(e, t, i), i;
          }),
          (c.rotateVector2ToRef = n),
          (c.rotateVector3 = function (e, t) {
            var i = BABYLON.Vector3.Zero();
            return o(e, t, i), i;
          }),
          (c.rotateVector3ToRef = o),
          (c.perpendicularVector2 = function (e) {
            return new BABYLON.Vector2(e.y, -e.x);
          }),
          (c.perpendicularVector3 = function (e) {
            var t = BABYLON.Vector3.Cross(e, c.VECTOR3_X);
            return (
              t.lengthSquared() < c.EPSILON &&
                (t = BABYLON.Vector3.Cross(e, c.VECTOR3_Y)),
              t.normalize()
            );
          }),
          (c.projectPointOnPlane = function (e, t) {
            var i = t.signedDistanceTo(e),
              n = f;
            return t.normal.scaleToRef(-i, n), e.add(n);
          }),
          (c.projectPointOnLine2 = function (e, t, i, n) {
            void 0 === n && (n = !1);
            var r = BABYLON.Vector2.Zero();
            return s(e, t, i, n, r), r;
          }),
          (c.projectPointOnLine2ToRef = s),
          (c.projectPointOnLine3 = function (e, t, i, n) {
            void 0 === n && (n = !1);
            var r = BABYLON.Vector3.Zero();
            return a(e, t, i, n, r), r;
          }),
          (c.projectPointOnLine3ToRef = a),
          (c.orientationToLine2 = l),
          (c.triangleNormal = function (e, t, i) {
            var n = BABYLON.Vector3.Zero();
            return u(e, t, i, n), n;
          }),
          (c.triangleNormalToRef = u),
          (c.isPointInFrustum = function (e, t) {
            for (var i = 0; i < 6; ++i)
              if (t[i].dotCoordinate(e) < 0) return !1;
            return !0;
          }),
          (c.isTriangleInFrustum = function (e, t, i, n) {
            for (var r = 0; r < 6; ++r) {
              var o = 3;
              if (
                (n[r].dotCoordinate(e) < 0 &&
                  (--o,
                  n[r].dotCoordinate(t) < 0 &&
                    (--o, n[r].dotCoordinate(i) < 0 && --o)),
                0 === o)
              )
                return !1;
            }
            return !0;
          }),
          (c.isSegmentInFrustum = function (e, t, i) {
            for (var n = 0; n < 6; ++n)
              if (i[n].dotCoordinate(e) < 0 && i[n].dotCoordinate(t) < 0)
                return !1;
            return !0;
          }),
          (c.isPointInSegmentBounds2 = h),
          (c.isPointOnSegment2 = function (e, t, i) {
            return h(e, t, i) && m(t, i, e);
          }),
          (c.isCollinear2 = m),
          (c.isMirrorScaling3 = function (e) {
            return e.x * e.y * e.z < 0;
          }),
          (c.isParallel2 = function (e, t, i, n) {
            return c.eq((e.y - t.y) * (i.x - n.x), (i.y - n.y) * (e.x - t.x));
          }),
          (c.segmentsIntersecting2 = function (e, t, i, n) {
            var r = l(i, e, t),
              o = l(n, e, t),
              s = l(e, i, n),
              a = l(t, i, n);
            return (
              (r !== o && s !== a) ||
              !(0 !== r || !h(i, e, t)) ||
              !(0 !== o || !h(n, e, t)) ||
              !(0 !== s || !h(e, i, n)) ||
              !(0 !== a || !h(t, i, n))
            );
          });
        var p = BABYLON.Vector2.Zero(),
          d = BABYLON.Vector2.Zero(),
          f = BABYLON.Vector3.Zero(),
          g = BABYLON.Vector3.Zero(),
          v = BABYLON.Matrix.Identity();
      })((y = t.utils || (t.utils = {})).math || (y.math = {}));
  })((egr = egr || {})),
  (function (e) {
    var t, c;
    (t = e.wcf || (e.wcf = {})),
      (function (e) {
        function i(e, t) {
          if (null == e) throw new Error(c.ERR_INVALID_ARGUMENT);
          BABYLON.Matrix.ComposeToRef(e.scaling, l(e), e.position, t);
        }
        function l(e) {
          if (null == e) throw new Error(c.ERR_INVALID_ARGUMENT);
          return (
            null == e.rotationQuaternion &&
              ((e.rotationQuaternion = BABYLON.Quaternion.RotationYawPitchRoll(
                e.rotation.y,
                e.rotation.x,
                e.rotation.z
              )),
              e.rotation.copyFromFloats(0, 0, 0)),
            e.rotationQuaternion
          );
        }
        (e.getLocalMatrix = function (e) {
          var t = BABYLON.Matrix.Identity();
          return i(e, t), t;
        }),
          (e.getLocalMatrixToRef = i),
          (e.setLocalMatrix = function (e, t) {
            return (
              null != e &&
              null != t &&
              (null == e.rotationQuaternion &&
                (e.rotationQuaternion = new BABYLON.Quaternion()),
              !!t.decompose(e.scaling, e.rotationQuaternion, e.position))
            );
          }),
          (e.getRotationQuaternion = l),
          (e.rotate = function (e, t, i, n) {
            if ((void 0 === n && (n = null), null == e || null == t)) return !1;
            var r = l(e),
              o = u,
              s = h,
              a = m;
            return (
              i
                ? (null != n && c.math.rotateVector3ToRef(n, r, o),
                  r.multiplyInPlace(t),
                  null != n &&
                    (c.math.rotateVector3ToRef(n, l(e), s),
                    o.subtractToRef(s, a),
                    a.multiplyInPlace(e.scaling),
                    e.position.addInPlace(a)))
                : (t.multiplyToRef(r, r),
                  null != n &&
                    (e.position.subtractToRef(n, o),
                    c.math.rotateVector3ToRef(o, t, s),
                    s.subtractToRef(o, a),
                    e.position.addInPlace(s.subtract(o)))),
              !0
            );
          }),
          (e.removeFromScene = function e(t, i) {
            if (null != t && null != i) {
              t instanceof BABYLON.AbstractMesh
                ? i.removeMesh(t)
                : i.removeTransformNode(t);
              for (
                var n = 0, r = t.getChildTransformNodes(!0);
                n < r.length;
                n++
              )
                e(r[n], i);
            }
          }),
          (e.addToScene = function e(t, i) {
            if (null != t && null != i) {
              t instanceof BABYLON.AbstractMesh
                ? i.addMesh(t)
                : i.addTransformNode(t);
              for (
                var n = 0, r = t.getChildTransformNodes(!0);
                n < r.length;
                n++
              )
                e(r[n], i);
            }
          }),
          (e.resizeInViewSpace = function (e, t, i, n) {
            var r, o, s, a;
            null != e &&
              null != t &&
              ((r = e.projectPoint2(t.position, 2, null, !0)),
              (o = u),
              e.cameraControl.right.scaleToRef(i, o),
              t.position.addToRef(o, o),
              (s = e.projectPoint2(o, 2, null, !0)),
              null != r &&
                null != s &&
                ((a = n / r.subtract(s).length()),
                (t.scaling.x = a),
                (t.scaling.y = a),
                (t.scaling.z = a)));
          }),
          (e.updateFrozenWorldMatrix = function e(t, i) {
            if (
              (void 0 === i && (i = !0),
              null != t && (t.isWorldMatrixFrozen && t.freezeWorldMatrix(), i))
            )
              for (
                var n = 0, r = t.getChildTransformNodes(!0);
                n < r.length;
                n++
              )
                e(r[n], !0);
          });
        var u = BABYLON.Vector3.Zero(),
          h = BABYLON.Vector3.Zero(),
          m = BABYLON.Vector3.Zero();
      })((c = t.utils || (t.utils = {})).mesh || (c.mesh = {}));
  })((egr = egr || {})),
  (function (e) {
    var s, h, t, a, i;
    function m(e, t, i, n, r) {
      void 0 === i && (i = null);
      var o = a.call(this, e, t, i, n, r) || this;
      return (
        (o.onBeforeCameraRender = function (e) {
          var t = o.getEngine(),
            i = e.viewport.width * t.getRenderWidth(),
            n = e.viewport.height * t.getRenderHeight();
          e instanceof s.core.view.Camera &&
            ((i /= e.view.pixelScaleFactor), (n /= e.view.pixelScaleFactor)),
            (o._lastViewportSize.x === i && o._lastViewportSize.y === n) ||
              ((o._lastViewportSize.x = i),
              (o._lastViewportSize.y = n),
              o._lineMaterial.setVector2('viewport', o._lastViewportSize));
        }),
        n
          ? ((o.color = n.color.clone()), (o.thickness = n.thickness))
          : ((o.color = new BABYLON.Color4(1, 1, 1, 1)), (o.thickness = 1)),
        (o._lineMaterial = new BABYLON.ShaderMaterial(
          'ThickLines',
          t,
          'wcf.core.ThickLines',
          {
            attributes: ['position', 'position2', 'direction'],
            uniforms: ['worldViewProjection', 'thickness', 'viewport', 'color'],
          }
        )),
        (o._lineMaterial.backFaceCulling = !1),
        (o._lineMaterial.needAlphaBlending = function () {
          return o.color.a < 1;
        }),
        o._lineMaterial.freeze(),
        (o._lastViewportSize = new BABYLON.Vector2(-1, -1)),
        t.onBeforeCameraRenderObservable.add(o.onBeforeCameraRender),
        o
      );
    }
    function c(e) {
      var t = new Array();
      return (
        e.forEach(function (e) {
          return t.push(e, e);
        }),
        t
      );
    }
    function p(e) {
      for (
        var t = new Float32Array(3 * e.length), i = 0, n = 0, r = e;
        n < r.length;
        n++
      ) {
        var o = r[n];
        (t[i++] = o.x), (t[i++] = o.y), (t[i++] = o.z);
      }
      return t;
    }
    (s = e.wcf || (e.wcf = {})),
      (h = s.utils || (s.utils = {})),
      (t = h.mesh || (h.mesh = {})),
      (a = BABYLON.Mesh),
      __extends(m, a),
      Object.defineProperty(m.prototype, 'material', {
        get: function () {
          return this._lineMaterial;
        },
        set: function (e) {},
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(m.prototype, 'checkCollisions', {
        get: function () {
          return !1;
        },
        enumerable: !1,
        configurable: !0,
      }),
      (m.prototype.getClassName = function () {
        return 'ThickLinesMesh';
      }),
      (m.prototype.createInstance = function (e) {
        return (
          h.Log.warn('ThickLinesMeshes do not support createInstance.'), null
        );
      }),
      (m.prototype._bind = function (e, t, i) {
        return (
          this._lineMaterial.setColor4('color', this.color),
          this._lineMaterial.setFloat('thickness', this.thickness),
          a.prototype._bind.call(this, e, t, i),
          this
        );
      }),
      (m.prototype.dispose = function (e) {
        this._lineMaterial.dispose(),
          this.getScene().onBeforeCameraRenderObservable.removeCallback(
            this.onBeforeCameraRender
          ),
          a.prototype.dispose.call(this, e);
      }),
      (m.prototype.clone = function (e, t, i) {
        return new m(e, this.getScene(), t, this, i);
      }),
      (m.CreateThickLines = function (e, t, i) {
        if (null == i || i.length < 2) throw new Error(h.ERR_INVALID_ARGUMENT);
        var n = i.length / 2,
          r = c(i),
          o = c(
            (function (e) {
              for (var t = new Array(), i = 0; i < e.length; i += 2)
                t.push(e[i + 1]), t.push(e[i]);
              return t;
            })(i)
          ),
          s = (function (e) {
            for (var t = 1, i = new Float32Array(2 * e), n = 0; n < e; n++)
              (i[2 * n + 0] = -t), (i[2 * n + 1] = t), (t *= -1);
            return i;
          })(i.length),
          a = (function (e) {
            for (var t = new Uint16Array(6 * e), i = 0; i < e; i++) {
              var n = 6 * i,
                r = 4 * i;
              (t[0 + n] = 0 + r),
                (t[1 + n] = 1 + r),
                (t[2 + n] = 2 + r),
                (t[3 + n] = 2 + r),
                (t[4 + n] = 1 + r),
                (t[5 + n] = 3 + r);
            }
            return t;
          })(n),
          l = new BABYLON.Geometry(BABYLON.Geometry.RandomId(), t);
        l.setVerticesData(BABYLON.VertexBuffer.PositionKind, p(r), !1),
          l.setVerticesData('position2', p(o), !1, 3),
          l.setVerticesData('direction', s, !1, 1),
          l.setIndices(a);
        var u = new m(e, t);
        return l.applyToMesh(u), u;
      }),
      (i = m),
      (t.ThickLinesMesh = i);
  })((egr = egr || {})),
  (BABYLON.Effect.ShadersStore['wcf.core.ThickLinesVertexShader'] =
    '\nprecision highp float;\n\nattribute vec3 position;\nattribute vec3 position2;\nattribute float direction;\n\nuniform mat4 worldViewProjection;\nuniform vec2 viewport;\nuniform float thickness;\n\nvec2 projectToScreen(vec4 projected) {\n    vec3 projected_normal = projected.xyz / projected.w;\n    vec2 pos = (projected_normal * 0.5 + 0.5).xy;\n    return pos * viewport;\n}\n\nvec4 unprojectFromScreen(vec2 screen, float z, float w) {\n    vec2 clip_pos = screen / viewport;\n    vec2 device_normal = clip_pos * 2.0 - 1.0;\n    return vec4(device_normal * w, z, w);\n}\n\nvoid main(void)\n{\n    vec4 currentProjected = worldViewProjection * vec4(position, 1.0);\n    vec4 nextProjected = worldViewProjection * vec4(position2, 1.0);\n\n    vec2 currentScreen = projectToScreen(currentProjected);\n    vec2 nextScreen = projectToScreen(nextProjected);\n\n    float offsetLength = thickness * 0.5;\n\n    vec2 dir = normalize(nextScreen - currentScreen);\n    vec2 offsetDir = vec2(-dir.y, dir.x);\n    offsetDir *= offsetLength * direction;\n    vec2 offsetPos = currentScreen + offsetDir;\n\n    gl_Position = unprojectFromScreen(offsetPos, currentProjected.z, currentProjected.w);\n}'),
  (BABYLON.Effect.ShadersStore['wcf.core.ThickLinesFragmentShader'] =
    '\nprecision highp float;\n\nuniform vec4 color;\n\nvoid main(void)\n{\n    gl_FragColor = color;\n}'),
  (function (e) {
    var l, t;
    (l = e.wcf || (e.wcf = {})),
      (function (e) {
        var i,
          t =
            ((i = BABYLON.TargetCamera),
            __extends(r, i),
            Object.defineProperty(r.prototype, 'view', {
              get: function () {
                return this.mView;
              },
              enumerable: !1,
              configurable: !0,
            }),
            (r.prototype.setTarget = function (e) {
              var t = s;
              e.subtractToRef(this.position, t),
                l.utils.math.eq(t.x, 0, o) && (t.x = 0),
                l.utils.math.eq(t.z, 0, o) && (t.z = 0);
              var i = r.UP_Y,
                n = a;
              t.normalizeToRef(n),
                1 <= n.y ? (i = r.UP_NEG_Z) : n.y <= -1 && (i = r.UP_Z),
                this.upVector.copyFrom(i),
                BABYLON.Matrix.LookAtLHToRef(
                  this.position,
                  e,
                  i,
                  this._camMatrix
                ),
                this._camMatrix.invert(),
                l.utils.math.eq(this._camMatrix.m[6], 0, o) &&
                  (this._camMatrix.m[6] = 0),
                l.utils.math.eq(this._camMatrix.m[10], 0, o) &&
                  (this._camMatrix.m[10] = 0),
                (this.rotation.x = Math.atan(
                  this._camMatrix.m[6] / this._camMatrix.m[10]
                )),
                isNaN(this.rotation.x) && (this.rotation.x = 0),
                0 <= t.x
                  ? (this.rotation.y = -Math.atan(t.z / t.x) + Math.PI / 2)
                  : (this.rotation.y = -Math.atan(t.z / t.x) - Math.PI / 2),
                isNaN(this.rotation.y) && (this.rotation.y = 0),
                (this.rotation.z = 0),
                this.rotationQuaternion &&
                  BABYLON.Quaternion.RotationYawPitchRollToRef(
                    this.rotation.y,
                    this.rotation.x,
                    this.rotation.z,
                    this.rotationQuaternion
                  );
            }),
            (r.prototype.getProjectionMatrix = function (e) {
              var t;
              return (
                this._doNotComputeProjectionMatrix ||
                  (!this.mProjectionChanged && !e) ||
                  ((this._refreshFrustumPlanes = !0),
                  (this.mProjectionChanged = !1),
                  (t =
                    null != this.mFixedAspectRatio
                      ? this.mFixedAspectRatio
                      : this.getEngine().getAspectRatio(this)),
                  this.mode === BABYLON.Camera.PERSPECTIVE_CAMERA
                    ? BABYLON.Matrix.PerspectiveFovLHToRef(
                        this.fov,
                        t,
                        this.minZ,
                        this.maxZ,
                        this._projectionMatrix,
                        this.fovMode === BABYLON.Camera.FOVMODE_VERTICAL_FIXED
                      )
                    : BABYLON.Matrix.OrthoOffCenterLHToRef(
                        this.orthoLeft,
                        this.orthoRight,
                        this.orthoBottom,
                        this.orthoTop,
                        this.minZ,
                        this.maxZ,
                        this._projectionMatrix
                      )),
                this.mode === BABYLON.Camera.PERSPECTIVE_CAMERA
                  ? ((this._projectionMatrix.m[8] = this.mProjectionOffsetX),
                    (this._projectionMatrix.m[9] = this.mProjectionOffsetY))
                  : ((this._projectionMatrix.m[12] = this.mProjectionOffsetX),
                    (this._projectionMatrix.m[13] = this.mProjectionOffsetY)),
                this._projectionMatrix
              );
            }),
            (r.prototype.notifyProjectionChanged = function () {
              this.mProjectionChanged = !0;
            }),
            (r.prototype._setProjectionOffset = function (e, t) {
              (this.mProjectionOffsetX = e),
                (this.mProjectionOffsetY = t),
                this._projectionMatrix._markAsUpdated();
            }),
            (r.prototype._setFixedAspectRatio = function (e) {
              this.mFixedAspectRatio = e;
            }),
            (r._DEFAULT_FOV = l.utils.math.degToRad(45)),
            (r.UP_Y = new BABYLON.Vector3(0, 1, 0)),
            (r.UP_Z = new BABYLON.Vector3(0, 0, 1)),
            (r.UP_NEG_Z = new BABYLON.Vector3(0, 0, -1)),
            r);
        function r(e) {
          var t =
            i.call(this, '', BABYLON.Vector3.Zero(), e.viewer.scene) || this;
          return (
            (t.mView = e),
            (t.mProjectionOffsetX = 0),
            (t.mProjectionOffsetY = 0),
            (t.mFixedAspectRatio = null),
            (t.mProjectionChanged = !0),
            (t.fov = r._DEFAULT_FOV),
            (t.orthoTop = 1),
            (t.orthoBottom = -t.orthoTop),
            (t.orthoLeft = -t.orthoTop),
            (t.orthoRight = t.orthoTop),
            t
          );
        }
        e.Camera = t;
        var o = 1e-8,
          s = BABYLON.Vector3.Zero(),
          a = BABYLON.Vector3.Zero();
      })((t = l.core || (l.core = {})).view || (t.view = {}));
  })((egr = egr || {})),
  (function (e) {
    var u, b;
    (u = e.wcf || (e.wcf = {})),
      (function (a) {
        var e, t;
        ((e = a.CameraMode || (a.CameraMode = {}))[(e.Top = 0)] = 'Top'),
          (e[(e.Bottom = 1)] = 'Bottom'),
          (e[(e.Left = 2)] = 'Left'),
          (e[(e.Right = 3)] = 'Right'),
          (e[(e.Front = 4)] = 'Front'),
          (e[(e.Back = 5)] = 'Back'),
          (e[(e.Orthographic = 6)] = 'Orthographic'),
          (e[(e.Perspective = 7)] = 'Perspective'),
          ((t = a.CameraModeMask || (a.CameraModeMask = {}))[(t.None = 0)] =
            'None'),
          (t[(t.Top = 1)] = 'Top'),
          (t[(t.Bottom = 2)] = 'Bottom'),
          (t[(t.Left = 4)] = 'Left'),
          (t[(t.Right = 8)] = 'Right'),
          (t[(t.Front = 16)] = 'Front'),
          (t[(t.Back = 32)] = 'Back'),
          (t[(t.Orthographic = 64)] = 'Orthographic'),
          (t[(t.Perspective = 128)] = 'Perspective'),
          (t[(t.All = 4294967295)] = 'All');
        var i =
          (Object.defineProperty(d.prototype, 'view', {
            get: function () {
              return this.mView;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'cameraMode', {
            get: function () {
              return this.mCameraMode;
            },
            set: function (e) {
              this.setCameraMode(e);
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'position', {
            get: function () {
              return this.mCamera.position;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'direction', {
            get: function () {
              return this.mDirection;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'right', {
            get: function () {
              return this.mRight;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'viewPlane', {
            get: function () {
              return this.mViewPlane;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'fixedTarget', {
            get: function () {
              return this.mFixedTarget;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'transformMatrix', {
            get: function () {
              return (
                null == this.mTransformMatrix &&
                  (this.mTransformMatrix = this.mCamera
                    .getViewMatrix()
                    .multiply(this.mCamera.getProjectionMatrix())),
                this.mTransformMatrix
              );
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'orbitInertia', {
            get: function () {
              return this.mOrbitInertia;
            },
            set: function (e) {
              this.mOrbitInertia = u.utils.math.clamp(e, 0, 1);
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(d.prototype, 'navigationArea', {
            get: function () {
              return {
                radius: this.mNavAreaRadius,
                center: this.mNavAreaCenter,
              };
            },
            enumerable: !1,
            configurable: !0,
          }),
          (d.prototype.copyCameraSettingsFrom = function (e) {
            null != e &&
              (this.beginChange(),
              (this.mCamera.minZ = e.mCamera.minZ),
              (this.mCamera.maxZ = e.mCamera.maxZ),
              (this.cameraMode = e.cameraMode),
              this.setFov(e.mCamera.fov),
              this.setFixedTarget(e.fixedTarget),
              this.setDirection(e.direction),
              this.setPosition(e.position),
              this.setCameraOrtho(e.mCamera.orthoTop),
              this.endChange());
          }),
          (d.prototype.setPosition = function (e, t) {
            void 0 === t && (t = !0),
              null != e &&
                ((this.mCamera.position = e.clone()),
                null != this.mFixedTarget &&
                  (t
                    ? (this.mCamera.setTarget(this.mFixedTarget),
                      this.updateDirection(),
                      this.updateTargetDistance(null))
                    : (this.mFixedTarget = null)),
                this.updateViewPlane(),
                this.updateTargetPlane(),
                this.notifyChange());
          }),
          (d.prototype.setDirection = function (e, t) {
            if (null == this.mFixedTarget)
              return this.setTarget(this.mCamera.position.add(e), t);
            if (this.mIsDirectionLocked || null == e) return !1;
            var i = this.mFixedTarget.subtract(this.mCamera.position).length(),
              n = this.mFixedTarget.add(e.scale(-i));
            return this.setPosition(n), !0;
          }),
          (d.prototype.setTarget = function (e, t) {
            return (
              !this.mIsDirectionLocked &&
              null != e &&
              null == this.mFixedTarget &&
              (this.mCamera.setTarget(e),
              null != t && (this.mCamera.upVector = t.clone()),
              this.updateDirection(),
              this.notifyChange(),
              !0)
            );
          }),
          (d.prototype.setFixedTarget = function (e) {
            return (
              !this.mIsDirectionLocked &&
              (null != e
                ? (this.mCamera.setTarget(e),
                  (this.mFixedTarget = e.clone()),
                  this.updateDirection(),
                  this.updateTargetDistance(null))
                : (this.mFixedTarget = null),
              this.notifyChange(),
              !0)
            );
          }),
          (d.prototype.setCameraOrtho = function (e) {
            var t = u.utils.math.clamp(e, d.MIN_ORTHO, this.mMaxZoomOrtho),
              i = this.mCamera.orthoRight / this.mCamera.orthoTop;
            (this.mCamera.orthoTop = t),
              (this.mCamera.orthoBottom = -t),
              (this.mCamera.orthoLeft = -t * i),
              (this.mCamera.orthoRight = t * i),
              this.mCamera.notifyProjectionChanged();
          }),
          (d.prototype.setFov = function (e) {
            this.mCamera.fov !== e &&
              ((this.mCamera.fov = e),
              this.mCamera.notifyProjectionChanged(),
              this._updateCSSPerspective());
          }),
          (d.prototype.setNavigationArea = function (e, t) {
            void 0 === t && (t = BABYLON.Vector3.Zero()),
              (this.mNavAreaRadius = e),
              (this.mNavAreaCenter = t),
              (this.mMaxZoomOrtho = this.mNavAreaRadius),
              (this.mMaxZoomDistance =
                this.mNavAreaRadius / Math.tan(0.5 * this.mCamera.fov));
          }),
          (d.prototype.getFrustum = function () {
            return BABYLON.Frustum.GetPlanes(this.transformMatrix);
          }),
          (d.prototype.notifyChange = function (e) {
            void 0 === e && (e = !0),
              (this.mChanged = !0),
              (this.mWasCameraChanged = !0),
              (this.mTransformMatrix = null),
              0 === this.mChangeDepth &&
                ((this.mChanged = !1), e && this.eventCameraChanged.trigger());
          }),
          (d.prototype.beginChange = function () {
            this.mChangeDepth++;
          }),
          (d.prototype.endChange = function () {
            this.mChangeDepth--,
              this.mChangeDepth <= 0 &&
                ((this.mChangeDepth = 0), this.mChanged && this.notifyChange());
          }),
          (d.prototype.zoomToFitElements = function (e, t) {
            for (
              var i = null == e ? this.mModel.elements : e,
                n = new Array(),
                r = 0,
                o = i;
              r < o.length;
              r++
            ) {
              var s = o[r];
              null != s.node && n.push(s.node);
            }
            7 === this.mCameraMode
              ? this.zoomToFitPerspective(n, !0, t)
              : this.zoomToFitOrtho(n, !0, t);
          }),
          (d.prototype.zoomToFitMeshes = function (e, t) {
            this.zoomToFitNodes(e, t);
          }),
          (d.prototype.zoomToFitNodes = function (e, t) {
            7 === this.mCameraMode
              ? this.zoomToFitPerspective(e, !1, t)
              : this.zoomToFitOrtho(e, !1, t);
          }),
          (d.prototype.zoomBy = function (e) {
            var t = new BABYLON.Vector2(
              0.5 * this.view.width,
              0.5 * this.view.height
            );
            this.view.convertCoordsToRef(t, 3, 1, t), this.wheelZoom(t, e);
          }),
          (d.prototype.serialize = function () {
            var n = this,
              r = new Array();
            this.mCameraModeSettings.forEach(function (e, t) {
              var i;
              t !== n.cameraMode &&
                (((i = {}).mode = n.cameraModeToString(t)),
                (i.position = b.io.serializeVector3(e.position)),
                (i.direction = b.io.serializeVector3(e.direction)),
                (i.fov = n.mCamera.fov),
                7 != t && (i.orthoTop = e.orthoTop),
                r.push(i));
            });
            var e = { active: !0 };
            return (
              (e.mode = this.cameraModeToString(this.cameraMode)),
              (e.position = b.io.serializeVector3(this.position)),
              (e.direction = b.io.serializeVector3(this.direction)),
              (e.fov = this.mCamera.fov),
              7 != this.cameraMode && (e.orthoTop = this.mCamera.orthoTop),
              r.push(e),
              r
            );
          }),
          (d.prototype.deserialize = function (e) {
            if (null == e) return !1;
            for (var t = new Map(), i = 0, n = e; i < n.length; i++) {
              var r = n[i],
                o = this.cameraModeFromString(r.mode),
                s = {};
              (s.position = b.io.deserializeVector3(r.position)),
                (s.direction = b.io.deserializeVector3(r.direction)),
                (s.orthoTop =
                  null != r.orthoTop ? r.orthoTop : d.DEFAULT_CAMERA_ORTHO),
                (s.fov = null != r.fov ? r.fov : a.Camera._DEFAULT_FOV),
                t.set(o, s),
                null != r.active &&
                  r.active &&
                  (this.beginChange(),
                  (this.cameraMode = o),
                  this.setFov(s.fov),
                  this.setPosition(s.position),
                  this.setDirection(s.direction),
                  this.setCameraOrtho(s.orthoTop),
                  this.endChange());
            }
            return (this.mCameraModeSettings = t), !0;
          }),
          (d.prototype.resetCamera = function (e, t) {
            this.beginChange(),
              e && this.setCameraOrtho(d.DEFAULT_CAMERA_ORTHO),
              (this.mFixedTarget = null);
            var i = 0.5 * this.mCamera.maxZ;
            switch (this.mCameraMode) {
              case 0:
                this.setDirection(new BABYLON.Vector3(0, -1, 0)),
                  this.setPosition(new BABYLON.Vector3(0, i, 0));
                break;
              case 1:
                this.setDirection(new BABYLON.Vector3(0, 1, 0)),
                  this.setPosition(new BABYLON.Vector3(0, -i, 0));
                break;
              case 2:
                this.setDirection(new BABYLON.Vector3(1, 0, 0)),
                  this.setPosition(new BABYLON.Vector3(-i, 0, 0));
                break;
              case 3:
                this.setDirection(new BABYLON.Vector3(-1, 0, 0)),
                  this.setPosition(new BABYLON.Vector3(i, 0, 0));
                break;
              case 4:
                this.setDirection(new BABYLON.Vector3(0, 0, 1)),
                  this.setPosition(new BABYLON.Vector3(0, 0, -i));
                break;
              case 5:
                this.setDirection(new BABYLON.Vector3(0, 0, -1)),
                  this.setPosition(new BABYLON.Vector3(0, 0, i));
                break;
              case 7:
                this.setPosition(d.DEFAULT_CAMERA_POSITION),
                  this.setTarget(new BABYLON.Vector3(0, 0, 0));
                break;
              case 6:
                var n = d.DEFAULT_CAMERA_POSITION.normalizeToNew();
                this.setPosition(n.scaleInPlace(i)),
                  this.setTarget(new BABYLON.Vector3(0, 0, 0));
            }
            t && (this.mCameraModeSettings = new Map()), this.endChange();
          }),
          (d.SetMeshCameraModeMask = function (e, t) {
            b.mdl.NodeUserData.SetData(e, d.NODEDATA_CAMERAMODEMASK, t);
          }),
          (d.GetMeshCameraModeMask = function (e) {
            return b.mdl.NodeUserData.GetData(e, d.NODEDATA_CAMERAMODEMASK);
          }),
          Object.defineProperty(d.prototype, '_camerModeMask', {
            get: function () {
              return this.mCameraModeMask;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (d.prototype._beforeRender = function () {
            this.mApplyOrbitInertia && this.updateOrbit();
            var e = this.mWasCameraChanged;
            return (this.mWasCameraChanged = !1), e;
          }),
          (d.prototype._updateCSSPerspective = function () {
            var e;
            null != this.mView.overlayDiv &&
              (7 === this.mCameraMode
                ? ((e =
                    (0.5 / Math.tan(0.5 * this.mCamera.fov)) *
                    this.mView.height),
                  (this.mView.overlayDiv.style.perspective = e + 'px'))
                : (this.mView.overlayDiv.style.perspective = 'none'));
          }),
          (d.prototype._handlePointerDown = function (e, t) {
            this.resetPickState(!0);
          }),
          (d.prototype._handlePointerUp = function (e, t) {
            this.resetPickState(!1);
          }),
          (d.prototype._handlePointerDblClick = function (e, t) {
            this.controlsEnabled &&
              2 !== this.mToolInteractionMode &&
              this.zoomEnabled &&
              this.dblClickZoomToFitEnabled &&
              this.zoomToFitElements(null, this.dblClickZoomToFitOptions);
          }),
          (d.prototype._handlePointerCancel = function (e, t) {
            this.resetPickState(!0);
          }),
          (d.prototype._handlePointerMove = function (e, t) {
            if (
              (this.updateToolInteractionMode(),
              this.controlsEnabled && 2 !== this.mToolInteractionMode)
            )
              if (t.pointers.has(e.pointerId))
                switch (t.pointers.size) {
                  case 1:
                    var i = 0 === this.mToolInteractionMode,
                      n = t.pointers.get(e.pointerId);
                    if (null == n) return;
                    if (
                      (n.buttons !== n.previousButtons &&
                        this.resetPickState(!0),
                      !this.leftMouseButtonEnabled &&
                        n.isMousePointer &&
                        0 === n.initialButton)
                    )
                      return;
                    (this.mIsDirectionLocked && i) ||
                    2 === n.initialButton ||
                    0 != (2 & n.buttons) ||
                    (e.ctrlKey && i)
                      ? this.panning(n.position, n.previousPosition)
                      : this.mIsDirectionLocked ||
                        (!i && 0 == (4 & n.buttons)) ||
                        this.orbit(n.position, n.previousPosition);
                    break;
                  case 2:
                    var r = t.getPointerByIndex(0),
                      o = t.getPointerByIndex(1);
                    null != r &&
                      null != o &&
                      this.touchZoomPan(
                        r.position,
                        o.position,
                        r.previousPosition,
                        o.previousPosition
                      );
                }
              else this.mZoomPickPos = null;
          }),
          (d.prototype._handleMouseWheel = function (e, t) {
            var i;
            this.updateToolInteractionMode(),
              this.controlsEnabled &&
                2 !== this.mToolInteractionMode &&
                ((i = e.deltaY),
                (i =
                  0 === e.deltaMode
                    ? u.utils.math.clamp(i, -100, 100)
                    : 0 < i
                    ? 100
                    : -100),
                this.wheelZoom(
                  new BABYLON.Vector2(e.clientX, e.clientY),
                  i * this.wheelZoomSpeed
                ));
          }),
          (d._GetMaskForCameraMode = function (e) {
            switch (e) {
              case 0:
                return 1;
              case 1:
                return 2;
              case 2:
                return 4;
              case 3:
                return 8;
              case 4:
                return 16;
              case 5:
                return 32;
              case 6:
                return 64;
              default:
                return 128;
            }
          }),
          (d.prototype.cameraModeToString = function (e) {
            return a.CameraMode[e];
          }),
          (d.prototype.cameraModeFromString = function (e) {
            var t = a.CameraMode[e];
            return null == t && (t = 7), t;
          }),
          (d.prototype.setCameraMode = function (e) {
            var t, i, n;
            e !== this.mCameraMode &&
              ((t = this.mCamera.mode),
              (this.mCamera.mode =
                7 === e
                  ? BABYLON.Camera.PERSPECTIVE_CAMERA
                  : BABYLON.Camera.ORTHOGRAPHIC_CAMERA),
              t != this.mCamera.mode && this.mCamera.notifyProjectionChanged(),
              this.resetOrbit(),
              this.mCameraModeSettings.set(this.mCameraMode, {
                position: this.position.clone(),
                direction: this.direction.clone(),
                orthoTop: this.mCamera.orthoTop,
                fov: this.mCamera.fov,
              }),
              (this.mCameraMode = e),
              (this.mCameraModeMask = d._GetMaskForCameraMode(
                this.mCameraMode
              )),
              (this.mIsDirectionLocked = !1),
              (i = 7 !== e && 6 !== e) && (this.mFixedTarget = null),
              this.mCameraModeSettings.has(e)
                ? ((n = this.mCameraModeSettings.get(e)),
                  this.setPosition(n.position),
                  this.setDirection(n.direction),
                  this.setCameraOrtho(n.orthoTop))
                : this.resetCamera(!1, !1),
              (this.mIsDirectionLocked = i),
              this._updateCSSPerspective(),
              this.notifyChange(),
              this.eventCameraModeChanged.trigger());
          }),
          (d.prototype.updateDirection = function () {
            BABYLON.Quaternion.RotationYawPitchRollToRef(
              this.mCamera.rotation.y,
              this.mCamera.rotation.x,
              this.mCamera.rotation.z,
              s
            ),
              u.utils.math.rotateVector3ToRef(
                u.utils.math.VECTOR3_Z,
                s,
                this.mDirection
              ),
              u.utils.math.rotateVector3ToRef(
                u.utils.math.VECTOR3_X,
                s,
                this.mRight
              ),
              this.updateViewPlane(),
              this.updateTargetPlane();
          }),
          (d.prototype.updateViewPlane = function () {
            this.mViewPlane = BABYLON.Plane.FromPositionAndNormal(
              this.mCamera.position,
              this.mDirection
            );
          }),
          (d.prototype.updateTargetPlane = function () {
            var e = this.mCamera.position.add(
              this.mDirection.scale(this.mTargetDistance)
            );
            this.mTargetPlane = BABYLON.Plane.FromPositionAndNormal(
              e,
              this.mDirection.negate()
            );
          }),
          (d.prototype.getNearestElementCenter = function () {
            for (
              var e = null,
                t = Number.MAX_VALUE,
                i = this.getFrustum(),
                n = 0,
                r = this.mModel.elements;
              n < r.length;
              n++
            ) {
              var o,
                s,
                a,
                l = r[n],
                u = l.boundingBoxVisible.transform(l.transform);
              u.isInFrustum(i) &&
                ((o = u.getCenter()),
                (s = BABYLON.Vector3.Distance(o, this.mCamera.position)) <
                  u.getRadius() &&
                  (s += (((a = u.getSize()).x + a.y + a.z) / 3) * 0.5),
                (s < t || null == e) && ((t = s), (e = o)));
            }
            return e;
          }),
          (d.prototype.updateTargetDistance = function (e, t) {
            if (
              (void 0 === t && (t = null),
              null == e && null == this.mFixedTarget)
            )
              return !1;
            var i,
              n,
              r = !1,
              o = null,
              s = 2 * this.mCamera.minZ;
            return (
              (i =
                7 === this.mCameraMode
                  ? this.mViewPlane.signedDistanceTo(this.mNavAreaCenter) +
                    this.mNavAreaRadius
                  : 2 * this.mCamera.maxZ + 2 * this.mNavAreaRadius),
              null != this.mFixedTarget
                ? (o = this.mFixedTarget)
                : (null != (n = this.mView.pickScene(e, 1)) &&
                    n.hit &&
                    ((o = n.pickedPoint),
                    (s = 0),
                    (i = Number.MAX_VALUE),
                    (r = !0)),
                  null == o &&
                    (null == (o = this.getNearestElementCenter())
                      ? (o = this.getPlanePickPos(e, this.mGroundPlane))
                      : (null != t && s < t && (s = t),
                        (i = Number.MAX_VALUE)))),
              null != o
                ? ((this.mTargetDistance = Math.abs(
                    this.mViewPlane.signedDistanceTo(o)
                  )),
                  this.mTargetDistance > i && (this.mTargetDistance = i))
                : (this.mTargetDistance = i),
              this.mTargetDistance < s && (this.mTargetDistance = s),
              this.updateTargetPlane(),
              r
            );
          }),
          (d.prototype.updateToolInteractionMode = function () {
            var e = this.mToolManager.activeTool;
            this.mToolInteractionMode = null != e ? e.getInteractionMode() : 0;
          }),
          (d.prototype.getPlanePickPos = function (e, t) {
            return null == e || null == t
              ? null
              : (this.mView.createPickingRayToRef(e, 1, null, r),
                u.utils.math.intersectRayPlane(r, t));
          }),
          (d.prototype.resetPickState = function (e) {
            var t;
            (this.mPanningPickPos = null),
              (this.mZoomPickPos = null),
              (this.mApplyOrbitInertia = !1),
              e || 0 === this.mOrbitInertia
                ? (this.mOrbitPickPos = null)
                : 0 < this.mOrbitInertia &&
                  ((t = Date.now() - this.mOrbitStartTime),
                  (this.mApplyOrbitInertia = this.mOrbitStarted && 50 <= t)),
              (this.mOrbitStartTime = Number.MAX_VALUE),
              (this.mOrbitStarted = !1);
          }),
          (d.prototype.resetOrbit = function () {
            (this.mOrbitStarted = !1),
              (this.mApplyOrbitInertia = !1),
              this.mOrbitStoppedTimer.stop();
          }),
          (d.prototype.orbit = function (e, t) {
            this.orbitEnabled &&
              null != e &&
              null != t &&
              ((null == this.mOrbitPickPos &&
                (this.updateTargetDistance(t),
                this.mOrbitRawRotation.copyFrom(this.mCamera.rotation),
                null == this.mFixedTarget
                  ? (this.mOrbitPickPos = this.getPlanePickPos(
                      t,
                      this.mTargetPlane
                    ))
                  : (this.mOrbitPickPos = this.mFixedTarget),
                null == this.mOrbitPickPos)) ||
                ((this.mOrbitDelta.y = (t.x - e.x) * this.orbitSpeed),
                (this.mOrbitDelta.x = (t.y - e.y) * this.orbitSpeed),
                this.updateOrbit(),
                0 < this.mOrbitInertia &&
                  (this.mOrbitStarted ||
                    ((this.mOrbitStartTime = Date.now()),
                    (this.mOrbitStarted = !0)),
                  this.mOrbitStoppedTimer.start(50, !0))));
          }),
          (d.prototype.updateOrbit = function () {
            if (null != this.mOrbitPickPos) {
              BABYLON.Quaternion.RotationYawPitchRollToRef(
                this.mCamera.rotation.y,
                this.mCamera.rotation.x,
                this.mCamera.rotation.z,
                s
              );
              var e,
                t,
                i,
                n = s.conjugateInPlace();
              if (
                this.mApplyOrbitInertia &&
                ((this.mOrbitDelta.y *= this.mOrbitInertia),
                (this.mOrbitDelta.x *= this.mOrbitInertia),
                u.utils.math.eq(this.mOrbitDelta.length(), 0, 0.001))
              )
                return (
                  (this.mOrbitPickPos = null),
                  void (this.mApplyOrbitInertia = !1)
                );
              (this.mOrbitRawRotation.x -= this.mOrbitDelta.x),
                (this.mOrbitRawRotation.x = u.utils.math.normalizeAngle(
                  this.mOrbitRawRotation.x,
                  !0
                )),
                (this.mOrbitRawRotation.x = u.utils.math.clamp(
                  this.mOrbitRawRotation.x,
                  this.pitchMin,
                  this.pitchMax
                )),
                (this.mOrbitRawRotation.y -= this.mOrbitDelta.y),
                (this.mOrbitRawRotation.y = u.utils.math.normalizeAngle(
                  this.mOrbitRawRotation.y,
                  !0
                )),
                (this.mOrbitRawRotation.y = u.utils.math.clamp(
                  this.mOrbitRawRotation.y,
                  this.yawMin,
                  this.yawMax
                )),
                this.orthoOrbitSnappingEnabled &&
                  6 === this.mCameraMode &&
                  !this.mApplyOrbitInertia &&
                  ((i = u.utils.math.normalizeAngle(
                    this.mOrbitRawRotation.y,
                    !1
                  )),
                  u.utils.math.eq(
                    this.mOrbitRawRotation.x,
                    0,
                    d.OTHO_SNAP_TOLERANCE
                  )
                    ? (e = 0)
                    : u.utils.math.eq(
                        this.mOrbitRawRotation.x,
                        u.utils.math.PI_DIV2,
                        d.OTHO_SNAP_TOLERANCE
                      )
                    ? (e = u.utils.math.PI_DIV2)
                    : u.utils.math.eq(
                        this.mOrbitRawRotation.x,
                        -u.utils.math.PI_DIV2,
                        d.OTHO_SNAP_TOLERANCE
                      ) && (e = -u.utils.math.PI_DIV2),
                  u.utils.math.eq(i, 0, d.OTHO_SNAP_TOLERANCE) ||
                  u.utils.math.eq(
                    i,
                    u.utils.math.PI_MUL2,
                    d.OTHO_SNAP_TOLERANCE
                  )
                    ? (t = 0)
                    : u.utils.math.eq(
                        i,
                        u.utils.math.PI_DIV2,
                        d.OTHO_SNAP_TOLERANCE
                      )
                    ? (t = u.utils.math.PI_DIV2)
                    : u.utils.math.eq(i, Math.PI, d.OTHO_SNAP_TOLERANCE)
                    ? (t = Math.PI)
                    : u.utils.math.eq(
                        i,
                        Math.PI + u.utils.math.PI_DIV2,
                        d.OTHO_SNAP_TOLERANCE
                      ) && (t = Math.PI + u.utils.math.PI_DIV2)),
                null != e && null != t
                  ? ((this.mCamera.rotation.x = e),
                    (this.mCamera.rotation.y = t))
                  : this.mCamera.rotation.copyFrom(this.mOrbitRawRotation),
                BABYLON.Quaternion.RotationYawPitchRollToRef(
                  this.mCamera.rotation.y,
                  this.mCamera.rotation.x,
                  this.mCamera.rotation.z,
                  l
                );
              var r = l,
                o = this.mCamera.position.subtract(this.mOrbitPickPos);
              u.utils.math.rotateVector3ToRef(o, n, o),
                u.utils.math.rotateVector3ToRef(o, r, o),
                (this.mCamera.position = this.mOrbitPickPos.add(o)),
                this.mCamera.rotation.x === u.utils.math.PI_DIV2 ||
                this.mCamera.rotation.x === -u.utils.math.PI_DIV2
                  ? (this.mCamera.rotation.x === u.utils.math.PI_DIV2
                      ? this.mCamera.upVector.copyFromFloats(0, 0, 1)
                      : this.mCamera.upVector.copyFromFloats(0, 0, -1),
                    BABYLON.Quaternion.RotationAxisToRef(
                      u.utils.math.VECTOR3_Y,
                      this.mCamera.rotation.y,
                      s
                    ),
                    u.utils.math.rotateVector3ToRef(
                      this.mCamera.upVector,
                      s,
                      this.mCamera.upVector
                    ))
                  : this.mCamera.upVector.copyFromFloats(0, 1, 0),
                this.updateDirection(),
                this.notifyChange();
            }
          }),
          (d.prototype.panning = function (e, t) {
            var i;
            this.panningEnabled &&
              null != e &&
              ((null == this.mPanningPickPos &&
                (this.updateTargetDistance(t),
                (this.mPanningPickPos = this.getPlanePickPos(
                  t,
                  this.mTargetPlane
                )),
                null == this.mPanningPickPos)) ||
                (null != (i = this.getPlanePickPos(e, this.mTargetPlane)) &&
                  (this.mCamera.position.addInPlace(
                    this.mPanningPickPos.subtract(i)
                  ),
                  null != this.mFixedTarget &&
                    this.mFixedTarget.addInPlace(
                      this.mPanningPickPos.subtract(i)
                    )),
                this.notifyChange()));
          }),
          (d.prototype.wheelZoom = function (e, t) {
            var i, n, r, o;
            this.zoomEnabled &&
              null != e &&
              null != t &&
              ((i = !1),
              (null == this.mZoomPickPos &&
                ((i = !this.updateTargetDistance(
                  e,
                  d.ZOOM_NO_HIT_MIN_TARGETDISTANCE
                )),
                null == this.mFixedTarget
                  ? (this.mZoomPickPos = this.getPlanePickPos(
                      e,
                      this.mTargetPlane
                    ))
                  : (this.mZoomPickPos = this.mFixedTarget),
                null == this.mZoomPickPos)) ||
                (this.mCamera.mode === BABYLON.Camera.ORTHOGRAPHIC_CAMERA
                  ? ((n = this.mCamera.orthoTop + t * this.mCamera.orthoTop),
                    this.setCameraOrtho(n),
                    d.MIN_ORTHO <= n &&
                      n <= this.mMaxZoomOrtho &&
                      ((o = (r = u.utils.math
                        .projectPointOnPlane(
                          this.mCamera.position,
                          this.mTargetPlane
                        )
                        .subtract(this.mZoomPickPos)).length()),
                      r.normalize(),
                      this.mCamera.position.addInPlace(r.scaleInPlace(t * o))))
                  : this.updatePerspectiveZoom(this.mZoomPickPos, t, !0),
                i && (this.mZoomPickPos = null),
                this.updateViewPlane(),
                this.notifyChange()));
          }),
          (d.prototype.touchZoomPan = function (e, t, i, n) {
            if (null != e && null != t && null != i && null != n) {
              if (null == this.mZoomPickPos) {
                this.updateTargetDistance(
                  BABYLON.Vector2.Center(i, n),
                  d.ZOOM_NO_HIT_MIN_TARGETDISTANCE
                );
                var r = this.getPlanePickPos(i, this.mTargetPlane),
                  o = this.getPlanePickPos(n, this.mTargetPlane);
                if (null == r || null == o) return;
                (this.mPanningPickPos = BABYLON.Vector3.Center(r, o)),
                  (this.mZoomPickDistance = BABYLON.Vector3.Distance(r, o)),
                  (this.mZoomPickPos =
                    null != this.mFixedTarget
                      ? this.mFixedTarget
                      : this.mPanningPickPos);
              }
              var s = this.getPlanePickPos(e, this.mTargetPlane),
                a = this.getPlanePickPos(t, this.mTargetPlane);
              if (null != s && null != a) {
                var l = BABYLON.Vector3.Center(s, a),
                  u = null != this.mFixedTarget ? this.mFixedTarget : l,
                  h = !1;
                if (
                  (this.panningEnabled &&
                    null != this.mPanningPickPos &&
                    (this.mCamera.position.addInPlace(
                      this.mPanningPickPos.subtract(l)
                    ),
                    null != this.mFixedTarget &&
                      this.mFixedTarget.addInPlace(
                        this.mPanningPickPos.subtract(l)
                      ),
                    (h = !0)),
                  this.zoomEnabled)
                ) {
                  var m,
                    c = BABYLON.Vector3.Distance(s, a),
                    p = this.mZoomPickDistance - c;
                  if (
                    (this.mCamera.mode === BABYLON.Camera.ORTHOGRAPHIC_CAMERA
                      ? ((m = this.mCamera.orthoTop + p * this.touchZoomSpeed),
                        this.setCameraOrtho(m))
                      : this.updatePerspectiveZoom(
                          u,
                          2 * p * this.touchZoomSpeed
                        ),
                    (s = this.getPlanePickPos(e, this.mTargetPlane)),
                    (a = this.getPlanePickPos(t, this.mTargetPlane)),
                    null == s || null == a)
                  )
                    return;
                  (c = BABYLON.Vector3.Distance(s, a)),
                    (this.mZoomPickDistance = c),
                    (h = !0);
                }
                h && (this.updateViewPlane(), this.notifyChange());
              }
            }
          }),
          (d.prototype.updatePerspectiveZoom = function (e, t, i) {
            void 0 === i && (i = !1);
            var n = 2 * this.mCamera.minZ,
              r = this.mCamera.position.subtract(e),
              o = r.length();
            r.normalize();
            var s = t;
            i && (s *= o),
              (o += s),
              (0 < t || n < o) &&
                (t < 0 || o < this.mMaxZoomDistance) &&
                (this.mCamera.position = e.add(r.scaleInPlace(o)));
          }),
          (d.prototype.calculateZoomToFitBounds = function (e, t, i) {
            if (null != t && t.isEnabled()) {
              if (t instanceof BABYLON.AbstractMesh) {
                var n = t instanceof BABYLON.Mesh && null == t.geometry;
                if (t.isVisible && !n) {
                  var r = t.getBoundingInfo();
                  if (null != r)
                    for (
                      var o = 0, s = r.boundingBox.vectorsWorld;
                      o < s.length;
                      o++
                    )
                      e(s[o]);
                }
              }
              if (i)
                for (
                  var a = 0, l = t.getChildTransformNodes(!0);
                  a < l.length;
                  a++
                ) {
                  var u = l[a];
                  this.calculateZoomToFitBounds(e, u, i);
                }
            }
          }),
          (d.prototype.zoomToFitOrtho = function (e, t, i) {
            var n = this,
              r = { useBoundingSphere: !1, adjustFixedTarget: !0 };
            null != i && Object.assign(r, i);
            for (
              var o,
                s,
                a,
                l,
                u,
                h,
                m,
                c,
                p,
                d = null,
                f = 1,
                g = 1,
                v = new b.mdl.BoundingBox(),
                y = r.useBoundingSphere ? null : new b.mdl.BoundingBox(),
                A = function (e) {
                  var t;
                  v.expandByPointInPlace(e),
                    null == y ||
                      (null != (t = n.mView.projectPoint3(e, 3, null, !1)) &&
                        y.expandByPointInPlace(t));
                },
                w = 0,
                C = e;
              w < C.length;
              w++
            ) {
              var P = C[w];
              this.calculateZoomToFitBounds(A, P, t);
            }
            r.useBoundingSphere
              ? v.isValid() &&
                ((o = (d = v.getCenter()).add(
                  this.mRight.scale(v.getRadius())
                )),
                (s = this.mView.projectPoint3(d, 3, null, !1)),
                (a = this.mView.projectPoint3(o, 3, null, !1)),
                null != s && null != a
                  ? (g = f = 2 * BABYLON.Vector3.Distance(s, a))
                  : (d = null))
              : null != y &&
                y.isValid() &&
                v.isValid() &&
                ((d = v.getCenter()),
                (f = y.max.x - y.min.x),
                (g = y.max.y - y.min.y)),
              null != d &&
                ((l = 0.5 * this.mCamera.maxZ),
                (this.mCamera.position = d.subtract(this.direction.scale(l))),
                (u = 1 - this.getZoomToFitMarginH(r)),
                (h = 1 - this.getZoomToFitMarginV(r)),
                (m = (this.mView.width * u) / f),
                (c = (this.mView.height * h) / g),
                (p = Math.min(m, c)),
                this.setCameraOrtho(this.mCamera.orthoTop / p),
                null != this.mFixedTarget &&
                  r.adjustFixedTarget &&
                  this.setFixedTarget(d),
                this.updateViewPlane(),
                this.notifyChange());
          }),
          (d.prototype.zoomToFitPerspective = function (e, t, i) {
            var n = { useBoundingSphere: !1, adjustFixedTarget: !0 };
            null != i && Object.assign(n, i);
            for (
              var r,
                o,
                s,
                a = null,
                l = new b.mdl.BoundingBox(),
                u = new f(
                  this.mCamera,
                  this.mView,
                  this.getZoomToFitMarginH(n),
                  this.getZoomToFitMarginV(n)
                ),
                h = function (e) {
                  l.expandByPointInPlace(e),
                    n.useBoundingSphere || u.expandByPoint(e);
                },
                m = 0,
                c = e;
              m < c.length;
              m++
            ) {
              var p = c[m];
              this.calculateZoomToFitBounds(h, p, t);
            }
            l.isValid() &&
              ((a = l.getCenter()),
              n.useBoundingSphere &&
                ((r = 0.75 * l.getRadius()),
                u.expandByPoint(a.add(new BABYLON.Vector3(r, r, r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(-r, r, r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(-r, -r, r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(r, -r, r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(r, r, -r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(-r, r, -r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(-r, -r, -r))),
                u.expandByPoint(a.add(new BABYLON.Vector3(r, -r, -r))))),
              null != a &&
                u.isValid() &&
                ((this.mCamera.position = u.getCameraPosition()),
                (o = 1.5 * this.mCamera.minZ),
                BABYLON.Vector3.Distance(this.mCamera.position, a) < o &&
                  ((s = this.mCamera.position
                    .subtract(a)
                    .normalize()).scaleInPlace(o),
                  this.mCamera.position.addInPlace(s)),
                null != this.mFixedTarget &&
                  n.adjustFixedTarget &&
                  this.setFixedTarget(a),
                this.updateViewPlane(),
                this.notifyChange());
          }),
          (d.prototype.getZoomToFitMarginV = function (e) {
            var t = 0.05;
            return (
              null != e &&
                (null != e.margin && (t = e.margin),
                null != e.minMarginPx &&
                  this.mView.height * t < e.minMarginPx &&
                  (t = e.minMarginPx / this.mView.height)),
              t
            );
          }),
          (d.prototype.getZoomToFitMarginH = function (e) {
            var t,
              i,
              n = 0.05;
            return (
              null != e &&
                (null != (t = null != e.marginH ? e.marginH : e.margin) &&
                  (n = t),
                null !=
                  (i =
                    null != e.minMarginPxH ? e.minMarginPxH : e.minMarginPx) &&
                  this.mView.width * n < i &&
                  (n = i / this.mView.width)),
              n
            );
          }),
          (d.DEFAULT_CAMERA_ORTHO = 3),
          (d.DEFAULT_CAMERA_POSITION = new BABYLON.Vector3(-1, 3, -4)),
          (d.NODEDATA_CAMERAMODEMASK = 'core:cameraModeMask'),
          (d.ZOOM_NO_HIT_MIN_TARGETDISTANCE = 1),
          (d.OTHO_SNAP_TOLERANCE = 0.08),
          (d.MIN_ORTHO = 0.01),
          d);
        function d(e, t) {
          var i = this;
          (this.eventCameraModeChanged = new u.utils.ListenableEvent(this)),
            (this.eventCameraChanged = new u.utils.ListenableEvent(this)),
            (this.onOrbitStopped = function () {
              i.mOrbitStarted = !1;
            }),
            (this.mViewer = e),
            (this.mView = t),
            (this.mCamera = t.camera),
            (this.mModel = this.mViewer.app.model),
            (this.mToolManager = this.mViewer.app.tools),
            (this.orbitSpeed = 0.005),
            (this.wheelZoomSpeed = 0.0015),
            (this.touchZoomSpeed = 1),
            (this.mOrbitRawRotation = BABYLON.Vector3.Zero()),
            (this.mOrbitInertia = 0),
            (this.mOrbitDelta = BABYLON.Vector2.Zero()),
            (this.mOrbitStartTime = Number.MAX_VALUE),
            (this.mOrbitStarted = !1),
            (this.mOrbitStoppedTimer = new u.utils.async.Timer(
              this.onOrbitStopped
            )),
            (this.mApplyOrbitInertia = !1),
            (this.pitchMax = u.utils.math.PI_DIV2 - u.utils.math.EPSILON),
            (this.pitchMin = -this.pitchMax),
            (this.yawMax = u.utils.math.PI_MUL2),
            (this.yawMin = -u.utils.math.PI_MUL2),
            this.setNavigationArea(20),
            (this.controlsEnabled = !0),
            (this.orbitEnabled = !0),
            (this.panningEnabled = !0),
            (this.zoomEnabled = !0),
            (this.orthoOrbitSnappingEnabled = !1),
            (this.dblClickZoomToFitEnabled = !0),
            (this.dblClickZoomToFitOptions = { margin: 0.05 }),
            (this.leftMouseButtonEnabled = !0),
            (this.mCameraMode = 7),
            (this.mCameraModeMask = 128),
            (this.mIsDirectionLocked = !1),
            (this.mWasCameraChanged = !0),
            (this.mChanged = !1),
            (this.mChangeDepth = 0),
            (this.mTransformMatrix = null),
            (this.mPanningPickPos = null),
            (this.mOrbitPickPos = null),
            (this.mZoomPickPos = null),
            (this.mZoomPickDistance = 0),
            (this.mToolInteractionMode = 0),
            (this.mGroundPlane = new BABYLON.Plane(0, 1, 0, 0)),
            (this.mTargetDistance = this.mNavAreaRadius),
            (this.mDirection = u.utils.math.VECTOR3_Z.clone()),
            (this.mRight = u.utils.math.VECTOR3_X.clone()),
            (this.mCameraModeSettings = new Map()),
            (this.mCamera.minZ = 0.1),
            (this.mCamera.maxZ = 100),
            this.mCamera.notifyProjectionChanged(),
            this.resetCamera(!0, !1),
            this.updateDirection(),
            this._updateCSSPerspective(),
            (this.mFixedTarget = null);
        }
        a.CameraControl = i;
        var f =
          ((n.prototype.isValid = function () {
            return this.mMinX < this.mMaxX || this.mMinY < this.mMaxY;
          }),
          (n.prototype.expandByPoint = function (e) {
            var t = BABYLON.Vector3.TransformCoordinates(e, this.mViewMatrix);
            (this.mMinX === Number.MAX_VALUE ||
              this.mMinXZ - this.mHalfFovXCos * (t.x - this.mMinX) > t.z) &&
              ((this.mMinX = t.x), (this.mMinXZ = t.z)),
              (this.mMaxX === -Number.MAX_VALUE ||
                this.mMaxXZ + this.mHalfFovXCos * (t.x - this.mMaxX) > t.z) &&
                ((this.mMaxX = t.x), (this.mMaxXZ = t.z)),
              (this.mMinY === Number.MAX_VALUE ||
                this.mMinYZ - this.mHalfFovYCos * (t.y - this.mMinY) > t.z) &&
                ((this.mMinY = t.y), (this.mMinYZ = t.z)),
              (this.mMaxY === -Number.MAX_VALUE ||
                this.mMaxYZ + this.mHalfFovYCos * (t.y - this.mMaxY) > t.z) &&
                ((this.mMaxY = t.y), (this.mMaxYZ = t.z));
          }),
          (n.prototype.getCameraPosition = function () {
            var e =
                ((this.mMinXZ - this.mMaxXZ) / this.mHalfFovXCos +
                  this.mMinX +
                  this.mMaxX) /
                2,
              t = this.mMaxXZ + this.mHalfFovXCos * (e - this.mMaxX),
              i =
                ((this.mMinYZ - this.mMaxYZ) / this.mHalfFovYCos +
                  this.mMinY +
                  this.mMaxY) /
                2,
              n = this.mMaxYZ + this.mHalfFovYCos * (i - this.mMaxY),
              r = new BABYLON.Vector3(e, i, Math.min(t, n));
            return (
              BABYLON.Vector3.TransformCoordinatesToRef(
                r,
                this.mViewMatrix.invert(),
                r
              ),
              r
            );
          }),
          n);
        function n(e, t, i, n) {
          var r, o, s;
          (this.mMinX = +Number.MAX_VALUE),
            (this.mMinXZ = +Number.MAX_VALUE),
            (this.mMaxX = -Number.MAX_VALUE),
            (this.mMaxXZ = -Number.MAX_VALUE),
            (this.mMinY = +Number.MAX_VALUE),
            (this.mMinYZ = +Number.MAX_VALUE),
            (this.mMaxY = -Number.MAX_VALUE),
            (this.mMaxYZ = -Number.MAX_VALUE),
            e.fovMode === BABYLON.Camera.FOVMODE_VERTICAL_FIXED
              ? ((o = t.width / t.height),
                (r = e.fov),
                (this.mHalfFovXCos = 1 / (o * Math.tan(((1 - i) * r) / 2))),
                (this.mHalfFovYCos = 1 / Math.tan(((1 - n) * r) / 2)))
              : ((o = t.height / t.width),
                (s = e.fov),
                (this.mHalfFovXCos = 1 / Math.tan(((1 - i) * s) / 2)),
                (this.mHalfFovYCos = 1 / (o * Math.tan(((1 - n) * s) / 2)))),
            (this.mViewMatrix = e.getViewMatrix());
        }
        var r = BABYLON.Ray.Zero(),
          s = BABYLON.Quaternion.Identity(),
          l = BABYLON.Quaternion.Identity();
      })((b = u.core || (u.core = {})).view || (b.view = {}));
  })((egr = egr || {})),
  (function (e) {
    var a, t;
    (a = e.wcf || (e.wcf = {})),
      (function (e) {
        var t, i;
        ((t = e.PointerButton || (e.PointerButton = {}))[(t.Unknown = -2)] =
          'Unknown'),
          (t[(t.None = -1)] = 'None'),
          (t[(t.Left = 0)] = 'Left'),
          (t[(t.Middle = 1)] = 'Middle'),
          (t[(t.Right = 2)] = 'Right'),
          ((i = e.PointerButtonFlags || (e.PointerButtonFlags = {}))[
            (i.None = 0)
          ] = 'None'),
          (i[(i.Left = 1)] = 'Left'),
          (i[(i.Right = 2)] = 'Right'),
          (i[(i.Middle = 4)] = 'Middle');
        var n =
          ((r.prototype.update = function (e) {
            this.previousPosition.copyFrom(this.position),
              this.position.copyFromFloats(e.clientX, e.clientY),
              (this.previousButton = this.button),
              (this.button = null == e.button ? -2 : e.button),
              (this.previousButtons = this.buttons),
              (this.buttons = null == e.buttons ? 0 : e.buttons);
          }),
          (r.IsMousePointer = function (e) {
            return null != e && 'mouse' === e.pointerType;
          }),
          (r.IsPrimaryMousePointer = function (e) {
            return r.IsMousePointer(e) && 0 === e.button;
          }),
          r);
        function r(e) {
          (this.event = e),
            (this.id = e.pointerId),
            (this.type = e.pointerType),
            (this.position = new BABYLON.Vector2(e.clientX, e.clientY)),
            (this.initialPosition = this.position.clone()),
            (this.previousPosition = this.position.clone()),
            (this.isMousePointer = r.IsMousePointer(e)),
            (this.button = null == e.button ? -2 : e.button),
            (this.initialButton = this.button),
            (this.previousButton = this.button),
            (this.buttons = null == e.buttons ? 0 : e.buttons),
            (this.previousButtons = this.buttons),
            (this.pointerDownChangedHoverView = !1);
        }
        e.PointerInfo = n;
        var o =
          ((s.prototype.reset = function () {
            (this.pointers = new Map()), (this.mPointerIds = new Array());
          }),
          (s.prototype.registerPointer = function (e) {
            return (
              !!this.setOrUpdatePointer(e, !1) &&
              (this.mPointerIds.push(e.pointerId), !0)
            );
          }),
          (s.prototype.updatePointer = function (e) {
            return this.setOrUpdatePointer(e, !0);
          }),
          (s.prototype.deregisterPointer = function (e) {
            return (
              !!this.pointers.has(e) &&
              (this.pointers.delete(e),
              a.utils.array.remove(this.mPointerIds, e),
              !0)
            );
          }),
          (s.prototype.getPointer = function (e) {
            var t = this.pointers.get(e);
            return null == t ? null : t;
          }),
          (s.prototype.getPointerByIndex = function (e) {
            if (null == e || e < 0 || e > this.mPointerIds.length - 1)
              return null;
            var t = this.pointers.get(this.mPointerIds[e]);
            return null == t ? null : t;
          }),
          (s.prototype.isPrimaryPointer = function (e) {
            if (null == e || 1 !== this.pointers.size) return !1;
            var t = this.pointers.get(e.pointerId);
            return null != t && (!t.isMousePointer || 0 === t.initialButton);
          }),
          (s.prototype.isMouseHoverPointer = function (e) {
            return 0 === this.pointers.size && n.IsMousePointer(e);
          }),
          (s.prototype._updatePointerPosition = function (e) {
            null != e &&
              (this.pointerPosition.copyFromFloats(e.clientX, e.clientY),
              null != e.pointerType &&
                'pointerup' !== e.type &&
                (this.pointerType = e.pointerType));
          }),
          (s.prototype.setOrUpdatePointer = function (e, t) {
            if ((this._updatePointerPosition(e), t)) {
              if (this.pointers.has(e.pointerId))
                return this.pointers.get(e.pointerId).update(e), !0;
            } else if (!this.pointers.has(e.pointerId))
              return this.pointers.set(e.pointerId, new n(e)), !0;
            return !1;
          }),
          s);
        function s() {
          this.reset(),
            (this.pointerPosition = new BABYLON.Vector2(0, 0)),
            (this.pointerType = '');
        }
        e.InputState = o;
      })((t = a.core || (a.core = {})).view || (t.view = {}));
  })((egr = egr || {})),
  (function (e) {
    var O, t;
    (O = e.wcf || (e.wcf = {})),
      (function (r) {
        var e, t;
        ((e = r.ViewLayerMaskFlags || (r.ViewLayerMaskFlags = {}))[
          (e.None = 0)
        ] = 'None'),
          (e[(e.Active = 1)] = 'Active'),
          (e[(e.Hover = 2)] = 'Hover'),
          (e[(e.Screenshot = 4)] = 'Screenshot'),
          (e[(e.All = 4294967295)] = 'All'),
          ((t = r.CoordinatesType || (r.CoordinatesType = {}))[(t.Client = 1)] =
            'Client'),
          (t[(t.Viewer = 2)] = 'Viewer'),
          (t[(t.View = 3)] = 'View');
        var i =
          (Object.defineProperty(x.prototype, 'viewer', {
            get: function () {
              return this.mViewer;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'camera', {
            get: function () {
              return this.mCamera;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'cameraControl', {
            get: function () {
              return this.mCameraControl;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'overlayDiv', {
            get: function () {
              return this.mOverlayDiv;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'isVisible', {
            get: function () {
              return this.mIsVisible;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'isMaximized', {
            get: function () {
              return this.mIsMaximized;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'width', {
            get: function () {
              return null != this.mSizeOverride
                ? this.mSizeOverride.x
                : this.mCamera.viewport.width * this.mViewer.width;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'height', {
            get: function () {
              return null != this.mSizeOverride
                ? this.mSizeOverride.y
                : this.mCamera.viewport.height * this.mViewer.height;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'renderWidth', {
            get: function () {
              return null != this.mSizeOverride
                ? this.mSizeOverride.x
                : this.mCamera.viewport.width * this.mViewer.canvas.width;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(x.prototype, 'renderHeight', {
            get: function () {
              return null != this.mSizeOverride
                ? this.mSizeOverride.y
                : this.mCamera.viewport.height * this.mViewer.canvas.height;
            },
            enumerable: !1,
            configurable: !0,
          }),
          (x.prototype.dispose = function () {
            this.mViewer.scene.onBeforeCameraRenderObservable.removeCallback(
              this.onBeforeCameraRender
            ),
              this.mViewer.scene.onAfterCameraRenderObservable.removeCallback(
                this.onAfterCameraRender
              ),
              this.mCamera.dispose(),
              null != this.mOverlayDiv &&
                this.mViewer.container.removeChild(this.mOverlayDiv);
          }),
          (x.prototype.maximize = function () {
            if (!this.mIsMaximized) {
              for (var e = 0, t = this.mViewer.views; e < t.length; e++) {
                var i = t[e];
                i !== this && i._setVisible(!1);
              }
              (this.mCamera.viewport = new BABYLON.Viewport(0, 0, 1, 1)),
                this.resize(),
                this.cameraControl.notifyChange(),
                (this.mIsMaximized = !0),
                this.mViewer._notifyViewMaximized(this);
            }
          }),
          (x.prototype.minimize = function () {
            if (this.mIsMaximized) {
              this._setVisible(!1);
              for (var e = 0, t = this.mViewer.views; e < t.length; e++)
                t[e]._setVisible(!0);
              (this.mCamera.viewport = this.mViewport),
                this.resize(),
                this.cameraControl.notifyChange(),
                (this.mIsMaximized = !1);
            }
          }),
          (x.prototype.resize = function () {
            var e, t, i, n;
            this.updateOrthoAspectRatio(),
              null != this.mOverlayDiv &&
                ((e = Math.round(this.width)),
                (t = Math.round(this.mViewer.width * this.mCamera.viewport.x)) +
                  e >
                  this.mViewer.width && --e,
                (i = Math.round(this.height)),
                (n = Math.round(this.mViewer.height * this.mCamera.viewport.y)),
                this.mViewer.height - n - i < 0 && --i,
                (this.mOverlayDiv.style.width = e.toString() + 'px'),
                (this.mOverlayDiv.style.height = i.toString() + 'px'),
                (this.mOverlayDiv.style.left = t.toString() + 'px'),
                (this.mOverlayDiv.style.bottom = n.toString() + 'px'),
                this.mCameraControl._updateCSSPerspective()),
              this.mCameraControl.notifyChange();
          }),
          (x.prototype.pickScene = function (e, t, i) {
            if (null == e) return null;
            var n = B;
            this.convertCoordsToRef(e, t, 2, n), this.setupMeshVisibility();
            var r = this.mViewer.scene.pick(n.x, n.y, i, !1, this.mCamera);
            return this.restoreMeshVisibility(), r;
          }),
          (x.prototype.pickSceneWithFrustum = function (e, t, i, n, r) {
            var o = this.convertCoords(e, n, 2);
            if (null == o) return null;
            var s = null,
              a = this.createPickingFrustum(o, t, i, 2);
            this.createPickingRayToRef(o, 2, null, c),
              this.setupMeshVisibility();
            for (var l = 0, u = this.viewer.scene.meshes; l < u.length; l++) {
              var h = u[l];
              if (null != r) {
                if (!r(h)) continue;
              } else if (!h.isEnabled() || !h.isVisible || !h.isPickable)
                continue;
              var m = this.pickMeshWithFrustum(h, c, a);
              m &&
                m.hit &&
                ((null != s && m.distance >= s.distance) || (s = m));
            }
            return this.restoreMeshVisibility(), s;
          }),
          (x.prototype.createPickingRay = function (e, t, i) {
            void 0 === i && (i = null);
            var n = BABYLON.Ray.Zero();
            return this.createPickingRayToRef(e, t, i, n), n;
          }),
          (x.prototype.createPickingRayToRef = function (e, t, i, n) {
            this.convertCoordsToRef(e, t, 2, B),
              this.mViewer.scene.createPickingRayToRef(
                B.x,
                B.y,
                null == i ? x.sIdentityMatrix : i,
                n,
                this.mCamera,
                !1
              );
          }),
          (x.prototype.createPickingFrustum = function (e, t, i, n) {
            if (null == e) throw new Error(O.utils.ERR_INVALID_ARGUMENT);
            function r(e, t) {
              var i = e.origin.subtract(t.origin);
              i.normalize();
              var n = BABYLON.Vector3.Cross(i, e.direction);
              return BABYLON.Plane.FromPositionAndNormal(e.origin, n);
            }
            var o = this.camera.minZ,
              s = this.camera.maxZ,
              a = this.cameraControl.position,
              l = this.cameraControl.direction,
              u = 0.5 * t,
              h = 0.5 * i,
              m = this.convertCoords(e, n, 2),
              c = new BABYLON.Vector2(m.x - u, m.y - h),
              p = new BABYLON.Vector2(m.x + u, m.y + h),
              d = this.createPickingRay(c, 2),
              f = this.createPickingRay(new BABYLON.Vector2(p.x, c.y), 2),
              g = this.createPickingRay(new BABYLON.Vector2(c.x, p.y), 2),
              v = this.createPickingRay(p, 2),
              y = new Array();
            return (
              y.push(BABYLON.Plane.FromPositionAndNormal(a.add(l.scale(o)), l)),
              y.push(
                BABYLON.Plane.FromPositionAndNormal(
                  a.add(l.scale(s)),
                  l.negate()
                )
              ),
              y.push(r(d, g)),
              y.push(r(v, f)),
              y.push(r(f, d)),
              y.push(r(g, v)),
              y
            );
          }),
          (x.prototype.projectPoint2 = function (e, t, i, n) {
            void 0 === i && (i = null), void 0 === n && (n = !0);
            var r = this.internalProjectPoint(e, i, n);
            if (null == r) return null;
            var o = new BABYLON.Vector2(r.x, r.y);
            return this.convertCoordsToRef(o, 3, t, o), o;
          }),
          (x.prototype.projectPoint3 = function (e, t, i, n) {
            void 0 === i && (i = null), void 0 === n && (n = !0);
            var r = this.internalProjectPoint(e, i, n);
            return null == r ? null : (this.convertCoordsToRef(r, 3, t, r), r);
          }),
          (x.prototype.unprojectPoint = function (e, t, i) {
            void 0 === i && (i = null);
            var n = BABYLON.Vector3.Zero();
            return this.unprojectPointToRef(e, t, i, n), n;
          }),
          (x.prototype.unprojectPointToRef = function (e, t, i, n) {
            if (null == e) throw new Error(O.utils.ERR_INVALID_ARGUMENT);
            n.copyFrom(e),
              this.convertCoordsToRef(e, t, 3, n),
              BABYLON.Vector3.UnprojectToRef(
                n,
                this.width,
                this.height,
                null == i ? x.sIdentityMatrix : i,
                this.mCamera.getViewMatrix(),
                this.mCamera.getProjectionMatrix(),
                n
              );
          }),
          (x.prototype.projectedDistance = function (e, t, i) {
            if ((void 0 === i && (i = null), null == e || null == t))
              return null;
            var n = this.projectPoint2(e, 3, i);
            if (null == n) return null;
            var r = this.projectPoint2(t, 3, i);
            return null == r ? null : BABYLON.Vector2.Distance(n, r);
          }),
          (x.prototype.viewerToViewCoords = function (e) {
            if (null == e) throw new Error(O.utils.ERR_INVALID_ARGUMENT);
            var t = BABYLON.Vector2.Zero();
            return this.viewerToViewCoordsToRef(e, t), t;
          }),
          (x.prototype.viewerToViewCoordsToRef = function (e, t) {
            var i, n;
            null != e &&
              null != t &&
              ((i = this.mCamera.viewport.x * this.mViewer.width),
              (n = this.mCamera.viewport.y * this.mViewer.height),
              (t.x = e.x - i),
              (t.y = e.y - (this.mViewer.height - n - this.height)));
          }),
          (x.prototype.viewToViewerCoords = function (e) {
            if (null == e) throw new Error(O.utils.ERR_INVALID_ARGUMENT);
            var t = BABYLON.Vector2.Zero();
            return this.viewToViewerCoordsToRef(e, t), t;
          }),
          (x.prototype.viewToViewerCoordsToRef = function (e, t) {
            var i, n;
            null != e &&
              null != t &&
              ((i = this.mCamera.viewport.x * this.mViewer.width),
              (n = this.mCamera.viewport.y * this.mViewer.height),
              (t.x = e.x + i),
              (t.y = e.y + (this.mViewer.height - n - this.height)));
          }),
          (x.prototype.convertCoords = function (e, t, i) {
            if (null == e) throw new Error(O.utils.ERR_INVALID_ARGUMENT);
            var n = BABYLON.Vector2.Zero();
            return this.convertCoordsToRef(e, t, i, n), n;
          }),
          (x.prototype.convertCoordsToRef = function (e, t, i, n) {
            null != e &&
              null != n &&
              ((n.x = e.x),
              (n.y = e.y),
              t !== i &&
                (t < i
                  ? (t <= 1 &&
                      2 <= i &&
                      this.mViewer.clientToViewerCoordsToRef(n, n),
                    t <= 2 && 3 <= i && this.viewerToViewCoordsToRef(n, n))
                  : (3 <= t && i <= 2 && this.viewToViewerCoordsToRef(n, n),
                    1 <= t &&
                      i <= 1 &&
                      this.mViewer.viewerToClientCoordsToRef(n, n))));
          }),
          (x.prototype.serialize = function () {
            return { cameraSettings: this.cameraControl.serialize() };
          }),
          (x.prototype.deserialize = function (e) {
            return (
              null != e &&
              (this.cameraControl.deserialize(e.cameraSettings), !0)
            );
          }),
          (x._GetLocalFrustum = function (e, t) {
            for (
              var i = t.getWorldMatrix().transpose(),
                n = new Array(),
                r = 0,
                o = e;
              r < o.length;
              r++
            ) {
              var s = o[r];
              n.push(s.transform(i));
            }
            return n;
          }),
          (x.prototype._setVisible = function (e) {
            this.mIsVisible !== e &&
              ((this.mIsVisible = e)
                ? (this.mViewer.scene.activeCameras.push(this.mCamera),
                  null != this.mOverlayDiv &&
                    (this.mOverlayDiv.style.display = 'block'))
                : (O.utils.array.remove(
                    this.mViewer.scene.activeCameras,
                    this.mCamera
                  ),
                  null != this.mOverlayDiv &&
                    (this.mOverlayDiv.style.display = 'none')));
          }),
          (x.prototype._setActive = function (e) {
            e
              ? ((this.mCamera.layerMask |= 1),
                null != this.mOverlayDiv &&
                  this.mOverlayDiv.setAttribute('data-state', 'active'))
              : ((this.mCamera.layerMask &= -2),
                null != this.mOverlayDiv &&
                  this.mOverlayDiv.removeAttribute('data-state'));
          }),
          (x.prototype._setHover = function (e) {
            e ? (this.mCamera.layerMask |= 2) : (this.mCamera.layerMask &= -3);
          }),
          (x.prototype._prepareRenderFrame = function (e) {
            var t;
            (this.mMSAASamplingStep = e),
              0 <= this.mMSAASamplingStep
                ? (0 === this.mMSAASamplingStep &&
                    this.mMSAASamplingPassAttached &&
                    (this.detachPostProcess(this.mMSAASamplingPass),
                    (this.mMSAASamplingPassAttached = !1)),
                  0 < this.mMSAASamplingStep &&
                    !this.mMSAASamplingPassAttached &&
                    (this.attachPostProcess(this.mMSAASamplingPass),
                    (this.mMSAASamplingPassAttached = !0)),
                  this.mMSAASamplingStep % 2 == 0
                    ? (this.attachPostProcess(this.mMSAAResultPass2),
                      (this.mMSAAResultPass2Attached = !0))
                    : (this.attachPostProcess(this.mMSAAResultPass1),
                      (this.mMSAAResultPass1Attached = !0)),
                  (t = x.sSamplingOffsets[this.mMSAASamplingStep]),
                  this.mCamera._setProjectionOffset(
                    t.x / this.renderWidth,
                    t.y / this.renderHeight
                  ))
                : (this.mMSAASamplingPassAttached &&
                    (this.detachPostProcess(this.mMSAASamplingPass),
                    (this.mMSAASamplingPassAttached = !1)),
                  this.mMSAAResultPass1Attached &&
                    (this.detachPostProcess(this.mMSAAResultPass1),
                    (this.mMSAAResultPass1Attached = !1)),
                  this.mMSAAResultPass2Attached &&
                    (this.detachPostProcess(this.mMSAAResultPass2),
                    (this.mMSAAResultPass2Attached = !1)));
          }),
          (x.prototype._finalizeRenderFrame = function () {
            0 <= this.mMSAASamplingStep &&
              (this.mMSAASamplingStep % 2 == 0
                ? (this.detachPostProcess(this.mMSAAResultPass2),
                  (this.mMSAAResultPass2Attached = !1))
                : (this.detachPostProcess(this.mMSAAResultPass1),
                  (this.mMSAAResultPass1Attached = !1)),
              this.mCamera._setProjectionOffset(0, 0));
          }),
          (x.prototype._setSizeOverride = function (e, t) {
            (this.mSizeOverride = e),
              null != this.mSizeOverride
                ? this.mCamera._setFixedAspectRatio(
                    this.mSizeOverride.x / this.mSizeOverride.y
                  )
                : this.mCamera._setFixedAspectRatio(null),
              this.updateOrthoAspectRatio(),
              this.mCamera.notifyProjectionChanged(),
              this.mCameraControl.notifyChange(t);
          }),
          (x.prototype._getSizeOverride = function () {
            return this.mSizeOverride;
          }),
          (x.prototype._isOffscreenView = function () {
            return !1;
          }),
          (x.prototype.createOverlayDiv = function () {
            (this.mOverlayDiv = document.createElement('div')),
              (this.mOverlayDiv.className = 'wcf-core view'),
              this.mOverlayDiv.setAttribute('touch-action', 'none'),
              (this.mOverlayDiv.style.display = 'none'),
              this.mViewer.container.appendChild(this.mOverlayDiv);
          }),
          (x.prototype.setupMeshVisibility = function () {
            for (var e = 0, t = this.mViewer.scene.meshes; e < t.length; e++) {
              var i,
                n = t[e];
              (n._wcf_core_wasVisible = n.isVisible),
                !n.isVisible ||
                  (null != (i = r.CameraControl.GetMeshCameraModeMask(n)) &&
                    0 == (i & this.mCameraControl._camerModeMask) &&
                    (n.isVisible = !1));
            }
          }),
          (x.prototype.restoreMeshVisibility = function () {
            for (var e = 0, t = this.mViewer.scene.meshes; e < t.length; e++) {
              var i = t[e];
              i.isVisible = i._wcf_core_wasVisible;
            }
          }),
          (x.prototype.updateOrthoAspectRatio = function () {
            var e, t;
            this.mCamera.fovMode === BABYLON.Camera.FOVMODE_VERTICAL_FIXED
              ? ((e = this.renderWidth / this.renderHeight),
                (t = this.mCamera.orthoTop),
                (this.mCamera.orthoBottom = -t),
                (this.mCamera.orthoLeft = -t * e),
                (this.mCamera.orthoRight = t * e))
              : ((e = this.renderHeight / this.renderWidth),
                (t = this.mCamera.orthoRight),
                (this.mCamera.orthoLeft = -t),
                (this.mCamera.orthoTop = t * e),
                (this.mCamera.orthoBottom = -t * e)),
              this.mCamera.notifyProjectionChanged();
          }),
          (x.prototype.internalProjectPoint = function (e, t, i) {
            if (
              (void 0 === t && (t = null), void 0 === i && (i = !0), null == e)
            )
              return null;
            var n = BABYLON.Vector3.Project(
              e,
              null == t ? x.sIdentityMatrix : t,
              this.mCameraControl.transformMatrix,
              x.sProjectViewport
            );
            return i && (n.z < 0 || 1 < n.z)
              ? null
              : ((n.x *= this.width), (n.y *= this.height), n);
          }),
          (x.prototype.setupMSAA = function () {
            var i = this,
              e = new n(this);
            (this.mMSAASamplingPass = new BABYLON.PostProcess(
              'MSAASampling',
              'wcf.core.MSAA',
              ['amount'],
              ['lastFrameSampler'],
              e,
              this.mCamera,
              BABYLON.Constants.TEXTURE_NEAREST_NEAREST
            )),
              this.mMSAASamplingPass.onApplyObservable.add(function (e) {
                i.mMSAASamplingStep % 2 == 0
                  ? e.setTextureFromPostProcess(
                      'lastFrameSampler',
                      i.mMSAAResultPass1
                    )
                  : e.setTextureFromPostProcess(
                      'lastFrameSampler',
                      i.mMSAAResultPass2
                    );
                var t = 1 / (i.mMSAASamplingStep + 1);
                e.setFloat('amount', t);
              }),
              (this.mMSAAResultPass1 = new BABYLON.PassPostProcess(
                'MSAAResultPass1',
                e,
                this.mCamera,
                BABYLON.Constants.TEXTURE_NEAREST_NEAREST
              )),
              (this.mMSAAResultPass2 = new BABYLON.PassPostProcess(
                'MSAAResultPass2',
                e,
                this.mCamera,
                BABYLON.Constants.TEXTURE_NEAREST_NEAREST
              )),
              this.detachPostProcess(this.mMSAASamplingPass),
              this.detachPostProcess(this.mMSAAResultPass1),
              this.detachPostProcess(this.mMSAAResultPass2),
              (this.mMSAASamplingPassAttached = !1),
              (this.mMSAAResultPass1Attached = !1),
              (this.mMSAAResultPass2Attached = !1),
              (this.mMSAASamplingStep = 0);
          }),
          (x.prototype.attachPostProcess = function (e) {
            this.mCamera._postProcesses.push(e);
          }),
          (x.prototype.detachPostProcess = function (e) {
            O.utils.array.remove(this.mCamera._postProcesses, e);
          }),
          (x.prototype.pickMeshWithFrustum = function (e, t, i) {
            if (null == e || null == i) return null;
            if (
              !(
                (e instanceof BABYLON.Mesh && null != e.geometry) ||
                e instanceof BABYLON.InstancedMesh
              )
            )
              return null;
            var n = null,
              r = null,
              o = e.getBoundingInfo();
            if (null != o && o.isInFrustum(i)) {
              if (!e._generatePointsArray()) return null;
              var s = e.getWorldMatrix(),
                a = BABYLON.Matrix.Invert(s),
                l = e._positions;
              if (null == l) return null;
              var u = BABYLON.Ray.Transform(t, a),
                h = x._GetLocalFrustum(i, e),
                m = e.getIndices();
              if (null == m) return null;
              for (var c = 0; c < m.length; c += 3) {
                var p,
                  d,
                  f,
                  g,
                  v,
                  y,
                  A,
                  w,
                  C = l[m[c]],
                  P = l[m[c + 1]],
                  b = l[m[c + 2]];
                O.utils.math.isTriangleInFrustum(C, P, b, h) &&
                  (null != (p = u.intersectsTriangle(C, P, b))
                    ? (null == n || p.distance < n) &&
                      ((n = p.distance), (r = null))
                    : ((d = B),
                      O.utils.math.triangleNormalToRef(C, P, b, d),
                      (f = BABYLON.Plane.FromPositionAndNormal(C, d)),
                      null != (g = O.utils.math.intersectRayPlane(u, f)) &&
                        ((v = E),
                        (y = L),
                        O.utils.math.projectPointOnLine3ToRef(g, C, P, !0, v),
                        (A = BABYLON.Vector3.DistanceSquared(v, g)),
                        O.utils.math.projectPointOnLine3ToRef(g, P, b, !0, y),
                        BABYLON.Vector3.DistanceSquared(y, g) < A && (v = y),
                        O.utils.math.projectPointOnLine3ToRef(g, b, C, !0, y),
                        BABYLON.Vector3.DistanceSquared(y, g) < A && (v = y),
                        O.utils.math.isPointInFrustum(v, h) &&
                          ((w = BABYLON.Vector3.Distance(v, u.origin)),
                          (null == n || w < n) && ((n = w), (r = v))))));
              }
              if (null != n) {
                var S,
                  T,
                  M = new BABYLON.PickingInfo();
                return (
                  (M.hit = !0),
                  (M.pickedMesh = e),
                  null == r
                    ? ((S = u.direction.scale(n)),
                      (T = BABYLON.Vector3.TransformNormal(S, s)),
                      (M.pickedPoint = t.origin.add(T)))
                    : (M.pickedPoint = BABYLON.Vector3.TransformCoordinates(
                        r,
                        s
                      )),
                  (M.distance = BABYLON.Vector3.Distance(
                    t.origin,
                    M.pickedPoint
                  )),
                  M
                );
              }
            }
            return null;
          }),
          (x.sProjectViewport = new BABYLON.Viewport(0, 0, 1, 1)),
          (x.sIdentityMatrix = BABYLON.Matrix.Identity()),
          (x.sSamplingOffsets = [
            new BABYLON.Vector2(0, 0),
            new BABYLON.Vector2(0.7, 0.7),
            new BABYLON.Vector2(-0.7, 0.7),
            new BABYLON.Vector2(-0.7, -0.7),
            new BABYLON.Vector2(0.7, -0.7),
            new BABYLON.Vector2(0.6, 0.3),
            new BABYLON.Vector2(-0.6, 0.3),
            new BABYLON.Vector2(-0.6, -0.3),
            new BABYLON.Vector2(0.6, -0.3),
            new BABYLON.Vector2(0.3, 0.6),
            new BABYLON.Vector2(-0.3, 0.6),
            new BABYLON.Vector2(-0.3, -0.6),
            new BABYLON.Vector2(0.3, -0.6),
            new BABYLON.Vector2(0.5, 0),
            new BABYLON.Vector2(-0.5, 0),
            new BABYLON.Vector2(0, 0.5),
            new BABYLON.Vector2(0, -0.5),
            new BABYLON.Vector2(0.3, 0.3),
            new BABYLON.Vector2(-0.3, 0.3),
            new BABYLON.Vector2(-0.3, -0.3),
            new BABYLON.Vector2(0.3, -0.3),
            new BABYLON.Vector2(1, 1),
            new BABYLON.Vector2(-1, 1),
            new BABYLON.Vector2(-1, -1),
            new BABYLON.Vector2(1, -1),
            new BABYLON.Vector2(0.9, 0.2),
            new BABYLON.Vector2(-0.9, 0.2),
            new BABYLON.Vector2(-0.9, -0.2),
            new BABYLON.Vector2(0.9, -0.2),
            new BABYLON.Vector2(0.2, 0.9),
            new BABYLON.Vector2(-0.2, 0.9),
            new BABYLON.Vector2(-0.2, -0.9),
            new BABYLON.Vector2(0.2, -0.9),
          ]),
          x);
        function x(e, t) {
          var i = this;
          (this.onBeforeCameraRender = function (e) {
            e === i.mCamera && i.setupMeshVisibility();
          }),
            (this.onAfterCameraRender = function (e) {
              e === i.mCamera && i.restoreMeshVisibility();
            }),
            (this.mViewer = e),
            (this.mIsVisible = !1),
            (this.mIsMaximized = !1),
            (this.mSizeOverride = null),
            (this.mOverlayDiv = null),
            (this.pixelScaleFactor = 1),
            (this.mCamera = new r.Camera(this)),
            this.mViewer.scene.onBeforeCameraRenderObservable.add(
              this.onBeforeCameraRender
            ),
            this.mViewer.scene.onAfterCameraRenderObservable.add(
              this.onAfterCameraRender
            ),
            null != t && (this.mCamera.viewport = t),
            (this.mViewport = this.mCamera.viewport),
            (this.mCamera.layerMask = -8),
            this.createOverlayDiv(),
            (this.mCameraControl = new r.CameraControl(this.mViewer, this)),
            this.setupMSAA(),
            this._setActive(!1);
        }
        r.View = i;
        var n =
          (Object.defineProperty(o.prototype, 'width', {
            get: function () {
              return this.mView.renderWidth;
            },
            enumerable: !1,
            configurable: !0,
          }),
          Object.defineProperty(o.prototype, 'height', {
            get: function () {
              return this.mView.renderHeight;
            },
            enumerable: !1,
            configurable: !0,
          }),
          o);
        function o(e) {
          this.mView = e;
        }
        var B = BABYLON.Vector3.Zero(),
          E = BABYLON.Vector3.Zero(),
          L = BABYLON.Vector3.Zero(),
          c = BABYLON.Ray.Zero();
      })((t = O.core || (O.core = {})).view || (t.view = {}));
  })((egr = egr || {})),
  (BABYLON.Effect.ShadersStore['wcf.core.MSAAFragmentShader'] =
    '\nprecision highp float;\n\nvarying vec2 vUV;\nuniform float amount;\nuniform sampler2D textureSampler;\nuniform sampler2D lastFrameSampler;\n\nvoid main(void)\n{\n    vec4 current = texture2D(textureSampler, vUV);\n    vec4 last = texture2D(lastFrameSampler, vUV);\n\n    gl_FragColor = last * (1.0 - amount) + current * amount;\n}'),
  (function (e) {
    var t, i, n, r, o;
    function s(e) {
      var t = r.call(this, e) || this;
      return t.setSize(640, 480), t;
    }
    (t = e.wcf || (e.wcf = {})),
      (i = t.core || (t.core = {})),
      (n = i.view || (i.view = {})),
      (r = n.View),
      __extends(s, r),
      (s.prototype.setSize = function (e, t) {
        this._setSizeOverride(new BABYLON.Vector2(e, t), !0);
      }),
      (s.prototype.maximize = function () {
        t.utils.Log.warn(
          'Maximize/minimize not supported from ScreenshotView.'
        );
      }),
      (s.prototype.minimize = function () {
        t.utils.Log.warn(
          'Maximize/minimize not supported from ScreenshotView.'
        );
      }),
      (s.prototype._isOffscreenView = function () {
        return !0;
      }),
      (s.prototype.createOverlayDiv = function () {}),
      (o = s),
      (n.ScreenshotView = o);
  })((egr = egr || {})),
  (function (e) {
    var S, t, o, i;
    function T(e, t) {
      var n = this;
      (this.eventResize = new S.utils.ListenableEvent(this)),
        (this.eventBeforeRender = new S.utils.ListenableEvent(this)),
        (this.eventAfterRender = new S.utils.ListenableEvent(this)),
        (this.eventActiveViewChanged = new S.utils.ListenableEvent(this)),
        (this.eventHoverViewChanged = new S.utils.ListenableEvent(this)),
        (this.eventViewAdded = new S.utils.ListenableEvent(this)),
        (this.eventViewRemoved = new S.utils.ListenableEvent(this)),
        (this.resetDoubleClickState = function () {
          (n.mDoubleClickCounter = 0),
            null != n.mDoubleClickTimer &&
              (clearTimeout(n.mDoubleClickTimer), (n.mDoubleClickTimer = null));
        }),
        (this.onResize = function () {
          n.resize();
        }),
        (this.onPointerDown = function (e) {
          var t, i;
          n.mInputState.registerPointer(e) &&
            ((t = n.updateActiveView(
              new BABYLON.Vector2(e.clientX, e.clientY),
              !1
            )),
            null != (i = n.mInputState.pointers.get(e.pointerId)) &&
              (i.pointerDownChangedHoverView = t),
            n.mTools._handlePointerDown(e, n.mInputState),
            null != n.mActiveView &&
              n.mActiveView.cameraControl._handlePointerDown(e, n.mInputState),
            n.mCanvas.setPointerCapture(e.pointerId),
            document.activeElement != n.mCanvas && n.mCanvas.focus(),
            0 === n.mDoubleClickCounter &&
              (n.mDoubleClickTimer = setTimeout(
                n.resetDoubleClickState,
                T.MAX_DOUBLE_CLICK_DELAY
              )),
            n.mDoubleClickCounter++,
            n.createPointerFeedback(e),
            e.preventDefault());
        }),
        (this.onPointerUp = function (e) {
          n.mInputState.updatePointer(e) &&
            (n.mTools._handlePointerUp(e, n.mInputState),
            null != n.mActiveView &&
              n.mActiveView.cameraControl._handlePointerUp(e, n.mInputState),
            2 <= n.mDoubleClickCounter &&
              (n.resetDoubleClickState(),
              n.mTools._handlePointerDblClick(e, n.mInputState),
              null != n.mActiveView &&
                n.mActiveView.cameraControl._handlePointerDblClick(
                  e,
                  n.mInputState
                )),
            n.mInputState.deregisterPointer(e.pointerId),
            e.preventDefault());
        }),
        (this.onPointerMove = function (e) {
          var t;
          !n.mInputState.updatePointer(e) ||
            (null != (t = n.mInputState.pointers.get(e.pointerId)) &&
              (Math.abs(t.initialPosition.x - t.position.x) >
                T.POINTER_MOVE_TOLERANCE ||
                Math.abs(t.initialPosition.y - t.position.y) >
                  T.POINTER_MOVE_TOLERANCE) &&
              n.resetDoubleClickState()),
            n.updateHoverView(e, n.mInputState),
            n.mTools._handlePointerMove(e, n.mInputState),
            null != n.mActiveView &&
              n.mActiveView.cameraControl._handlePointerMove(e, n.mInputState),
            e.preventDefault();
        }),
        (this.onPointerCancel = function (e) {
          n.mInputState.pointers.has(e.pointerId) &&
            (null != n.mActiveView &&
              n.mActiveView.cameraControl._handlePointerCancel(
                e,
                n.mInputState
              ),
            n.mTools._handlePointerCancel(e, n.mInputState),
            n.mInputState.deregisterPointer(e.pointerId),
            n.mCanvas.releasePointerCapture(e.pointerId),
            n.resetDoubleClickState());
        }),
        (this.onKeyUp = function (e) {
          n.mTools._handleKeyUp(e, n.mInputState);
        }),
        (this.onMouseWheel = function (e) {
          n.mInputState._updatePointerPosition(e),
            n.updateActiveView(new BABYLON.Vector2(e.clientX, e.clientY), !0),
            null != n.mActiveView &&
              n.mActiveView.cameraControl._handleMouseWheel(e, n.mInputState),
            e.preventDefault();
        }),
        (this.onContextMenu = function (e) {
          e.preventDefault();
        }),
        (this.onScroll = function (e) {
          n.mClientOffset = null;
        }),
        (this.mApp = e),
        (this.mContainer = t),
        (this.mViews = new Array()),
        (this.mActiveView = null),
        (this.mHoverView = null),
        (this.mRenderFrameRequested = !0),
        (this.mDisableRenderingDepth = 0),
        (this.showPointerFeedback = !0),
        (this.onDemandRenderingEnabled = !0),
        (this.mInputState = new o.InputState()),
        (this.mDoubleClickCounter = 0),
        (this.mDoubleClickTimer = null),
        (this.mWidth = -1),
        (this.mHeight = -1),
        (this.mClientOffset = null),
        (this.mResizeTimeOut = null),
        (this.mNextMSAAStep = -1),
        (this.mMSAAQuality = T.MSAA_MAX_QUALITY),
        (this.mMSAADelayFrame = 0),
        (this.mScreenshotLock = new S.utils.async.Lock()),
        (this.mContainer.style.position = 'relative'),
        (this.mCanvas = document.createElement('canvas')),
        (this.mCanvas.style.width = this.getContainerWidth().toString() + 'px'),
        (this.mCanvas.style.height =
          this.getContainerHeight().toString() + 'px'),
        (this.mCanvas.style.display = 'block'),
        (this.mCanvas.style.outline = 'none'),
        (this.mCanvas.style.msUserSelect = 'none'),
        (this.mCanvas.style.webkitUserSelect = 'none'),
        (this.mCanvas.style.userSelect = 'none'),
        (this.mCanvas.tabIndex = 0),
        this.mCanvas.setAttribute('touch-action', 'none'),
        this.mContainer.appendChild(this.mCanvas);
    }
    (S = e.wcf || (e.wcf = {})),
      (t = S.core || (S.core = {})),
      (o = t.view || (t.view = {})),
      Object.defineProperty(T.prototype, 'app', {
        get: function () {
          return this.mApp;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'container', {
        get: function () {
          return this.mContainer;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'canvas', {
        get: function () {
          return this.mCanvas;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'scene', {
        get: function () {
          return this.mScene;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'width', {
        get: function () {
          return this.mWidth;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'height', {
        get: function () {
          return this.mHeight;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'views', {
        get: function () {
          return this.mViews;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'activeView', {
        get: function () {
          return this.mActiveView;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'hoverView', {
        get: function () {
          return this.mHoverView;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'inputState', {
        get: function () {
          return this.mInputState;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'backgroundColor', {
        get: function () {
          return this.mScene.clearColor;
        },
        set: function (e) {
          this.mScene.clearColor = e;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'renderingEnabled', {
        get: function () {
          return 0 === this.mDisableRenderingDepth;
        },
        enumerable: !1,
        configurable: !0,
      }),
      Object.defineProperty(T.prototype, 'antiAliasingQuality', {
        get: function () {
          return this.mMSAAQuality;
        },
        set: function (e) {
          this.mMSAAQuality = S.utils.math.clamp(e, 0, T.MSAA_MAX_QUALITY);
        },
        enumerable: !1,
        configurable: !0,
      }),
      (T.prototype.initialize = function (e) {
        return (
          null != this.mApp.model &&
          null != this.mApp.tools &&
          ((this.mApp.engine.canvasTabIndex = this.mCanvas.tabIndex),
          (this.mScene = this.mApp.scene),
          (this.mScene.clearColor = new BABYLON.Color4(1, 1, 1, 1)),
          (this.mTools = this.mApp.tools),
          (this.mWidth = this.mCanvas.clientWidth),
          (this.mHeight = this.mCanvas.clientHeight),
          e && window.addEventListener('resize', this.onResize),
          this.mCanvas.addEventListener('pointerdown', this.onPointerDown, !1),
          this.mCanvas.addEventListener('pointerup', this.onPointerUp, !1),
          this.mCanvas.addEventListener('pointermove', this.onPointerMove, !1),
          this.mCanvas.addEventListener(
            'pointercancel',
            this.onPointerCancel,
            !1
          ),
          this.mCanvas.addEventListener('keyup', this.onKeyUp, !1),
          this.mCanvas.addEventListener('wheel', this.onMouseWheel, !1),
          this.mCanvas.addEventListener('contextmenu', this.onContextMenu, !1),
          window.addEventListener('pointerup', this.onPointerUp, !1),
          window.addEventListener('pointercancel', this.onPointerCancel, !1),
          window.addEventListener('scroll', this.onScroll, !0),
          !0)
        );
      }),
      (T.prototype.dispose = function () {
        null != this.mScene &&
          (window.removeEventListener('resize', this.onResize),
          this.mCanvas.removeEventListener(
            'pointerdown',
            this.onPointerDown,
            !1
          ),
          this.mCanvas.removeEventListener('pointerup', this.onPointerUp, !1),
          this.mCanvas.removeEventListener(
            'pointermove',
            this.onPointerMove,
            !1
          ),
          this.mCanvas.removeEventListener(
            'pointercancel',
            this.onPointerCancel,
            !1
          ),
          this.mCanvas.removeEventListener('keyup', this.onKeyUp, !1),
          this.mCanvas.removeEventListener('wheel', this.onMouseWheel, !1),
          this.mCanvas.removeEventListener(
            'contextmenu',
            this.onContextMenu,
            !1
          ),
          window.removeEventListener('pointerup', this.onPointerUp, !1),
          window.removeEventListener('pointercancel', this.onPointerCancel, !1),
          window.removeEventListener('scroll', this.onScroll, !0));
      }),
      (T.prototype.resetViews = function () {
        for (var e = 0, t = this.mViews; e < t.length; e++)
          t[e].cameraControl.resetCamera(!0, !0);
      }),
      (T.prototype.resize = function () {
        var o = this;
        null == this.mResizeTimeOut &&
          (this.mResizeTimeOut = setTimeout(function () {
            (o.mResizeTimeOut = null), (o.mClientOffset = null);
            var e = o.getContainerWidth(),
              t = o.getContainerHeight();
            if (
              ((o.mCanvas.style.width = e.toString() + 'px'),
              (o.mCanvas.style.height = t.toString() + 'px'),
              o.mWidth != e || o.mHeight != t)
            ) {
              (o.mWidth = e), (o.mHeight = t), o.mApp.engine.resize();
              for (var i = 0, n = o.mViews; i < n.length; i++) {
                var r = n[i];
                r.isVisible && r.resize();
              }
              o.eventResize.trigger(), o.requestRenderFrame();
            }
          }, 100));
      }),
      (T.prototype.requestRenderFrame = function () {
        (this.mMSAADelayFrame = 0), (this.mRenderFrameRequested = !0);
      }),
      (T.prototype.forceRenderFrame = function () {
        (this.mMSAADelayFrame = 0), this._renderFrame(!0);
      }),
      (T.prototype.beginDisableRendering = function () {
        this.mDisableRenderingDepth++;
      }),
      (T.prototype.endDisableRendering = function () {
        0 < this.mDisableRenderingDepth && this.mDisableRenderingDepth--;
      }),
      (T.prototype.addView = function (e) {
        return (
          null != e &&
          (e._isOffscreenView()
            ? (S.utils.Log.warn(
                "Offscreen views can't be added to the viewer."
              ),
              !1)
            : (this.mViews.push(e),
              e._setVisible(!0),
              e.resize(),
              1 == this.mViews.length
                ? (this.setHoverView(e), this.setActiveView(e))
                : (e._setHover(!1), e._setActive(!1)),
              this.eventViewAdded.trigger(e),
              this.requestRenderFrame(),
              !0))
        );
      }),
      (T.prototype.removeView = function (e) {
        null != e &&
          (S.utils.array.remove(this.mViews, e),
          e._setVisible(!1),
          e._setActive(!1),
          this.eventViewRemoved.trigger(e),
          this.requestRenderFrame());
      }),
      (T.prototype.getViewAtPosition = function (e) {
        for (
          var t = this.mHeight - e.y, i = null, n = 0, r = this.mViews;
          n < r.length;
          n++
        ) {
          var o,
            s,
            a,
            l,
            u = r[n];
          u.isVisible &&
            ((o = u.camera.viewport.x * this.mWidth),
            (s = u.camera.viewport.y * this.mHeight),
            (a = u.camera.viewport.width * this.mWidth),
            (l = u.camera.viewport.height * this.mHeight),
            e.x >= o && e.x < o + a && s <= t && t < s + l && (i = u));
        }
        return i;
      }),
      (T.prototype.clientToViewerCoords = function (e) {
        if (null == e) throw new Error(S.utils.ERR_INVALID_ARGUMENT);
        var t = BABYLON.Vector2.Zero();
        return this.clientToViewerCoordsToRef(e, t), t;
      }),
      (T.prototype.clientToViewerCoordsToRef = function (e, t) {
        var i;
        null != e &&
          null != t &&
          ((i = this.getClientOffset()), (t.x = e.x - i.x), (t.y = e.y - i.y));
      }),
      (T.prototype.viewerToClientCoords = function (e) {
        if (null == e) throw new Error(S.utils.ERR_INVALID_ARGUMENT);
        var t = BABYLON.Vector2.Zero();
        return this.viewerToClientCoordsToRef(e, t), t;
      }),
      (T.prototype.viewerToClientCoordsToRef = function (e, t) {
        var i;
        null != e &&
          null != t &&
          ((i = this.getClientOffset()), (t.x = e.x + i.x), (t.y = e.y + i.y));
      }),
      (T.prototype.createScreenshot = function (i, n, r) {
        return __awaiter(this, void 0, void 0, function () {
          var t;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                if (null == i || null == n)
                  throw S.utils.newError(S.utils.ERR_INVALID_ARGUMENT);
                return [4, this.mScreenshotLock.acquireLock()];
              case 1:
                (t = e.sent()), (e.label = 2);
              case 2:
                return (
                  e.trys.push([2, , 4, 5]),
                  [4, this.internalCreateScreenshot(i, n, r)]
                );
              case 3:
                return [2, e.sent()];
              case 4:
                return t.unlock(), [7];
              case 5:
                return [2];
            }
          });
        });
      }),
      (T.prototype.serialize = function () {
        var e = {};
        e.views = new Array();
        for (var t = 0, i = this.mViews; t < i.length; t++) {
          var n = i[t].serialize();
          null != n && e.views.push(n);
        }
        return e;
      }),
      (T.prototype.deserialize = function (e) {
        if (null != e)
          for (var t = 0; t < e.views.length; ++t) {
            var i = this.mViews[t];
            null != i && i.deserialize(e.views[t]);
          }
        return !0;
      }),
      (T.prototype._notifyViewMaximized = function (e) {
        this.setActiveView(e);
      }),
      (T.prototype._renderFrame = function (e) {
        if (
          (this.renderingEnabled || e) &&
          !this.mScreenshotLock.isLocked &&
          0 !== this.mViews.length
        ) {
          for (var t = !1, i = 0, n = this.mViews; i < n.length; i++)
            if ((l = n[i]).isVisible && l.cameraControl._beforeRender()) {
              t = !0;
              break;
            }
          var r =
            !this.onDemandRenderingEnabled ||
            this.mRenderFrameRequested ||
            t ||
            e;
          r && ((this.mNextMSAAStep = -1), this.eventBeforeRender.trigger()),
            this.mMSAADelayFrame++;
          var o =
            this.mMSAADelayFrame > T.MSAA_DELAY_FRAMES &&
            this.mNextMSAAStep <= this.mMSAAQuality;
          if (r || o) {
            for (var s = 0, a = this.mViews; s < a.length; s++)
              (l = a[s]).isVisible && l._prepareRenderFrame(this.mNextMSAAStep);
            this.mScene.render();
            for (var l, u = 0, h = this.mViews; u < h.length; u++)
              (l = h[u]).isVisible && l._finalizeRenderFrame();
            this.mNextMSAAStep++,
              (this.mRenderFrameRequested = !1),
              r && this.eventAfterRender.trigger();
          }
        }
      }),
      (T.prototype._forwardEvent = function (e, t) {
        if (null != e) {
          var i = !1;
          switch (e.type) {
            case 'pointerdown':
              t ? (i = !0) : this.onPointerDown(e);
              break;
            case 'wheel':
              t ? (i = !0) : this.onMouseWheel(e);
              break;
            case 'click':
              i = !0;
          }
          i &&
            (this.mInputState._updatePointerPosition(e),
            this.updateActiveView(
              new BABYLON.Vector2(e.clientX, e.clientY),
              !1
            ));
        }
      }),
      (T.prototype.getClientOffset = function () {
        var e;
        return (
          null == this.mClientOffset &&
            ((e = this.mCanvas.getBoundingClientRect()),
            (this.mClientOffset = new BABYLON.Vector2(e.left, e.top))),
          this.mClientOffset
        );
      }),
      (T.prototype.getContainerWidth = function () {
        return this.mContainer.clientWidth >= T.MIN_CANVAS_SIZE
          ? this.mContainer.clientWidth
          : T.MIN_CANVAS_SIZE;
      }),
      (T.prototype.getContainerHeight = function () {
        return this.mContainer.clientHeight >= T.MIN_CANVAS_SIZE
          ? this.mContainer.clientHeight
          : T.MIN_CANVAS_SIZE;
      }),
      (T.prototype.updateActiveView = function (e, t) {
        var i = this.mInputState.pointers.size;
        if ((t && 0 < i) || (!t && 1 < i)) return !1;
        var n = this.clientToViewerCoords(e),
          r = this.getViewAtPosition(n),
          o = this.setHoverView(r);
        return this.setActiveView(r), o;
      }),
      (T.prototype.setActiveView = function (e) {
        null != e &&
          e != this.mActiveView &&
          (null != this.mActiveView && this.mActiveView._setActive(!1),
          (this.mActiveView = e),
          this.mActiveView._setActive(!0),
          this.eventActiveViewChanged.trigger());
      }),
      (T.prototype.updateHoverView = function (e, t) {
        var i;
        o.PointerInfo.IsMousePointer(e) &&
          ((i = this.clientToViewerCoords(t.pointerPosition)),
          this.setHoverView(this.getViewAtPosition(i)));
      }),
      (T.prototype.setHoverView = function (e) {
        return (
          null != e &&
          e != this.mHoverView &&
          (null != this.mHoverView && this.mHoverView._setHover(!1),
          (this.mHoverView = e),
          this.mHoverView._setHover(!0),
          (this.mScene.cameraToUseForPointers = this.mHoverView.camera),
          this.eventHoverViewChanged.trigger(),
          !0)
        );
      }),
      (T.prototype.createPointerFeedback = function (e) {
        var t,
          i,
          n,
          r = this;
        this.showPointerFeedback &&
          (null == e ||
            o.PointerInfo.IsMousePointer(e) ||
            (null != (t = this.mInputState.pointers.get(e.pointerId)) &&
              ((i = this.clientToViewerCoords(t.position)),
              ((n = document.createElement('div')).className =
                'wcf-core pointer-feedback'),
              (n.style.left = i.x.toString() + 'px'),
              (n.style.top = i.y.toString() + 'px'),
              this.mContainer.appendChild(n),
              setTimeout(function () {
                r.mContainer.removeChild(n);
              }, 1e3))));
      }),
      (T.prototype.internalCreateScreenshot = function (C, P, b) {
        return __awaiter(this, void 0, void 0, function () {
          var t,
            i,
            n,
            r,
            o,
            s,
            a,
            l,
            u,
            h,
            m,
            c,
            p,
            d,
            f,
            g,
            v,
            y,
            A,
            w = this;
          return __generator(this, function (e) {
            switch (e.label) {
              case 0:
                (t = this.mScene.activeCamera),
                  (i = C.camera.viewport),
                  (n = C.camera.layerMask),
                  (r = this.mScene.clearColor),
                  (o = C._getSizeOverride()),
                  (s = C.pixelScaleFactor),
                  (l = a = null),
                  (e.label = 1);
              case 1:
                for (
                  e.trys.push([1, , 3, 4]),
                    u = Math.round(P.width),
                    h = Math.round(P.height),
                    C._setSizeOverride(new BABYLON.Vector2(u, h), !1),
                    null != P.onBeforeRender &&
                      (P.onBeforeRender(),
                      (m = Math.round(P.width)),
                      (c = Math.round(P.height)),
                      (m == u && c == h) ||
                        ((u = m),
                        (h = c),
                        C._setSizeOverride(new BABYLON.Vector2(u, h), !1))),
                    this.mScene.activeCamera = C.camera,
                    C.pixelScaleFactor =
                      null != P.pixelScaleFactor ? P.pixelScaleFactor : 1,
                    C.camera.layerMask = 4,
                    C.camera.viewport = new BABYLON.Viewport(0, 0, 1, 1),
                    C.camera.notifyProjectionChanged(),
                    null != P.backgroundColor &&
                      (this.mScene.clearColor = P.backgroundColor),
                    p = 0,
                    d = null != P.renderAsync && P.renderAsync,
                    f =
                      null != P.antiAliasingQuality
                        ? P.antiAliasingQuality
                        : T.MSAA_MAX_QUALITY,
                    f = S.utils.math.clamp(f, 0, T.MSAA_MAX_QUALITY),
                    l = new BABYLON.RenderTargetTexture(
                      '',
                      { width: u, height: h },
                      this.mScene,
                      !1,
                      !1
                    ),
                    g =
                      null == P.meshesToRender
                        ? this.mScene.meshes
                        : P.meshesToRender,
                    v = 0,
                    y = g;
                  v < y.length;
                  v++
                )
                  0 != ((A = y[v]).layerMask & C.camera.layerMask) &&
                    l.renderList.push(A);
                return [
                  4,
                  new Promise(function (t, i) {
                    l.onAfterRenderObservable.add(function () {
                      p === f &&
                        w
                          .dumpFramebuffer(u, h, P, b)
                          .then(function (e) {
                            return t(e);
                          })
                          .catch(function (e) {
                            return i(e);
                          });
                    });
                    var e = function () {
                      C._prepareRenderFrame(p),
                        w.mScene.onBeforeCameraRenderObservable.notifyObservers(
                          C.camera
                        ),
                        l.render(!0),
                        w.mScene.onAfterCameraRenderObservable.notifyObservers(
                          C.camera
                        ),
                        C._finalizeRenderFrame(),
                        ++p <= f && (d ? setTimeout(e) : e());
                    };
                    w.mScene.incrementRenderId(), e();
                  }),
                ];
              case 2:
                return (
                  (a = e.sent()),
                  this.mScene.incrementRenderId(),
                  this.mScene.resetCachedMaterial(),
                  [2, a]
                );
              case 3:
                return (
                  null != l && l.dispose(),
                  (this.mScene.clearColor = r),
                  (this.mScene.activeCamera = t),
                  (C.pixelScaleFactor = s),
                  (C.camera.layerMask = n),
                  (C.camera.viewport = i),
                  C.camera.notifyProjectionChanged(),
                  null != P.onAfterRender && P.onAfterRender(),
                  C._setSizeOverride(o, !1),
                  C.isVisible &&
                    this.mNextMSAAStep <= this.mMSAAQuality &&
                    (this.mNextMSAAStep = 0),
                  [7]
                );
              case 4:
                return [2];
            }
          });
        });
      }),
      (T.prototype.dumpFramebuffer = function (e, t, i, n) {
        void 0 === n && (n = !1);
        for (
          var r = null != i.mimeType ? i.mimeType : 'image/png',
            o = 4 * e,
            s = t / 2,
            a = this.mApp.engine.readPixels(0, 0, e, t),
            l = 0;
          l < s;
          l++
        )
          for (var u = 0; u < o; u++) {
            var h = u + l * o,
              m = u + (t - l - 1) * o,
              c = a[h];
            (a[h] = a[m]), (a[m] = c);
          }
        var p = i.targetCanvas;
        null == p &&
          (null == this.mDumpFrameBufferCanvas &&
            (this.mDumpFrameBufferCanvas = document.createElement('canvas')),
          (p = this.mDumpFrameBufferCanvas)),
          (p.width = e),
          (p.height = t);
        var d = p.getContext('2d');
        if (null == d)
          return Promise.reject(new Error('Failed to get canvas 2d context'));
        var f = !1;
        if (
          (null != i.onDrawBackground &&
            this.mScene.clearColor.a < 0.99 &&
            ((f = !0), i.onDrawBackground(d)),
          this.drawDataOn2DContext(e, t, a, d, f),
          null != i.onDrawOverlay && i.onDrawOverlay(d),
          null != i.targetCanvas)
        )
          return Promise.resolve('');
        if (n) return S.utils.image.canvasToBlob(p, r);
        var g = p.toDataURL(r);
        return Promise.resolve(g);
      }),
      (T.prototype.drawDataOn2DContext = function (e, t, i, n, r) {
        var o;
        if (r)
          for (
            var s = (o = n.getImageData(0, 0, e, t)).width * o.height * 4,
              a = 0;
            a < s;
            a += 4
          ) {
            var l = (u = i[a + 3] / 255) + (o.data[a + 3] / 255) * (1 - u);
            (o.data[a] = i[a] + (1 - u) * o.data[a]),
              (o.data[a + 1] = i[a + 1] + (1 - u) * o.data[a + 1]),
              (o.data[a + 2] = i[a + 2] + (1 - u) * o.data[a + 2]),
              (o.data[a + 3] = 255 * l),
              0 < l &&
                ((o.data[a + 0] /= l),
                (o.data[a + 1] /= l),
                (o.data[a + 2] /= l));
          }
        else if (this.mScene.clearColor.a < 0.99)
          for (
            var u,
              s = (o = n.getImageData(0, 0, e, t)).width * o.height * 4,
              a = 0;
            a < s;
            a += 4
          )
            (o.data[a + 0] = i[a + 0]),
              (o.data[a + 1] = i[a + 1]),
              (o.data[a + 2] = i[a + 2]),
              (o.data[a + 3] = i[a + 3]),
              0 < (u = i[a + 3] / 255) &&
                ((o.data[a + 0] /= u),
                (o.data[a + 1] /= u),
                (o.data[a + 2] /= u));
        else (o = n.createImageData(e, t)).data.set(i);
        n.putImageData(o, 0, 0);
      }),
      (T.MAX_DOUBLE_CLICK_DELAY = 300),
      (T.POINTER_MOVE_TOLERANCE =
        null != window.devicePixelRatio && 1 < window.devicePixelRatio
          ? 3 * window.devicePixelRatio
          : 3),
      (T.MSAA_DELAY_FRAMES = 20),
      (T.MSAA_MAX_QUALITY = 32),
      (T.MIN_CANVAS_SIZE = 4),
      (i = T),
      (o.Viewer = i);
  })((egr = egr || {}));
